/* English locale — the single source of user-facing copy for V1. Add more locales alongside. */
export const en = {
  // Brand
  "brand.flow": "Listed",
  "brand.by_digihome": "by DigiHome",
  "brand.by": "by",

  // Admin — command palette, stepper, pipeline v2, outbox v2
  "cmd.placeholder": "Search properties, owners, pages…",
  "cmd.hint": "Search",
  "cmd.empty": "Nothing found. Try an owner name or address.",
  "cmd.group.leads": "Properties",
  "cmd.group.pages": "Go to",
  "cmd.group.actions": "Actions",
  "cmd.group.settings": "Settings",
  "cmd.action.add_lead": "Add a property manually",
  "cmd.action.copy_start": "Copy owner start page link",
  "cmd.action.open_start": "Open owner start page",
  "cmd.action.install": "Install the widget on your website",
  "cmd.kbd_open": "⌘K",
  "cmd.kbd_nav": "↑↓ to navigate · ↵ to open · esc to close",
  "stepper.title": "Journey",
  "stepper.move_here": "Move to {stage}",
  "stepper.current": "Current stage",
  "stepper.closed": "Closed",
  "stepper.step_of": "Stage {n} of {total}",
  "pipeline.drag_hint": "Drag a property to another column to move it",
  "pipeline.drop_here": "Drop here",
  "pipeline.empty_new": "New leads land here",
  "pipeline.empty_new_cta": "Share your start page",
  "pipeline.empty_col": "No properties in this stage",
  "pipeline.stale": "{d}d in stage",
  "pipeline.waiting_owner": "Waiting on owner",
  "pipeline.waiting_you": "Waiting on you",
  "pipeline.more": "More",
  "pipeline.open": "Open property",
  "pipeline.mobile_hint": "Swipe between stages",
  "pipeline.summary": "{active} active · {closed} closed",
  "outbox.select": "Select an email to preview it",
  "outbox.preview": "Preview",
  "outbox.back": "All emails",
  "outbox.details": "Details",
  "outbox.sent_at": "Queued",
  "outbox.open_lead": "Open property",
  "outbox.count": "{n} emails",
  "outbox.search": "Search subject or recipient",
  "lead.more_actions": "More",
  "lead.links": "Owner links",
  "settings.nav_hint": "Everything the owner sees — and how your team works.",
  "settings.group_team": "Team & workflow",
  "brand.powered_by": "Powered by DigiHome",

  // Common
  "common.back": "Back",
  "common.next": "Next",
  "common.continue": "Continue",
  "common.save": "Save",
  "common.saved": "Saved",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.add": "Add",
  "common.remove": "Remove",
  "common.import": "Import",
  "common.confirm": "Confirm",
  "common.close": "Close",
  "common.done": "Done",
  "common.skip": "Skip for now",
  "common.loading": "Loading…",
  "common.search": "Search",
  "common.yes": "Yes",
  "common.no": "No",
  "common.optional": "Optional",
  "common.required": "Required",
  "common.copy": "Copy",
  "common.copied": "Copied to clipboard",
  "common.open": "Open",
  "common.view": "View",
  "common.retry": "Try again",
  "common.not_found": "Not found",
  "common.error": "Something went wrong",
  "common.none": "None",
  "common.unknown": "Unknown",
  "common.other": "Other",
  "common.all": "All",
  "common.per_year": "per year",
  "common.estimate": "Estimate",
  "common.version": "Version {n}",
  "common.select": "Select…",
  "common.generate": "Generate",
  "common.regenerate": "Regenerate",
  "common.send": "Send",
  "common.sending": "Sending…",
  "common.saving": "Saving…",
  "common.name": "Name",
  "common.email": "Email",
  "common.phone": "Phone",
  "common.password": "Password",
  "common.role": "Role",
  "common.status": "Status",
  "common.actions": "Actions",
  "common.description": "Description",
  "common.title": "Title",
  "common.label": "Label",
  "common.type": "Type",
  "common.amount": "Amount",
  "common.currency": "Currency",
  "common.category": "Category",
  "common.preview": "Preview",
  "common.details": "Details",
  "common.today": "Today",
  "common.reset": "Reset to default",
  "common.log_out": "Log out",
  "profile.menu": "Profile",
  "profile.title": "Your profile",
  "profile.sub": "Who recipients see. Your photo, name and title become the sender card at the foot of every Growth e-mail.",
  "profile.name_required": "Enter your name.",
  "profile.photo_saved": "Photo updated",
  "profile.photo_removed": "Photo removed",
  "profile.photo_upload": "Upload photo",
  "profile.photo_change": "Change photo",
  "profile.photo_set": "Photo in use",
  "profile.photo_none": "No photo yet — your initials are shown instead",
  "profile.photo_help": "A well-lit photo with your face centred works best. JPEG, PNG or WebP up to 8 MB — it is cropped square and resized here.",
  "profile.name": "Full name",
  "profile.job_title": "Title",
  "profile.job_title_help": "Shown under your name, e.g. Founder. The company comes from Growth → Settings.",
  "profile.job_title_ph": "Founder",
  "profile.phone": "Phone",
  "profile.linkedin": "LinkedIn",
  "profile.signin_email": "Signed in as {email}. Your sign-in e-mail is not shown to recipients — e-mails go out from the connected mailbox.",
  "common.min": "Min",
  "common.max": "Max",
  "common.date": "Date",
  "common.from": "From",
  "common.to": "To",
  "common.by": "by {name}",

  // Time
  "time.today": "Today",
  "time.yesterday": "Yesterday",
  "time.just_now": "just now",
  "time.minutes_ago": "{n} min ago",
  "time.hours_ago": "{n} h ago",
  "time.days_ago": "{n} d ago",

  // Pricing
  "price.of_revenue": "of booking revenue",
  "price.per_stay": "/ stay",
  "price.per_guest": "/ guest",
  "price.per_night": "/ night",
  "price.monthly": "/ month",
  "price.one_time": "one-time",
  "pricing.percentage": "Percentage of revenue",
  "pricing.per_stay": "Per stay",
  "pricing.per_guest": "Per guest",
  "pricing.per_night": "Per night",
  "pricing.one_time": "One-time",
  "pricing.monthly": "Monthly",

  // Behaviors / chips
  "chip.required": "Required",
  "chip.included": "Included",
  "chip.optional": "Optional",
  "chip.internal": "Internal",
  "chip.recommended": "Recommended",
  "chip.add": "Add",
  "chip.added": "Added",
  "behavior.required.help": "Always part of the agreement.",
  "behavior.included.help": "Included at no separate cost.",
  "behavior.optional.help": "Owner can choose it in the offer.",
  "behavior.internal.help": "Used in calculations, never shown to the owner.",

  // Stages
  "stage.new": "New",
  "stage.qualified": "Qualified",
  "stage.offer": "Offer",
  "stage.signed": "Signed",
  "stage.onboarding": "Onboarding",
  "stage.ready": "Ready",
  "stage.live": "Live",
  "stage.lost": "Lost",
  "stage.archived": "Archived",

  // Property types etc
  "ptype.apartment": "Apartment",
  "ptype.house": "House",
  "ptype.cabin": "Cabin",
  "ptype.other": "Other",
  "plan.all_year": "All year",
  "plan.part_of_year": "Part of the year",
  "plan.when_not_using": "When I'm not using it",
  "plan.unknown": "Not sure yet",
  "start.asap": "As soon as possible",
  "start.date": "Pick a date",
  "start.exploring": "Just exploring",
  "rented.none": "Not rented today",
  "rented.airbnb": "Airbnb",
  "rented.booking": "Booking.com",
  "rented.other": "Other platform",

  // Offer statuses
  "offer.status.draft": "Draft",
  "offer.status.sent": "Sent — awaiting response",
  "offer.status.opened": "Opened by owner",
  "offer.status.accepted": "Accepted",
  "offer.status.declined": "Declined",
  "offer.status.superseded": "Superseded",
  "offer.status.expired": "Expired",
  "offer.sent_at": "Sent",

  // Home / marketing
  "home.eyebrow": "Listed by DigiHome",
  "home.title": "From first click to live listing.",
  "home.sub": "Listed is the acquisition and launch infrastructure for modern property managers. One journey from a prospective owner's address to a signed, onboarded property — ready in your PMS.",
  "home.cta_admin": "Open Listed Admin",
  "home.cta_demo": "Try the owner journey",
  "home.steps": "Lead · Property · Proposal · Sign · Onboarding · PMS · Live",
  "home.pillar1.title": "Capture",
  "home.pillar1.text": "A single embeddable field on the property manager's website. Address or Airbnb link in — qualified lead out.",
  "home.pillar2.title": "Offers",
  "home.pillar2.text": "A structured offer builder with a live owner preview. No PDFs — a beautiful, interactive web page with options and e-signature.",
  "home.pillar3.title": "Onboarding",
  "home.pillar3.text": "A mobile journey the owner completes while walking through the property. AI reads photos and free text so nobody types twice.",
  "home.pillar4.title": "Connect",
  "home.pillar4.text": "One canonical property schema mapped to Guesty, Lodgify, Hostaway or DigiHome through adapters. Listed stays independent of your PMS.",
  "home.demo_note": "Demo tenant: Northstay · sarah@northstay.com / flow1234",

  // Widget / start
  "widget.default_headline": "What could your property earn?",
  "widget.default_sub": "Enter your address or paste your Airbnb / Booking.com link.",
  "widget.default_cta": "Get a free estimate",
  "widget.placeholder": "Search address or paste listing link…",
  "widget.searching": "Searching…",
  "widget.no_results": "No matches — keep typing or continue with what you wrote.",
  "widget.use_as_typed": "Use “{q}” as the address",
  "widget.listing_detected": "{platform} listing detected",
  "widget.address_found": "Address found",
  "start.how.eyebrow": "How it works",
  "start.how.tell.title": "Tell us about the property",
  "start.how.tell.text": "Address or listing link — two minutes on your phone.",
  "start.how.proposal.title": "Get a tailored proposal",
  "start.how.proposal.text": "Estimated revenue, services and a clear fee.",
  "start.how.sign.title": "Accept and sign online",
  "start.how.sign.text": "No PDFs, no printing.",
  "start.how.ready.title": "We get it ready",
  "start.how.ready.text": "A guided onboarding while you walk through the home.",

  // Intake journey
  "intake.progress": "Step {n} of {total}",
  "intake.found_title": "We found your property",
  "intake.found_listing_title": "We found your listing",
  "intake.found_sub": "Correct anything that's wrong — we only ask what we don't already know.",
  "intake.is_correct": "Looks right",
  "intake.imported_from": "Imported from {platform}",
  "intake.listing_fallback": "We recognised a {platform} link but couldn't read the details automatically. Tell us a little about the property instead.",
  "intake.property_type.q": "What kind of property is it?",
  "intake.bedrooms.q": "How many bedrooms?",
  "intake.guests.q": "How many guests can it normally host?",
  "intake.bathrooms.q": "How many bathrooms?",
  "intake.plan.q": "How do you want to use the property?",
  "intake.start.q": "When would you like to start?",
  "intake.rented.q": "Is the property rented out today?",
  "intake.photos.q": "Show us your place",
  "intake.photos.sub": "Add a few photos, or pull them straight from your Airbnb, Booking.com or Vrbo listing. Optional — but it sharpens the estimate.",
  "intake.photos.sub_listing": "We can pull the photos straight from your listing — pick the ones to include, or add your own.",
  "intake.photos.upload": "Upload photos",
  "intake.photos.later": "Do this later",

  /* ---- Photo studio (owner photo step: tray, drop zone, listing import) ---- */
  "photos.drop.title": "Add photos of the property",
  "photos.drop.more": "Add more photos",
  "photos.drop.sub": "Drag and drop, or choose from your device. Daylight, tidy rooms and landscape shots work best.",
  "photos.choose": "Choose photos",
  "photos.uploading_n": "Uploading {a} of {b}…",
  "photos.tray.one": "1 photo added",
  "photos.tray.n": "{n} photos added",
  "photos.tray.cover": "Cover",
  "photos.tray.cover_hint": "The first photo becomes the cover",
  "photos.tray.make_cover": "Use as cover",
  "photos.import.title": "Already listed somewhere?",
  "photos.import.sub": "Paste your Airbnb, Booking.com or Vrbo link — we pull the photos in for you.",
  "photos.import.placeholder": "https://www.airbnb.com/rooms/…",
  "photos.import.fetch": "Fetch photos",
  "photos.import.reading": "Reading your {platform} listing…",
  "photos.import.invalid": "That doesn't look like a listing link. Paste the full address, starting with https://",
  "photos.import.generic_platform": "listing",
  "photos.import.found": "We found {n} photos on {platform}",
  "photos.import.select_all": "Select all",
  "photos.import.clear": "Clear",
  "photos.import.photo_n": "Photo {n}",
  "photos.import.picked": "{n} of {total} selected",
  "photos.import.max": "Up to {n} photos at a time — add more afterwards if you like.",
  "photos.import.add_one": "Add 1 photo",
  "photos.import.add_n": "Add {n} photos",
  "photos.import.adding": "Adding {n} photos…",
  "photos.import.blocked_title": "{platform} doesn't let us fetch photos automatically",
  "photos.import.blocked_sub": "No problem — we've saved your link so {org} can collect the photos from there. If you have a few on your phone, add them now.",
  "photos.import.your_manager": "your manager",
  "photos.import.upload_instead": "Upload instead",
  "photos.import.none_title": "We couldn't find any photos on that {platform} page",
  "photos.import.none_sub": "Check that the link opens your listing, or upload a few photos instead.",
  "photos.import.done_one": "1 photo added from {platform}",
  "photos.import.done_n": "{n} photos added from {platform}",
  "photos.import.skipped": "{n} couldn't be downloaded and were skipped.",
  "photos.import.pick_more": "Pick more from this listing",
  "photos.import.note": "We only read the public listing page — nothing is changed on your account, and you choose exactly which photos to include.",
  "intake.contact.q": "Where should we send the assessment?",
  "intake.contact.sub": "We'll reply personally within 24 hours.",
  "intake.contact.name": "Your name",
  "intake.contact.email": "Email",
  "intake.contact.phone": "Phone",
  "intake.contact.note": "Anything else we should know? (optional)",
  "intake.submit": "Send my request",
  "intake.done.title": "Thanks, {name}!",
  "intake.done.sub": "{org} has received the details for {property} and will get back to you with a tailored proposal shortly.",
  "intake.done.check_email": "We've sent a confirmation to {email}.",
  "intake.done.another": "Submit another property",
  "intake.error.name_email": "Please enter your name and a valid email.",
  "intake.count.bedrooms": "{n} bedroom(s)",
  "intake.summary.bedrooms": "{n} bedrooms",
  "intake.summary.guests": "{n} guests",
  "intake.summary.baths": "{n} baths",
  "intake.summary.title": "Your property so far",
  "intake.summary.empty": "Your answers appear here as you go.",
  "intake.summary.type": "Type",
  "intake.summary.rooms": "Rooms",
  "intake.summary.plan": "Rental plan",
  "intake.summary.start": "Start",
  "intake.summary.rented": "Rented today",
  "intake.summary.photos": "Photos",
  "intake.summary.photos_n": "{n} added",
  "intake.summary.private": "Only {org} sees your answers. Nothing is shared with third parties.",
  "intake.group.found": "Your property",
  "intake.group.property": "About the property",
  "intake.group.plans": "Your plans",
  "intake.group.photos": "Photos",
  "intake.group.contact": "Contact details",
  "start.paste_from": "Or paste a listing link from",
  "start.trust.free": "Free & non-binding",
  "start.trust.time": "About 2 minutes",
  "start.trust.web": "No PDFs, no printing",
  "start.mobile_how": "How it works",
  "start.footer.privacy": "Your details are only used to prepare your proposal.",

  // Owner offer
  "owner_offer.eyebrow": "Your proposal",
  "owner_offer.title": "We think {property} can become a very good rental property.",
  "owner_offer.estimate": "Estimated annual revenue",
  "owner_offer.estimate_note": "Estimate based on comparable properties and market data — not a guarantee.",
  "owner_offer.estimate_source": "Source: {source}",
  "intake.estimate.eyebrow": "Indicative estimate",
  "intake.estimate.title": "What a property like yours could earn",
  "intake.estimate.sub": "Based on {n} bedrooms in {area}. Indicative only — your tailored proposal will be more precise.",
  "intake.estimate.sub_short": "Indicative only — your tailored proposal will be more precise.",
  "intake.estimate.per_year": "per year, before fees",
  "intake.estimate.loading": "Looking at comparable properties…",
  "intake.estimate.cta_note": "Leave your details and we'll refine this with real market data.",
  "intake.group.estimate": "Estimate",
  "owner_offer.no_estimate": "Revenue estimate will be shared after our first conversation.",
  "owner_offer.your_proposal": "Your proposal",
  "owner_offer.includes": "Includes",
  "owner_offer.addons": "Services",
  "owner_offer.addons_sub": "Add or remove optional services — the summary updates live.",
  "owner_offer.summary": "Summary",
  "owner_offer.management_fee": "Management fee",
  "owner_offer.one_time": "One-time costs",
  "owner_offer.variable": "Per-stay / per-guest costs",
  "owner_offer.variable_note": "Normally covered by guest fees.",
  "owner_offer.est_fee": "Estimated management fee (year 1)",
  "owner_offer.est_net": "Estimated net to you (year 1)",
  "owner_offer.terms": "Good to know",
  "owner_offer.accept": "Accept and continue",
  "owner_offer.decline": "Not for me",
  "owner_offer.accepted_title": "Offer accepted",
  "owner_offer.accepted_sub": "Next step: review and sign the agreement.",
  "owner_offer.go_sign": "Review & sign agreement",
  "owner_offer.declined_title": "Thanks for letting us know",
  "owner_offer.declined_sub": "We've informed {org}. You're welcome to reach out any time.",
  "owner_offer.decline_reason": "Anything we could have done differently? (optional)",
  "owner_offer.invalid": "This offer link isn't valid or has expired.",
  "owner_offer.prepared_for": "Prepared for {name}",
  "owner_offer.version": "Offer version {n}",
  "owner_offer.total_label": "Management fee",
  "owner_offer.superseded": "A newer version of this offer has been sent to you.",
  "owner_offer.included_title": "Included in your plan",
  "owner_offer.optional_title": "Optional extras",
  "owner_offer.optional_sub": "Tap to add or remove — the summary updates live.",
  "owner_offer.next_title": "What happens next",
  "owner_offer.next.accept": "You accept this proposal",
  "owner_offer.next.sign": "Sign the agreement online — under a minute",
  "owner_offer.next.onboard": "A guided onboarding while you walk through the property",
  "owner_offer.next.live": "{org} makes the property ready and takes it live",
  "owner_offer.valid_until": "Valid until {date}",
  "owner_offer.questions": "Questions? Just reply to the email from {org}.",
  "owner_offer.decline_title": "Not the right fit?",
  "owner_offer.decline_sub": "Let {org} know — no hard feelings.",
  "owner_offer.one_time_short": "one-time",
  "owner_offer.year1": "year 1",
  "owner_offer.hero_kicker": "A proposal from {org}",
  "owner_offer.prepared_by": "Prepared by",
  "owner_offer.property_facts": "{type} · {beds} bed · up to {guests} guests",
  "owner_offer.potential_title": "Your earning potential",
  "owner_offer.potential_sub": "What comparable homes in your area earn per year when professionally managed.",
  "owner_offer.you_keep": "You keep",
  "owner_offer.fee_share": "Management fee",
  "owner_offer.range_low": "Conservative",
  "owner_offer.range_high": "Strong season",
  "owner_offer.plan_label": "Your plan",
  "owner_offer.live_summary": "Updates as you choose",
  "owner_offer.selected_extras": "{n} extras selected",
  "owner_offer.selected_extra_one": "1 extra selected",
  "owner_offer.no_extras": "No extras selected",
  "owner_offer.trust_sign": "Sign digitally on your phone",
  "owner_offer.trust_private": "This link was prepared only for you",
  "owner_offer.trust_edit": "Change extras any time before you accept",
  "owner_offer.review": "Review proposal",
  "owner_offer.jump_extras": "Extras",
  "owner_offer.jump_summary": "Summary",
  "owner_offer.doc_label": "Proposal",
  "owner_offer.cost_title": "What it costs",
  "owner_offer.own_title": "Try your own number — if the home earns",
  "owner_offer.own_note": "Your assumption, not an estimate from us. Drag to see how the split changes.",
  "owner_offer.your_property": "your property",
  "owner_offer.est_fee_short": "Our fee, year 1",
  "owner_offer.sent_on": "Sent {date}",
  "owner_offer.reply_to": "Reply to {email}",
  "owner_offer.existing_one": "You already have one home with {org} ({names}). Thank you for trusting us with another.",
  "owner_offer.existing_many": "You already have {n} homes with {org} ({names}). Thank you for trusting us with another.",
  "owner_offer.meta_bedroom_one": "1 bedroom",
  "owner_offer.meta_bedrooms": "{n} bedrooms",
  "owner_offer.meta_guests": "up to {n} guests",
  "owner_offer.net_title": "Estimated net to you, year 1",
  "owner_offer.net_sub": "What is left for you after our fee and one-time costs, based on {revenue} in booking revenue. Switch scenario to see how the season changes it.",
  "owner_offer.scenario_label": "Revenue scenario",
  "owner_offer.scenario.low": "Conservative",
  "owner_offer.scenario.mid": "Expected",
  "owner_offer.scenario.high": "Strong",
  "owner_offer.revenue_row": "Estimated booking revenue",
  "owner_offer.monthly": "Monthly costs",
  "owner_offer.no_estimate_sub": "This proposal doesn't include a revenue estimate — the fee and fixed costs below are what you'd pay. Revenue depends on the season and how often the home is available.",
  "owner_offer.plan_title": "The plan",
  "owner_offer.no_plan_items": "No management fee has been set for this proposal.",
  "owner_offer.extras_sub": "Switch on what you'd like — the figures update as you choose.",
  "owner_offer.extras_row": "Extras",
  "owner_offer.valid_row": "Valid until",
  "owner_offer.what_changed": "What changed since version {n}",
  "owner_offer.change.item_added": "{name} added ({price})",
  "owner_offer.change.item_removed": "{name} removed",
  "owner_offer.change.item_amount": "{name}: {from} → {to}",
  "owner_offer.change.estimate": "Revenue estimate: {from} → {to}",
  "owner_offer.change.valid_until": "Now valid until {date}",
  "owner_offer.change.intro": "The introduction was updated",
  "owner_offer.change.terms": "The terms were updated",
  "owner_offer.change.highlights": "The highlights were updated",
  "owner_offer.questions_email": "Questions? Write to",
  "owner_offer.questions_reads": "{name} reads every message.",
  "owner_offer.sticky_line": "Year 1 net · {pct} fee",
  "owner_offer.fee_short": "Our fee",
  "owner_offer.preview_badge": "Preview",
  "owner_offer.status_accepted": "Accepted",
  "owner_offer.expired_chip": "Expired",
  "owner_offer.superseded_chip": "Newer version sent",
  "owner_offer.superseded_sub": "Check your inbox for the latest version — this one can no longer be accepted.",
  "owner_offer.expired_title": "This proposal expired on {date}",
  "owner_offer.expired_sub": "Ask {org} for an updated one — it takes a minute and you'll get a fresh link by e-mail.",
  "owner_offer.request_update": "Request an updated proposal",
  "owner_offer.update_requested": "Request sent — {org} will be in touch shortly.",
  "owner_offer.accepted_banner": "You accepted this proposal on {date}",
  "owner_offer.money_title": "How the money works",
  "owner_offer.range_note": "Range {min} – {max}",
  "owner_offer.fee_row": "Our fee · {pct}",
  "owner_offer.net_row": "To you, year 1",
  "owner_offer.portfolio_title": "Homes we already run",
  "owner_offer.portfolio_sub": "{n} homes under management{cities}",
  "owner_offer.portfolio_sub_one": "1 home under management{cities}",
  "owner_offer.portfolio_in": " in {cities}",
  "owner_offer.cover_illustrative": "Illustration photo",
  "builder.cover_manage": "Manage photos",
  "builder.cover_owner": "The owner's photos",
  "builder.cover_brand": "Your photos",
  "builder.cover_default": "Curated pictures",
  "builder.cover_explicit": "You chose this cover for this proposal.",
  "builder.cover_auto": "Chosen automatically: the owner's photo when there is one, else your own cover photos, else a curated picture that suits the property.",
  "builder.cover_no_brand": "Add your own photography under Settings → Branding so every proposal shows the homes you run.",
  "builder.mode_document": "Document",
  "builder.mode_phone": "Phone",
  "branding.covers": "Proposal cover photos",
  "branding.covers_help": "Your own photography — the homes you run, your team, your area. Shown at the top of every proposal until the owner has photos of their own. Up to 6.",
  "branding.covers_add": "Add photo",
  "branding.covers_hint": "JPG, PNG or WebP · landscape works best · under 8 MB.",
  "branding.cover_uploaded": "Photo added.",
  "branding.cover_removed": "Photo removed.",
  "branding.covers_empty": "No photos yet — proposals use a curated picture that suits the property until you add your own.",
  "branding.owner_language": "Owner language",
  "branding.owner_language_help": "The language of the proposals owners receive.",
  "branding.lang_auto": "Automatic — from country",
  "branding.lang_nb": "Norwegian",
  "branding.lang_en": "English",
  "owner_offer.accepted_next": "Next: review and sign the agreement — it takes under a minute on your phone.",
  "owner_offer.invalid_title": "This link doesn't work",
  "owner_offer.contact_us": "Write to {email}",
  "price.per_month": "/ month",


  // Sign
  "sign.eyebrow": "Agreement",
  "sign.title": "Almost there, {name}.",
  "sign.sub": "Review the agreement and sign electronically. Takes under a minute.",
  "sign.selected": "What you've chosen",
  "sign.method.type": "Type",
  "sign.method.draw": "Draw",
  "sign.full_name": "Your full name",
  "sign.type_placeholder": "Enter your full name above to sign",
  "sign.signature": "Your signature",
  "sign.draw_hint": "Sign with your finger or mouse",
  "sign.clear": "Clear",
  "sign.consent": "I have read and agree to the agreement above. I understand this electronic signature is legally binding.",
  "sign.submit": "Sign agreement",
  "sign.signing": "Signing…",
  "sign.legal": "We record the signing time, your IP address and a fingerprint of the document.",
  "sign.signed_title": "Agreement signed",
  "sign.signed_sub": "Welcome to {org}. Now we make {property} ready.",
  "sign.start_onboarding": "Start onboarding",
  "sign.signed_by": "Signed by {name} on {date}",
  "sign.download_signed": "Download signed agreement (PDF)",
  "sign.download_pdf": "Download as PDF",
  "sign.document_label": "The agreement",
  "sign.copy_by_email": "A signed copy has also been sent to your e-mail. This link stays available if you need it again.",
  "sign.invalid": "This agreement link isn't valid.",
  "sign.need_consent": "Please confirm you agree to the agreement.",
  "sign.need_signature": "Please add your signature.",

  // Onboarding (owner)
  "onb.complete": "{pct}% complete",
  "onb.default_title": "Let's get your property ready",
  "onb.sections": "Sections",
  "onb.start": "Start",
  "onb.continue": "Continue",
  "onb.review": "Review",
  "onb.section_done": "Done",
  "onb.all_done_title": "All done!",
  "onb.all_done_sub": "{org} has everything they need from you. They'll finish the internal preparations and let you know when {property} goes live.",
  "onb.remaining_one": "One thing remaining",
  "onb.remaining_n": "{n} things remaining",
  "onb.remaining_sub": "We still need: {items}",
  "onb.finish_section": "Finish section",
  "onb.back_to_sections": "Back to overview",
  "onb.upload.take_photo": "Take photo",
  "onb.upload.choose": "Choose file",
  "onb.upload.record_video": "Record video",
  "onb.upload.uploading": "Uploading…",
  "onb.upload.analyzing": "Reading your photo…",
  "onb.upload.remove": "Remove",
  "onb.ai.detected": "We read this from your photo",
  "onb.ai.structured": "We understood this from your text",
  "onb.ai.apply": "Use this",
  "onb.ai.dismiss": "Ignore",
  "onb.ai.uploaded_ok": "{what} uploaded ✓",
  "onb.ai.mismatch": "This looks like a {what}, not what we expected. You can keep it or retake.",
  "onb.ai.structure_btn": "Let Listed structure this",
  "onb.secure_hint": "Stored encrypted. Shared only with guests during their stay.",
  "onb.periods.add": "Add period",
  "onb.periods.from": "From",
  "onb.periods.to": "To",
  "onb.periods.note": "Note",
  "onb.invalid": "This onboarding link isn't valid.",
  "onb.saved": "Saved",
  "onb.of": "{a} of {b}",
  "onb.required_left": "{n} required left",
  "onb.optional_hint": "Optional",
  "onb.empty_optional": "Nothing required here — add details if you like.",

  // Admin nav
  "nav.dashboard": "Dashboard",
  "nav.pipeline": "Pipeline",
  "nav.outbox": "Outbox",
  "nav.settings": "Settings",
  "nav.start_page": "Owner start page",
  "nav.owner_surfaces": "Owner surfaces",
  "nav.workspace": "Workspace",
  "nav.admin": "Admin",
  "nav.new_lead": "New lead",
  "nav.owners": "Owners",
  "nav.properties": "Properties",

  // ---- Owners (relationships) ----
  "owners.title": "Owners",
  "owners.sub": "Everyone you manage for — and every unit they have with you.",
  "owners.summary": "{owners} owners · {units} units · {live} live",
  "owners.search": "Search name, company, e-mail or phone…",
  "owners.empty": "No owners yet",
  "owners.empty_sub": "An owner appears here the moment a lead is qualified. Until then they live in the pipeline.",
  "owners.none_match": "No owners match your search",
  "owners.col_owner": "Owner",
  "owners.col_units": "Units",
  "owners.col_open": "In pipeline",
  "owners.col_activity": "Last activity",
  "owners.units_n": "{n} units",
  "owners.units_one": "1 unit",
  "owners.live_n": "{n} live",
  "owners.open_n": "{n} in pipeline",
  "owners.returning": "Existing owner",
  "owners.returning_units": "Existing owner · {n} units",
  "owners.returning_one": "Existing owner · 1 unit",
  "owners.returning_hint": "Matched on e-mail or phone with an owner you already manage for.",
  "owner.back": "Owners",
  "owner.add_unit": "Add unit",
  "owner.edit": "Edit owner",
  "owner.contact": "Contact",
  "owner.units": "Units",
  "owner.units_sub": "Every property this owner has with you.",
  "owner.enquiries": "New enquiries",
  "owner.enquiries_sub": "Came in through your start page or widget — not yet qualified.",
  "owner.agreements": "Agreements",
  "owner.activity": "Activity",
  "owner.no_units": "No units yet",
  "owner.no_units_sub": "Add the first unit — the offer can go out right away.",
  "owner.no_agreements": "No agreements yet",
  "owner.stat_units": "Units",
  "owner.stat_live": "Live",
  "owner.stat_open": "In pipeline",
  "owner.stat_agreements": "Signed agreements",
  "owner.stat_emails": "E-mails sent",
  "owner.since": "Owner since {date}",
  "owner.live_since": "Live since {date}",
  "owner.add_unit.title": "Add a unit for {name}",
  "owner.add_unit.sub": "You already know this owner — only the property is needed. The unit starts at Qualified, so the offer can go out immediately.",
  "owner.add_unit.create": "Add unit",
  "owner.add_unit.done": "Unit added — starts at Qualified",
  "owner.other_units": "Also has {n} other units with you",
  "owner.other_unit": "Also has 1 other unit with you",
  "owner.view": "View owner",
  "owner.not_found": "Owner not found",
  "owner.agreement_signed": "Signed {date}",
  "owner.agreement_pending": "Awaiting signature",
  "owner.agreement_void": "Void",
  "owner.stat_ended": "Ended",
  "owner.ended_on": "Ended {date}",

  // ---- Relationship (derived from the owner's units) ----
  "rel.customer": "Customer",
  "rel.prospect": "Prospect",
  "rel.former": "Former customer",
  "rel.lost": "Lost",
  "rel.customer_since": "Customer since {date}",
  "rel.live_units": "{n} live",
  "rel.live_unit": "1 live",
  "owners.seg.customers": "Customers",
  "owners.seg.prospects": "Prospects",
  "owners.seg.former": "Former",
  "owners.seg.all": "All",
  "owners.col_status": "Status",
  "owners.col_since": "Customer since",
  "owners.empty_customers": "No customers yet",
  "owners.empty_customers_sub": "An owner becomes a customer the moment they sign. Prospects are in the pipeline.",
  "owners.returning_customer": "Existing customer",
  "owners.returning_customer_units": "Existing customer · {n} live",
  "owners.returning_prospect": "Returning prospect",
  "owners.returning_former": "Former customer",

  // ---- End agreement (offboarding) ----
  "stage.ended": "Ended",
  "lead.next.ended": "Agreement ended.",
  "end.action": "End agreement…",
  "end.title": "End the agreement",
  "end.sub": "The unit leaves your portfolio and the owner becomes a former customer (unless they have other units). Nothing changes in your PMS — remember to deactivate the listing there.",
  "end.date": "End date",
  "end.reason": "Reason",
  "end.note": "Note (optional)",
  "end.note_ph": "Anything worth remembering for next time",
  "end.confirm": "End agreement",
  "end.done": "Agreement ended",
  "end.banner": "Agreement ended {date} · {reason}",
  "end.pms_hint": "Deactivate the listing in {pms} so it stops taking bookings.",
  "end.reason.owner_sold": "Owner sold the property",
  "end.reason.owner_self_use": "Owner uses it themselves",
  "end.reason.switched_manager": "Switched to another manager",
  "end.reason.performance": "Unhappy with results",
  "end.reason.regulation": "Regulation / permit",
  "end.reason.other": "Other",
  "properties.filter.ended": "Ended",
  "properties.size_m2": "{n} m²",
  "common.clear": "Clear",
  "dir.sort": "Sort",
  "dir.sort.activity": "Last activity",
  "dir.sort.name": "Name",
  "dir.sort.units": "Most units",
  "dir.sort.since": "Customer since",
  "dir.sort.newest": "Recently updated",
  "dir.sort.stage": "Stage",
  "dir.sort.owner": "Owner",
  "dir.view": "View",
  "dir.view.list": "List",
  "dir.view.grid": "Grid",
  "dir.clear_filters": "Clear search",
  "owners.action_email": "E-mail",
  "owners.action_call": "Call",
  "owner.relationship": "Relationship",
  "owner.first_enquiry": "First enquiry",
  "owner.status": "Status",

  "dash.customers": "Customers",
  "dash.customers_new": "{n} new this month",
  "dash.hint.customers": "Owners with a signed agreement",

  // ---- Properties (inventory) ----
  "properties.title": "Properties",
  "properties.sub": "Every unit you have acquired — stage, owner and where it lives in your PMS.",
  "properties.summary": "{units} units · {live} live",
  "properties.search": "Search property, address or owner…",
  "properties.empty": "No properties yet",
  "properties.empty_sub": "A property appears here when a lead is qualified. New enquiries live in the pipeline.",
  "properties.none_match": "No properties match",
  "properties.filter.all": "All",
  "properties.filter.pipeline": "In pipeline",
  "properties.filter.onboarding": "Onboarding",
  "properties.filter.live": "Live",
  "properties.filter.closed": "Closed",
  "properties.col_property": "Property",
  "properties.col_owner": "Owner",
  "properties.col_stage": "Stage",
  "properties.col_pms": "PMS",
  "properties.col_since": "Since",
  "properties.pms_none": "Not linked",
  "properties.pms_linked": "Linked",
  "properties.pms_pushed": "Created",
  "properties.pms_live": "Live",


  // Login
  "login.title": "Welcome back",
  "login.sub": "Log in to Listed Admin.",
  "login.submit": "Log in",
  "login.demo": "Demo: sarah@northstay.com / flow1234",
  "login.use_demo": "Fill in the demo account (Northstay)",
  "login.visual.title": "Every owner, from first click to live listing.",
  "login.visual.capture": "Capture from your website",
  "login.visual.offer": "Offer, accept and sign online",
  "login.visual.launch": "Onboard and launch in your PMS",
  "login.register_link": "New property manager? Create an organization",
  "login.login_link": "Already have an account? Log in",
  "register.title": "Create your organization",
  "register.sub": "You'll get a ready-to-use service catalogue, offer template and onboarding template.",
  "register.org_name": "Company name",
  "register.submit": "Create organization",

  // Dashboard
  "dash.title": "Good to see you, {name}.",
  "dash.sub": "Which properties can we win — and what blocks the ones we've already won?",
  "dash.new_leads": "New leads",
  "dash.offers_awaiting": "Offers awaiting response",
  "dash.contracts_awaiting": "Contracts awaiting signature",
  "dash.onboarding": "Properties onboarding",
  "dash.ready": "Ready to launch",
  "dash.live": "Live",
  "dash.pipeline": "Pipeline",
  "dash.blockers": "What blocks launch",
  "dash.blockers_empty": "No properties in onboarding right now.",
  "dash.recent": "Recent activity",
  "dash.new_leads_list": "Newest leads",
  "dash.no_new_leads": "No new leads yet. Share your start page or install the widget.",
  "dash.blocking_items": "{n} blocking",
  "dash.owner_short": "owner",
  "dash.internal_short": "internal",
  "dash.view_pipeline": "Open pipeline",
  "dash.pipeline_total": "{n} active properties",
  "dash.blockers_sub": "Owner answers and internal tasks that still block a launch.",
  "dash.no_new_leads_title": "No new leads",
  "dash.hint.you": "Waiting on you",
  "dash.hint.owner": "Waiting on the owner",
  "dash.hint.both": "Owner + team",
  "dash.hint.launch": "Push to PMS",

  // Pipeline
  "pipeline.title": "Pipeline",
  "pipeline.sub": "Every property on its way from lead to live.",
  "pipeline.kanban": "Board",
  "pipeline.list": "List",
  "pipeline.search": "Search owner, property or address…",
  "pipeline.empty": "No leads yet",
  "pipeline.empty_sub": "Leads appear here the moment an owner submits your widget or start page.",
  "pipeline.add_lead": "Add lead",
  "pipeline.show_closed": "Show lost & archived",
  "pipeline.col_property": "Property",
  "pipeline.col_owner": "Owner",
  "pipeline.col_stage": "Stage",
  "pipeline.col_offer": "Offer",
  "pipeline.col_created": "Created",
  "pipeline.move_to": "Move to…",
  "pipeline.new_lead.title": "Add a lead manually",
  "pipeline.new_lead.address": "Property address",
  "pipeline.new_lead.create": "Create lead",
  "add_lead.sub": "Start with the property, then who owns it. You can fill in the rest on the lead afterwards.",
  "add_lead.section.property": "Property",
  "add_lead.section.owner": "Owner",
  "add_lead.bedrooms": "Bedrooms",
  "add_lead.guests": "Guests",
  "add_lead.name_ph": "Full name",
  "add_lead.phone_help": "Used to recognise the owner if they enquire again.",
  "add_lead.created": "Lead added",
  "add_lead.err.address": "Pick the property address first.",
  "add_lead.err.name": "Add the owner's name.",
  "add_lead.err.email": "Add a valid e-mail address.",
  "address.placeholder": "Search street address…",
  "phone.country": "Country code",
  "phone.search": "Search country or code",
  "phone.placeholder": "Phone number",
  "stepper.not_set": "Not set",
  "stepper.decrease": "Decrease",
  "stepper.increase": "Increase",
  "address.no_results": "No address found — you can still use what you typed:",
  "address.selected": "Address",
  "address.manual": "Typed manually",
  "common.change": "Change",
  "common.no_results": "No matches",
  "add_lead.type": "Property type",
  "add_lead.owner_sub": "Who owns it — we use e-mail and phone to recognise returning owners.",
  "owner.add_unit.address_help": "Search the street address; the unit is created for this owner and starts at Qualified.",

  // Lead detail
  "lead.tabs.overview": "Overview",
  "lead.tabs.offer": "Offer",
  "lead.tabs.onboarding": "Onboarding & launch",
  "lead.tabs.timeline": "Timeline",
  "lead.tabs.emails": "Emails",
  "lead.tabs.conversation": "Conversation",
  "nav.inbox": "Inbox",
  "inbox.title": "Inbox",
  "inbox.sub": "Every owner conversation, with what needs your reply first.",
  "inbox.view.needs_reply": "Needs reply",
  "inbox.view.all": "All",
  "inbox.view.sent": "Sent log",
  "inbox.search": "Search owner or property…",
  "inbox.empty.needs_reply": "You're all caught up",
  "inbox.empty.needs_reply_sub": "No owner is waiting on an answer from you.",
  "inbox.empty.all": "No conversations yet",
  "inbox.empty.all_sub": "Messages you send from a lead — and every owner reply — show up here.",
  "inbox.pick": "Select a conversation",
  "inbox.pick_sub": "Owner replies land here the moment they arrive — answer them without leaving Listed.",
  "inbox.pick_kbd": "to move between conversations",
  "inbox.gone": "That conversation is no longer in this view.",
  "inbox.back": "Back to list",
  "inbox.open_lead": "Open lead",
  "inbox.sub_sent": "Every e-mail Listed sent on your behalf, for audits.",
  "inbox.meta.needs_one": "1 owner is waiting on your reply",
  "inbox.meta.needs": "{n} owners are waiting on your reply",
  "inbox.meta.clear": "Nobody is waiting on you right now",
  "inbox.empty.search": "No matches",
  "inbox.empty.search_sub": "Nothing matches “{q}”. Try the owner’s name, e-mail or the property.",
  "inbox.empty.show_all": "Show all conversations",
  "inbox.count_one": "1 conversation",
  "inbox.count": "{n} conversations",
  "inbox.details": "Show details",
  "inbox.details_hide": "Hide details",
  "inbox.answered": "Answered — this conversation has left Needs reply.",
  "inbox.answered_next": "Next conversation",
  "inbox.awaiting": "Awaiting your reply",
  "inbox.rail.owner": "Owner",
  "inbox.rail.contact": "Contact",
  "inbox.rail.property": "Property",
  "inbox.rail.stage": "Stage",
  "inbox.rail.type": "Type",
  "inbox.rail.activity": "Activity",
  "inbox.rail.last_reply": "Last owner reply",
  "inbox.rail.last_sent": "Last sent",
  "inbox.rail.owner_messages": "Owner messages",
  "inbox.rail.none": "None yet",
  "conv.quick.answer": "Answer their question",
  "conv.quick.call": "Suggest a call",
  "conv.quick.next": "Propose next step",
  "conv.quick.answer_ctx": "Answer the owner's question directly and warmly, then confirm what happens next.",
  "conv.quick.call_ctx": "Suggest a short phone call and offer two concrete time slots.",
  "conv.quick.next_ctx": "Propose the concrete next step in the process and what you need from the owner to get there.",
  "conv.new_divider": "New",
  "dash.needs_reply": "Needs your reply",
  "dash.needs_reply_sub": "Owners who wrote back and are waiting on you.",
  "dash.needs_reply_empty": "No owner is waiting on an answer.",
  "dash.open_inbox": "Open inbox",
  "lead.now.read_reply": "Read reply",
  "lead.next.replied": "The owner replied — read and answer before anything else.",
  "lead.message_owner": "Message owner",
  "conv.replied": "Owner replied",
  "conv.replied_hint": "The owner answered by e-mail — open the conversation to read and reply.",
  "conv.count": "{n} messages",
  "conv.hide_system": "Hide {n} automatic e-mails",
  "conv.show_system": "Show {n} automatic e-mails",
  "conv.empty.title": "No messages yet",
  "conv.empty.sub": "Write to the owner below. Their replies land right here — and in your inbox.",
  "conv.placeholder": "Write to {name}…",
  "conv.the_owner": "the owner",
  "conv.you": "You",
  "conv.ai_draft": "Draft with AI",
  "conv.ai_context_reply": "Reply to the owner's latest message:",
  "conv.add_subject": "Subject",
  "conv.sent": "Message sent",
  "conv.no_email": "The owner has no e-mail address — add one on the Overview tab to write to them.",
  "conv.no_email_short": "No e-mail on file",
  "conv.no_text": "(no text)",
  "conv.via_mailbox": "from mailbox",
  "conv.via_mailbox_hint": "Sent from your own e-mail client by replying to the lead's e-mail — captured automatically.",
  "conv.rail.recipient": "Owner",
  "conv.rail.how": "How replies work",
  "conv.rail.armed": "Every e-mail on this lead carries a unique reply address. When the owner answers, the reply shows up here and a copy lands in your inbox — reply to that copy from Outlook or Gmail and it is captured too.",
  "conv.rail.not_armed": "Replies go straight to your mailbox. Inbound capture is not configured on this platform yet.",
  "conv.rail.last_reply": "Last reply",
  "conv.system.lead_received": "Confirmation sent to owner",
  "conv.system.offer_sent": "Proposal sent",
  "conv.system.contract_signed": "Welcome + signed agreement sent",
  "conv.system.onboarding_invited": "Onboarding invitation sent",
  "conv.system.owner_live": "Live notification sent",
  "conv.system.automation_reminder": "Automatic reminder sent",
  "conv.system.team_new_lead": "Team notified",
  "lead.owner": "Owner",
  "lead.property": "Property",
  "lead.intention": "Rental intention",
  "lead.existing_listing": "Existing listing",
  "lead.photos": "Photos from owner",
  "lead.photo_source_blocked": "The owner linked their {platform} listing, but the photos could not be fetched automatically. You can collect them from the listing.",
  "lead.photo_source_open": "Open listing",
  "lead.ai_summary": "AI summary",
  "lead.ai_generating": "Listed is reading this lead…",
  "lead.ai_failed": "Summary couldn't be generated.",
  "lead.ai_edited": "Edited",
  "lead.ai_fit": "Fit",
  "lead.ai_suggested": "Suggested: {name}",
  "lead.ai_missing": "Worth asking",
  "lead.type": "Property type",
  "lead.estimate": "Estimated annual revenue",
  "lead.estimate_sub": "Fetch a suggestion from your revenue data provider, or enter the range manually. Only a confirmed range reaches the owner.",
  "lead.estimate_fetch": "Fetch estimate",
  "lead.estimate_refetch": "Fetch again",
  "lead.estimate_suggestion": "Suggested range",
  "lead.estimate_apply": "Use this range",
  "lead.estimate_dismiss": "Dismiss",
  "lead.estimate_manual": "Enter manually",
  "lead.estimate_confidence": "{level} confidence",
  "lead.estimate_provider_range": "Provider range {min} – {max}, widened by ±{pct}% and rounded to {round}",
  "lead.estimate_adr": "Nightly rate",
  "lead.estimate_occupancy": "Occupancy",
  "lead.estimate_comparables": "{n} comparables",
  "lead.estimate_confirmed": "Confirmed by {name}",
  "lead.estimate_source": "Source",
  "lead.estimate_no_provider": "No market data provider connected — the internal model will be used. Connect AirDNA in Listed HQ.",
  "confidence.low": "Low",
  "confidence.medium": "Medium",
  "confidence.high": "High",
  "role.superadmin": "Platform admin",
  "lead.estimate_none": "No estimate yet",
  "lead.create_offer": "Create offer",
  "lead.open_offer": "Open offer builder",
  "lead.stage": "Stage",
  "lead.next_action": "Next best action",
  "lead.now.kicker": "Now",
  "lead.now.review_blockers": "Review {n} blockers",
  "lead.now.open_launch": "Open launch",
  "lead.photos_none": "No photos yet — the owner can add them during onboarding.",
  "lead.next.new": "Review the lead and create an offer.",
  "lead.next.qualified": "Build and send the offer.",
  "lead.next.offer": "Waiting for the owner. Send a follow-up if it stays unopened.",
  "lead.next.signed": "Owner has signed. Invite them to start onboarding.",
  "lead.next.onboarding": "Follow the owner's progress and complete internal tasks.",
  "lead.next.ready": "Everything is in place. Create the property in your PMS.",
  "lead.next.live": "Live. Nothing left to do here.",
  "lead.next.lost": "Marked as lost.",
  "lead.next.archived": "Archived.",
  "lead.followup": "Send follow-up",
  "lead.followup.title": "Follow-up email",
  "lead.followup.context": "Anything specific to mention? (optional)",
  "lead.followup.draft": "Draft with AI",
  "lead.followup.drafting": "Drafting…",
  "lead.followup.subject": "Subject",
  "lead.followup.body": "Message",
  "lead.followup.sent": "Follow-up sent",
  "lead.notes": "Notes",
  "lead.notes.placeholder": "Add an internal note…",
  "lead.copy_offer_link": "Copy owner link",
  "lead.copy_onboarding_link": "Copy onboarding link",
  "lead.source": "Source: {source}",
  "lead.mark_lost": "Mark as lost",
  "lead.archive": "Archive",
  "lead.owner_note": "Owner's note",
  "lead.offers_empty": "No offer yet. Listed will pre-fill the best template for this lead.",
  "lead.offers_empty_short": "No offer yet",
  "lead.contract": "Agreement",
  "lead.contract.pending": "Awaiting signature",
  "lead.contract.signed": "Signed by {name}",
  "lead.open_public": "Open as owner",
  "lead.property_promoted": "Property record created",
  "lead.edit_facts": "Edit property facts",

  // Onboarding & launch (admin)
  "launch.title": "Launch readiness",
  "launch.progress": "Progress",
  "launch.tasks_none": "No internal tasks. Add one if something must happen before launch.",
  "launch.task_reopen": "Reopen task",
  "launch.task_complete": "Complete task",
  "launch.task_auto": "Automatic",
  "common.hide": "Hide",
  "common.show": "Show",
  "launch.owner_pct": "Owner onboarding",
  "launch.readiness_pct": "Launch readiness",
  "launch.blocking": "{n} items blocking launch",
  "launch.blocking_one": "1 item blocking launch",
  "launch.ready": "{property} is ready to launch",
  "launch.ready_sub": "All owner and internal blockers are resolved.",
  "launch.not_started": "Onboarding starts once the agreement is signed.",
  "launch.start.title": "Onboarding hasn't started yet",
  "launch.start.sub": "The agreement was marked as signed outside Listed, so the owner's onboarding journey hasn't been created. Start it to get the owner's link — you can connect the property system on the right at any time.",
  "launch.start.invite": "Start & e-mail the owner",
  "launch.start.link": "Start & copy link",
  "launch.start.invited": "Onboarding started — invitation sent to {email}",
  "launch.start.link_copied": "Onboarding started — link copied",
  "launch.start.no_email": "Add the owner's e-mail address to send the invitation, or copy the link instead.",
  "launch.completed": "Completed",
  "launch.missing": "Missing from owner",
  "launch.missing_sub": "Answers the owner still has to give.",
  "launch.missing_blocking": "Dots mark the {n} that block launch.",
  "launch.internal_tasks": "Internal tasks",
  "launch.add_task": "Add task",
  "launch.task_title": "Task title",
  "launch.task_blocking": "Blocks launch",
  "launch.owner_answers": "Owner answers",
  "launch.reveal_logged": "Show — this is recorded on the timeline",
  "launch.uploads": "Uploads",
  "launch.create_in": "Create in {provider}",
  "launch.pushed": "Pushed to {provider}",
  "launch.prepared": "Payload prepared for {provider}",
  "launch.push_note": "Listed maps its canonical property schema to the PMS format. Without API credentials the payload is prepared and stored.",
  "launch.view_payload": "View payload",
  "launch.ai_check": "Check readiness",
  "launch.ai_checking": "Checking…",
  "launch.owner_status.not_started": "Owner hasn't started",
  "launch.owner_status.in_progress": "Owner in progress",
  "launch.owner_status.completed": "Owner complete",
  "launch.remind_owner": "Remind owner",
  "launch.canonical": "Technical details",
  "launch.live_title": "{property} is live",
  "launch.live_sub": "The whole journey is in the timeline.",
  "launch.external": "PMS records",

  // Offer builder
  "builder.title": "Offer builder",
  "builder.template": "Template",
  "builder.custom": "Custom",
  "builder.intro": "Intro text",
  "builder.items": "Services & pricing",
  "builder.add_service": "Add service",
  "builder.estimate": "Revenue estimate",
  "builder.terms": "Terms & notes",
  "builder.valid_until": "Valid until",
  "builder.send": "Send offer",
  "builder.resend": "Send new version",
  "builder.sent": "Offer sent to {email}",
  "builder.live_preview": "What the owner sees",
  "builder.preview_full": "Open full size",
  "builder.versions": "Versions sent",
  // P36 — block-based proposal
  "blocks.cover": "Cover photo",
  "blocks.cover_hint": "The photograph at the top of the proposal.",
  "blocks.intro": "Letter",
  "blocks.intro_hint": "Title and a personal opening.",
  "blocks.property": "The property",
  "blocks.property_hint": "Address and key facts in one line.",
  "blocks.highlights": "Highlights",
  "blocks.highlights_hint": "Up to four concrete reasons this home will do well.",
  "blocks.estimate": "The numbers",
  "blocks.estimate_hint": "Estimate, fee and what the owner keeps.",
  "blocks.plan": "The plan",
  "blocks.plan_hint": "Management fee and included services.",
  "blocks.why_us": "Why us",
  "blocks.why_us_hint": "Three or four things that set you apart.",
  "blocks.team": "Your team",
  "blocks.team_hint": "Who the owner will be working with.",
  "blocks.references": "What owners say",
  "blocks.references_hint": "Short quotes from owners you already work with.",
  "blocks.portfolio": "Homes we run",
  "blocks.portfolio_hint": "Photos of properties already under management.",
  "blocks.extras": "Optional extras",
  "blocks.extras_hint": "Add-ons the owner can switch on.",
  "blocks.timeline": "What happens next",
  "blocks.timeline_hint": "The steps from accepting to going live.",
  "blocks.faq": "Questions & answers",
  "blocks.faq_hint": "The questions owners usually ask, answered.",
  "blocks.text": "Text section",
  "blocks.text_hint": "A heading and free text — anything else you want to say.",
  "blocks.terms": "Good to know",
  "blocks.terms_hint": "Terms and assumptions.",
  "blocks.accept": "Accept",
  "blocks.accept_hint": "The decision and your contact line.",
  "blocks.ph.heading": "Heading",
  "blocks.ph.title": "Title",
  "blocks.ph.text": "Write a sentence or two…",
  "blocks.ph.paragraph": "Write here…",
  "blocks.ph.name": "Name",
  "blocks.ph.role": "Role",
  "blocks.ph.quote": "What the owner said…",
  "blocks.ph.where": "City",
  "blocks.ph.question": "Question",
  "blocks.ph.answer": "Answer",
  "blocks.add.point": "Add point",
  "blocks.add.member": "Add person",
  "blocks.add.quote": "Add quote",
  "blocks.add.step": "Add step",
  "blocks.add.question": "Add question",
  "blocks.customise_steps": "Customise the steps",
  "blocks.starter.why_us.heading": "Why owners choose us",
  "blocks.starter.why_us.p1_title": "Local, hands-on team",
  "blocks.starter.why_us.p1_text": "We are close to the property and can be there the same day.",
  "blocks.starter.why_us.p2_title": "Pricing that follows demand",
  "blocks.starter.why_us.p2_text": "Rates move with season, events and lead time — never a flat number.",
  "blocks.starter.why_us.p3_title": "Guests who are screened",
  "blocks.starter.why_us.p3_text": "Every booking is checked before it is confirmed, and house rules are enforced.",
  "blocks.starter.team.heading": "Who you will work with",
  "blocks.starter.references.heading": "What owners say",
  "blocks.starter.faq.heading": "Good questions",
  "blocks.starter.faq.q1": "Can I still use the property myself?",
  "blocks.starter.faq.a1": "Yes. You block the dates you want in the owner calendar; we plan around them.",
  "blocks.starter.faq.q2": "When am I paid?",
  "blocks.starter.faq.a2": "Monthly, with a statement that shows every booking, the fee and what you keep.",
  "builder.add_section": "Add section",
  "builder.manage_services": "Manage services & pricing",
  "builder.portfolio_empty": "Shows once you have properties live in Listed. Hidden for the owner until then.",
  "builder.extras_empty": "No optional extras on this proposal yet. Hidden for the owner until you add one.",
  "builder.cover_change": "Change photo",
  "builder.cover_auto_short": "Chosen automatically",
  "builder.cover_explicit_short": "Your pick for this proposal",
  "builder.block.move_up": "Move up",
  "builder.block.move_down": "Move down",
  "builder.block.hide": "Hide section",
  "builder.block.show": "Show",
  "builder.block.hidden": "{name} is hidden for the owner",
  "builder.block.ai": "Write with AI",
  "builder.block.ai_busy": "Writing…",
  "builder.ai.write": "Write this section",
  "builder.ai.improve": "Improve the text",
  "builder.ai.shorter": "Make it shorter",
  "builder.ai.longer": "Add more detail",
  "builder.ai.personal": "More personal",
  "builder.ai.formal": "More formal",
  "builder.ai.custom": "Give an instruction",
  "builder.ai.custom_title": "Tell the AI what to change",
  "builder.ai.custom_ph": "e.g. mention that we handle linen and that the owner can block dates",
  "builder.ai.run": "Rewrite",
  "builder.ai.applied": "Section updated — review and save",
  "builder.ai.unavailable": "AI writing is not available on this platform.",
  "builder.mode.edit": "Edit",
  "builder.mode.preview": "Preview",
  "builder.sections": "Sections",
  "builder.sections_sub": "Show, hide and reorder. Hidden sections never reach the owner.",
  "builder.details": "Details",
  "builder.change.blocks": "Sections were added, removed or reordered",
  "owner_offer.change.blocks": "Sections of the proposal were updated",
  "builder.services_sheet.title": "Services & pricing",
  "builder.services_sheet.sub": "The plan\u2019s fee, included services and optional extras. Changes show in the document immediately.",
  "builder.services_sheet.done": "Done",
  "builder.cover_sheet.title": "Cover photo",
  "builder.editing_hint": "Click any text to edit it. Hover a section for move, hide and AI.",
  "builder.behavior": "Behavior",
  "builder.suggested": "Suggested by Listed",
  "builder.accepted_lock": "This offer was accepted and is locked. Create a new offer to change terms.",
  "builder.edited_after_send": "You've changed a sent offer. Send a new version so the owner sees the update.",
  "builder.owner_link": "Owner link",
  "builder.back_to_lead": "Back to lead",
  "builder.recommended_toggle": "Recommended",
  "builder.no_items": "No services yet. Add from your catalogue.",
  "builder.preview": "Preview",
  "builder.story": "The story",
  "builder.story_sub": "What the owner reads first. Write it like a letter — short, personal, specific.",
  "builder.title_ph": "Proposal for the property",
  "builder.intro_ph": "Why this home will do well with you — and what the owner can expect.",
  "builder.use_suggested_intro": "Use suggested intro",
  "builder.highlights": "Highlights",
  "builder.highlights_sub": "up to {n} short lines the owner sees under the intro",
  "builder.highlight_ph": "e.g. Sea view and 5 minutes from the ferry — strong summer demand",
  "builder.add_highlight": "Add highlight",
  "builder.cover": "Cover photo",
  "builder.cover_sub": "The photograph at the top of the proposal — the owner's own, yours, or a curated picture.",
  "builder.cover_empty": "Photos the owner uploads appear here — the proposal works fine without one.",
  "builder.estimate_sub": "Shown to the owner as a yearly range. Leave empty to send without an estimate.",
  "builder.use_lead_estimate": "Use lead estimate ({range})",
  "builder.estimate_order": "Min must be lower than max.",
  "builder.estimate_none_note": "Without an estimate the owner sees the fee and a slider to try their own number.",
  "builder.plan": "The plan",
  "builder.plan_sub": "The management fee and what it includes. Pick a template or set it by hand.",
  "builder.no_fee": "No management fee yet — add a percentage-of-revenue service below or pick a template.",
  "builder.items_sub": "Fixed, per-stay and optional services. Owners can switch optional ones on and off.",
  "builder.behavior_legend": "Required is always part of the agreement · Included has no separate cost · Optional is the owner's choice · Internal is never shown to the owner.",
  "builder.search_services": "Search your catalogue…",
  "builder.no_services_found": "No matching services.",
  "builder.validity": "Validity & terms",
  "builder.validity_sub": "When the proposal expires, and the fine print the owner should know.",
  "builder.pick_date": "Pick a date",
  "builder.in_days": "In {n} days",
  "builder.terms_ph": "Fees are charged on realised booking revenue. Cleaning is normally covered by the guest cleaning fee…",
  "builder.ready.title": "Ready to send",
  "builder.ready.blocked": "Not ready yet",
  "builder.ready.email": "Owner has an e-mail address",
  "builder.ready.email_fix": "Add on lead",
  "builder.ready.fee": "Management fee is set",
  "builder.ready.story": "Title and intro written",
  "builder.ready.estimate": "Revenue estimate set",
  "builder.ready.estimate_off": "Estimates switched off for owners",
  "builder.ready.valid": "Valid-until date set",
  "builder.ready.highlights": "At least one highlight",
  "builder.send_dialog.title": "Send this proposal?",
  "builder.send_dialog.title_again": "Send version {n}?",
  "builder.send_dialog.sub": "{name} gets an e-mail with a personal link ({email}). You can send a new version any time.",
  "builder.send_dialog.changes": "What changed since the last version",
  "builder.send_dialog.no_changes": "Nothing changed — the owner gets a fresh link and a new validity window.",
  "builder.send_dialog.confirm": "Send",
  "builder.change.item_behavior": "{name} is now {to}",

  // Outbox
  "outbox.title": "Outbox",
  "outbox.sub": "Every e-mail Listed sends on your behalf, with delivery status.",
  "outbox.empty": "No emails yet",
  "outbox.empty_sub": "Offers, agreements and reminders you send will appear here with their delivery status.",
  "outbox.none_match": "No e-mails match.",
  "outbox.to_owner": "To owner",
  "outbox.to_team": "To team",
  "outbox.resend": "Re-send",
  "outbox.resent": "Re-sent (logged)",
  "outbox.status.logged": "Logged",
  "outbox.status.sent": "Sent",
  "outbox.status.failed": "Failed",
  "outbox.open_link": "Open link",

  // Timeline
  "timeline.empty": "No activity yet.",

  // Settings
  "settings.title": "Settings",
  "settings.branding": "Branding",
  "settings.lead_capture": "Lead capture & widget",
  "settings.pipeline": "Pipeline",
  "settings.services": "Services & pricing",
  "settings.offer_templates": "Proposal templates",
  "settings.contract": "Contract template",
  "settings.onboarding": "Onboarding template",
  "settings.automations": "Automations",
  "settings.integrations": "Integrations",
  "settings.team": "Team",

  "branding.title": "Branding",
  "branding.sub": "Everything the owner sees carries your brand. Listed stays invisible.",
  "branding.logo_url": "Logo URL",
  "branding.favicon_url": "Favicon URL",
  "branding.primary_color": "Primary colour",
  "branding.email_sender_name": "Email sender name",
  "branding.email_sender_address": "Email sender address",
  "branding.email_footer": "Email footer",
  "branding.custom_domain": "Custom domain",
  "branding.custom_domain_help": "e.g. owners.yourcompany.com (Pro). Point a CNAME to Listed and we'll serve your owner pages there.",
  "branding.plan": "Plan",
  "branding.plan.standard": "Standard — shows “Powered by DigiHome”",
  "branding.plan.pro": "Pro — full white-label",
  "branding.preview": "Owner-facing preview",
  "branding.org_name": "Organization name",

  "capture.title": "Lead capture & widget",
  "capture.sub": "Configure the first thing an owner sees, then install it anywhere.",
  "capture.headline": "Headline",
  "capture.subheadline": "Subheadline",
  "capture.cta": "Button text",
  "capture.placeholder": "Input placeholder",
  "capture.trust_line": "Trust line",
  "capture.allow_listing": "Accept Airbnb / Booking / VRBO links",
  "capture.photo_upload": "Ask for photos (optional step)",
  "capture.revenue_estimate": "Show revenue estimate to owners",
  "capture.est.title": "Revenue estimate",
  "capture.est.sub": "Decide where owners see an estimated annual revenue range — and where the numbers come from.",
  "capture.est.mode": "Where owners see it",
  "capture.est.mode.off": "Never",
  "capture.est.mode.off_sub": "No revenue range anywhere in the owner journey.",
  "capture.est.mode.offer_only": "Only in the offer",
  "capture.est.mode.offer_only_sub": "You confirm the range before the owner sees it. Recommended.",
  "capture.est.mode.instant": "Instantly in the capture form",
  "capture.est.mode.instant_sub": "An indicative range appears after the owner answers the basics. Highest conversion, least control.",
  "capture.est.source": "Data source",
  "capture.est.source.auto": "Automatic (market data, then internal model)",
  "capture.est.source.airdna": "AirDNA only",
  "capture.est.source.internal": "Internal model only",
  "capture.est.source.manual": "Manual entry only",
  "capture.est.margin": "Safety margin (±%)",
  "capture.est.rounding": "Round to nearest",
  "capture.est.show_source": "Show the data source to owners",
  "capture.est.limit": "Instant estimates per day",
  "capture.est.providers": "Available providers",
  "capture.est.scope.platform": "Platform key",
  "capture.est.scope.tenant": "Your key",
  "capture.est.scope.builtin": "Built in",
  "capture.est.scope.none": "Not connected",
  "capture.est.instant_note": "Instant estimates are indicative, rate-limited and never block the owner if a provider is unavailable.",
  "capture.required_phone": "Require phone number",
  "capture.install": "Install the widget",
  "capture.install_sub": "Paste this where you want the widget to appear. Works as an inline embed or a button.",
  "capture.inline": "Inline widget",
  "capture.button": "Button that opens your start page",
  "capture.start_page": "Standalone start page",
  "capture.start_page_sub": "Share this link directly — in ads, emails or your navigation.",
  "capture.preview": "Preview",

  "services.title": "Services & pricing",
  "services.sub": "Set up your catalogue once. Offers are built from it.",
  "services.new": "New service",
  "services.edit": "Edit service",
  "services.includes": "What's included (one per line)",
  "services.recommended": "Mark as recommended",
  "services.active": "Active",
  "services.empty": "No services yet.",
  "services.delete_confirm": "Delete this service? It will be removed from templates too.",

  // ---- P37: templates own the document · per-offer configurator ----
  "builder.mode.compose": "Compose",
  "builder.mode.customize": "Customize document",
  "builder.compose_hint": "Plan, letter, sections — the document on the left is exactly what the owner gets.",
  "builder.customize_hint": "Click any text to edit it. Hover a section for move · hide · AI.",
  "builder.customize_scope": "Changes here apply to this proposal only — the template stays as it is.",
  "builder.reset_all": "Reset sections to template",
  "builder.reset_all_done": "Sections reset to the template.",
  "builder.reset_done": "{name} reset to the template.",
  "builder.edit_template": "Edit template “{name}”",
  "builder.saved_to_library": "Saved as shared content — every template follows.",
  "builder.saved_to_template": "Saved to the template “{name}”.",
  "builder.template_switched": "Switched to {name}. Your letter, estimate and cover were kept.",
  "builder.step.plan": "Plan & price",
  "builder.step.letter": "The letter",
  "builder.step.details": "Sections, cover, validity",
  "builder.fee": "Management fee",
  "builder.includes_summary": "{included} included · {optional} optional — services & pricing",
  "builder.use_lead_estimate_short": "Use the estimate from the enquiry",
  "builder.letter.title": "Title",
  "builder.letter.intro": "Opening",
  "builder.letter.highlights": "Highlights",
  "builder.letter.highlights_hint": "Three or four concrete reasons this plan suits them. Shown under the opening.",
  "builder.letter.write_for": "Write for {name}",
  "builder.letter.rewrite": "Rewrite",
  "builder.letter.the_owner": "the owner",
  "builder.letter.writing": "Writing a letter for {name}…",
  "builder.letter.written": "A letter for {name} is drafted — read it through and adjust.",
  "builder.letter.failed": "The draft could not be written right now. Write it yourself or try again.",
  "builder.optional_sections": "Optional sections",
  "builder.optional_none": "This template fixes every section. Use “Customize document” to change this proposal only.",
  "builder.hidden_note": "{n} more section(s) hidden in “Customize document”.",
  "builder.block.locked_short": "locked by template",
  "builder.block.modified": "Edited",
  "builder.block.reset": "Reset to template",
  "builder.block.reset_hint": "Replace this section with the template's text.",
  "builder.block.reset_same": "Already the template's text.",
  "builder.block.to_template": "Save to template “{name}”",
  "builder.block.to_template_hint": "This text becomes the default for every new proposal from this plan.",
  "builder.block.to_library_hint": "This section is shared content — every template will use this text.",
  "common.more": "More",
  "common.unsaved": "Unsaved changes",
  "templates.untitled": "New template",
  "templates.name_required": "Give the template a name first.",
  "templates.open_designer": "Open the designer",
  "templates.sections_line": "{n} sections · {optional} optional for the sender",
  "templates.shared_title": "Shared content",
  "templates.shared_sub": "Why us, the team, references and FAQ are written once and reused by every template that includes them. Edit them where you see them — inside the designer.",
  "templates.shared_count": "{n} entries",
  "templates.shared_empty": "Not written yet",
  "templates.shared_used_by": "used by {n} template(s)",
  "templates.shared_write": "Write",
  "designer.back": "Proposal templates",
  "designer.sub": "The document every proposal from this plan starts from — with a sample owner.",
  "designer.template": "Template",
  "designer.default_help": "New proposals start from the default template unless another one fits the enquiry better.",
  "designer.internal_note": "Internal note",
  "designer.internal_note_hint": "For your team only. Owners never see this.",
  "designer.editing_hint": "Click any text to edit it. Hover a section for rules, move · hide · AI.",
  "designer.preview_hint": "Exactly what an owner would receive — merge fields resolved for the sample owner.",
  "designer.sample_note": "You are looking at a sample owner (Emma Christensen, Strandveien 12). Real proposals fill in the owner's name, property and numbers.",
  "designer.sample_owner": "Sample owner · {name}",
  "designer.open_as_owner": "Open as owner",
  "designer.services_sub": "Which services this plan includes and how — required, included, optional or internal.",
  "designer.services_count": "{n} of {total} services in this plan",
  "designer.no_services": "No services yet.",
  "designer.sections_sub": "Order and rules. Optional sections can be switched on/off per proposal; locked text cannot be edited per proposal.",
  "designer.optional": "Optional",
  "designer.optional_short": "optional",
  "designer.optional_hint": "The sender may switch this section on or off for a proposal.",
  "designer.locked": "Locked",
  "designer.locked_hint": "The text cannot be edited per proposal — for terms and brand promises.",
  "designer.default_visibility": "Shown by default",
  "designer.shared": "Shared",
  "designer.shared_hint": "Shared content — edited here, used by every template.",
  "designer.shared_empty": "Shared content not written yet — the section is left out of proposals until it is.",
  "designer.make_custom": "Make custom for this template",
  "designer.make_custom_hint": "Copy the shared text into this template and edit it independently.",
  "designer.use_shared": "Use shared content",
  "designer.use_shared_hint": "Read this section from the shared library (Settings → Shared content).",
  "designer.outline_legend": "Hover a row: optional · locked · shown by default.",
  "merge.title": "Merge fields",
  "merge.sub": "Type these into any text — they are filled in per owner.",
  "merge.hint": "Click a field to copy it, then paste into the document.",
  "merge.owner_first_name": "Owner's first name",
  "merge.owner_name": "Owner's full name",
  "merge.property": "Property name",
  "merge.city": "City",
  "merge.estimate": "Revenue estimate range",
  "merge.company": "Owner's company",
  "merge.manager": "Your company",
  "merge.pm_name": "Sender's name",
  "merge.fee": "Management fee",
  "templates.title": "Proposal templates",
  "templates.sub": "Each template owns the whole proposal: services & pricing, the sections and the text. Listed suggests the right one for each enquiry; the sender only decides price, letter and optional sections.",
  "templates.new": "New template",
  "templates.edit": "Edit template",
  "templates.default": "Default",
  "templates.make_default": "Use as default",
  "templates.suggest_for": "Suggest for",
  "templates.property_types": "Property types",
  "templates.rental_plans": "Rental plans",
  "templates.items": "Services in this template",
  "templates.empty": "No templates yet.",
  "templates.delete_confirm": "Delete this template?",

  "contract.title": "Contract template",
  "contract.sub": "The agreement the owner signs after accepting an offer. Placeholders are filled automatically.",
  "contract.placeholders": "Placeholders",
  "contract.body": "Agreement text",

  "onbt.title": "Onboarding template",
  "onbt.sub": "The journey a new owner walks through on their phone before the property can go live. Every answer says where it ends up.",
  "onbt.intro_title": "Welcome title",
  "onbt.intro_text": "Welcome text",
  "onbt.add_section": "Add section",
  "onbt.add_field": "Add question",
  "onbt.section_title": "Section title",
  "onbt.section_desc": "Section description",
  "onbt.field_label": "Question",
  "onbt.field_help": "Help text",
  "onbt.field_type": "Answer type",
  "onbt.field_listing_import": "Allow photos from a listing link",
  "onbt.field_listing_import_help": "Owner can pull photos from Airbnb, Booking.com or Vrbo",
  "onbt.field_required": "Required",
  "onbt.field_blocking": "Blocks launch",
  "onbt.field_options": "Answer options",
  "onbt.field_condition": "Only show when",
  "onbt.field_condition_field": "Question key",
  "onbt.field_condition_values": "has one of these values (comma separated)",
  "onbt.field_ai": "AI assist",
  "onbt.field_key": "Key",
  "onbt.property_types": "Only for property types",
  "onbt.move_up": "Move up",
  "onbt.move_down": "Move down",
  "onbt.reset_confirm": "Reset the template to Listed's default? Your changes will be lost.",
  "onbt.questions": "{n} questions",
  "onbt.saved": "Template saved",
  "onbt.type.text": "Short text",
  "onbt.type.textarea": "Long text",
  "onbt.type.number": "Number",
  "onbt.type.select": "Single choice",
  "onbt.type.multiselect": "Multiple choice",
  "onbt.type.boolean": "Yes / No",
  "onbt.type.secure": "Secure text (code, password)",
  "onbt.type.photo": "Photo",
  "onbt.type.video": "Video",
  "onbt.type.file": "Document",
  "onbt.type.date": "Date",
  "onbt.type.periods": "Date periods",
  "onbt.ai.none": "None",
  "onbt.ai.router": "Read Wi-Fi from router photo",
  "onbt.ai.key_box": "Detect key box / code from photo",
  "onbt.ai.electrical_panel": "Confirm electrical panel photo",
  "onbt.ai.water_shutoff": "Confirm water shut-off photo",
  "onbt.ai.fire_extinguisher": "Confirm fire extinguisher photo",
  "onbt.ai.parking": "Confirm parking photo",
  "onbt.ai.floor_plan": "Confirm floor plan",
  "onbt.ai.access_free_text": "Structure access description",
  "onbt.ai.wifi_free_text": "Structure Wi-Fi text",
  "onbt.ai.parking_free_text": "Structure parking text",
  "onbt.ai.house_rules_free_text": "Structure house rules",

  "auto.title": "Automations",
  "auto.sub": "Event-driven follow-ups. Sequences stop the moment the owner opens, signs or completes.",
  "auto.enabled": "Automations enabled",
  "auto.offer_rules": "After an offer is sent",
  "auto.onboarding_rules": "After signing (onboarding incomplete)",
  "auto.days_after": "{n} day(s) after",
  "auto.action.reminder": "Send reminder to owner",
  "auto.action.followup": "Send follow-up to owner",
  "auto.action.notify": "Create task for manager",
  "auto.action.invite": "Send onboarding invitation",
  "auto.action.reminder_task": "Reminder + task for manager",
  "auto.run_now": "Evaluate rules now",
  "auto.ran": "Rules evaluated — {n} action(s) fired",
  "auto.add_rule": "Add rule",
  "auto.internal_tasks": "Default internal tasks after signing",
  "auto.internal_tasks_sub": "Created automatically for every new property. Blocking tasks must be done before launch.",
  "auto.schedule_note": "Rules are evaluated every 5 minutes in the background.",

  "integ.title": "Integrations",
  "integ.sub": "Listed keeps one canonical property schema and maps it to each system through adapters.",
  "integ.pms": "Property management systems",
  "integ.revenue": "Revenue data",
  "integ.revenue_sub": "Used for estimated annual revenue. A key entered here overrides the platform key set in Listed HQ.",
  "integ.status.inherited": "Platform key",
  "integ.inherited_note": "Using the platform-level key configured in Listed HQ. Add your own key to override.",
  "integ.docs": "API docs",
  "integ.email": "Email delivery",
  "integ.email_note": "Currently log-only: every email is stored in the Outbox and on the timeline. Connecting a provider changes nothing in the product logic.",
  "integ.address": "Address lookup",
  "integ.address_note": "Norwegian national address registry with Photon / OpenStreetMap as global fallback. Google Maps (Places) is added behind the same interface.",
  "integ.ai": "AI",
  "integ.ai_note": "OpenAI GPT-5 via the Emergent universal key. All outputs are editable suggestions.",
  "integ.signing": "E-signature",
  "integ.signing_note": "Listed-native typed/drawn signature with audit metadata. Scrive, Signicat or DocuSign can be plugged in later.",
  "integ.status.connected": "Connected",
  "integ.status.not_connected": "Not connected",
  "integ.api_key": "API key",
  "integ.account_id": "Account ID",
  "integ.connect": "Save credentials",
  "integ.disconnect": "Disconnect",
  "integ.native": "Native",

  "team.title": "Team",
  "team.sub": "Admins configure the organization. Managers run leads, offers and onboarding. Sales handle leads and offers. Operations handle onboarding and launch.",
  "team.invite": "Add team member",
  "team.remove_confirm": "Remove this team member?",
  "role.admin": "Admin",
  "role.manager": "Manager",
  "role.sales": "Sales",
  "role.operations": "Operations",

  "pipe.title": "Pipeline stages",
  "pipe.sub": "Rename stages to match how your team talks. The order and logic stay the same.",
  "pipe.label": "Label for {key}",

  // Widget page (embed)
  "embed.open_full": "Continue",

  // Additions (admin surfaces)
  "settings.readonly": "You can view the configuration. Admins and managers can change it.",
  "branding.country": "Country",
  "templates.not_included": "Not included",
  "auto.skipped": "Automations are disabled — enable them and save first.",
  "integ.digihome_note": "DigiHome consumes Listed's canonical property schema natively. No credentials needed.",
  "integ.connect_native": "Connect",
  "integ.override_key": "Use own key",

  // PMS integrations (Settings → Integrations)
  "pms.section_title": "Property management systems",
  "pms.section_sub": "Connect the PMS where properties go live. Listed maps its canonical property record field by field and only reports a property as live when the PMS confirms it.",
  "pms.status.connected": "Connected",
  "pms.status.not_connected": "Not connected",
  "pms.status.link_only": "Link-only",
  "pms.cap.create": "Creates listings",
  "pms.cap.photos": "Sends photos",
  "pms.cap.test": "Connection test",
  "pms.cap.link": "Link existing",
  "pms.cap.readonly": "Read-only API",
  "pms.beta": "Beta",
  "pms.connect": "Connect",
  "pms.manage": "Manage",
  "pms.test": "Test connection",
  "pms.testing": "Testing…",
  "pms.disconnect": "Disconnect",
  "pms.disconnect_confirm": "Disconnect {provider}? Stored credentials are deleted. Properties already live are unaffected.",
  "pms.last_test": "Last test",
  "pms.never_tested": "Never tested",
  "pms.handoffs": "{n} live",
  "pms.handoffs_none": "No handoffs yet",
  "pms.connected_since": "Since {date}",
  "pms.readonly_role": "You can view the integrations. Admins connect and manage them.",
  "pms.revenue_title": "Revenue data",
  "pms.pricing_title": "Dynamic pricing",
  "pms.pricing_managed": "Managed by Listed",
  "pms.pricing_settings_note": "PriceLabs credentials are held by Listed. You enable pricing per property from the Launch tab; nothing is sent until Listed activates the sync for your organisation.",
  "pms.dialog.title": "Connect {provider}",
  "pms.dialog.where": "Where to find this",
  "pms.dialog.encrypted": "Stored encrypted. Never shown again in full.",
  "pms.dialog.keep_secret": "Leave blank to keep the stored value",
  "pms.dialog.test_first": "Test before saving",
  "pms.dialog.save": "Save & connect",
  "pms.dialog.saved_connected": "{provider} connected",
  "pms.dialog.saved_incomplete": "Saved — fill in every field to connect",
  "pms.dialog.test_ok": "Connection works",
  "pms.dialog.test_failed": "Connection failed",
  "pms.dialog.readonly_note": "{provider}'s public API is read-only for properties. Listed prepares a complete handover sheet; you create the property in {provider}, then link it here so Listed knows where it lives and marks it live.",
  "pms.dialog.help.guesty": "In Guesty: Integrations → Marketplace → Guesty Open API → create an application. Copy the Client ID and Client secret. Access tokens are minted server-side and cached — Guesty allows five per day.",
  "pms.dialog.help.hostaway": "In Hostaway: Settings → Hostaway API → Create. Copy your Account ID and the API key (shown once). Listed exchanges them for an access token on the server.",
  "pms.dialog.help.lodgify": "In Lodgify: Settings → Public API → generate a key. Listed uses it to read your properties so you can link the right one.",
  "pms.dialog.help.smoobu": "In Smoobu: Advanced → API Keys → create a key. If Smoobu issued a signing secret for the key, paste it too — requests are then HMAC-signed. Listed reads your apartments so you can link the right one.",
  "pms.dialog.help.beds24": "In Beds24: Settings → Apps & Integrations → API → generate an invite code with read/write access to properties. Paste it here — Listed exchanges it for a refresh token when you save (the code is single-use and never stored).",
  "pms.dialog.help.hostfully": "In Hostfully: Agency Settings → API key (Premium plans). Listed sends it as X-HOSTFULLY-APIKEY, detects your agency and creates properties as inactive drafts you activate after review.",
  "pms.dialog.help.uplisting": "In Uplisting: Connect → API. The API is invite-only — ask Uplisting support to enable it, then generate a key. Listed reads your properties so you can link the right one.",
  "pms.dialog.help.hospitable": "In Hospitable: Settings → Integrations → API access → create a personal access token with property read scope. Listed reads your properties and sees when they are listed on a channel.",
  "pms.dialog.help.digihome": "Enter the API key issued by DigiHome for your account. Until connected, every handover is prepared as a complete canonical package.",
  "pms.dialog.help.airdna": "AirDNA Enterprise → API access. Paste the Bearer key. A key here overrides the platform key for your organisation only.",

  // Launch → handoff to PMS
  "handoff.title": "Property system",
  "handoff.sub": "Where this property is listed and kept in sync. Live only when the system confirms it.",
  "wf.title": "{provider} workflow",
  "wf.sub": "When the property enters your PMS, what Listed keeps updated, and who makes it bookable. Listed never marks a property live before the PMS reports it.",
  "wf.create_at": "When does the property enter the PMS?",
  "wf.create_at_help": "Recommended: at signing — your team can set up channels and pricing in {provider} while the owner completes onboarding.",
  "wf.create_at_readonly": "{provider} cannot create properties via API. Listed prepares the handover; you create the property in {provider} and link it.",
  "wf.create_at.signed": "At signing",
  "wf.create_at.ready": "When ready",
  "wf.create_at.manual": "Manually",
  "wf.auto_sync": "Keep the PMS updated during onboarding",
  "wf.auto_sync_help": "Owner answers and photos are pushed to {provider} as they land. Only fields Listed owns — never price, calendar or channels.",
  "wf.auto_sync_readonly": "Not available for {provider}: the public API cannot update properties.",
  "wf.activation": "Who makes the listing bookable?",
  "wf.activation_help": "Activate from Listed when the property is ready, or inside {provider}.",
  "wf.activation_readonly": "{provider} has no activation API. Publish inside {provider}; Listed checks every 15 minutes and marks the property live.",
  "wf.activation.listed": "From Listed",
  "wf.activation.pms": "Inside {provider}",
  "wf.auto_activate": "Activate automatically when ready",
  "wf.auto_activate_help": "The moment every launch blocker is resolved, Listed activates the listing in {provider} without a click. Off by default.",
  "wf.live_rule_label": "Live means:",
  "wf.notify_owner": "E-mail the owner when the property goes live",
  "wf.notify_owner_help": "Sent in your name, with links to the live listing where the PMS provides them.",
  "pms.live.kicker": "In {provider}",
  "pms.live.sync_label": "Sync",
  "pms.live.photos_label": "Photos in system",
  "pms.live.price_label": "Nightly price in system",
  "pms.live.checked_label": "Status checked",
  "pms.live.channels_label": "Channels",
  "pms.live.state.draft": "Draft in PMS",
  "pms.live.state.live": "Live",
  "pms.live.state.unknown": "Linked — awaiting status",
  "pms.live.synced_at": "Synced {when}",
  "pms.live.never_synced": "Not synced yet",
  "pms.live.sync_error": "Last sync failed",
  "pms.live.pending": "{n} pending",
  "pms.live.in_sync": "In sync",
  "pms.live.photos_in": "{n} photo(s) in {provider}",
  "pms.live.price_in": "Price in {provider}: {price}",
  "pms.live.checked_at": "Status checked {when}",
  "pms.live.activate_hint_ready": "Everything is ready — you can activate from here.",
  "pms.live.activate_hint_blocked": "Activation opens when the {n} remaining launch blocker(s) are resolved.",
  "pms.live.activate_in_pms": "Activate the listing inside {provider}; Listed checks every 15 minutes and marks it live.",
  "pms.live.activation_requested": "Activation requested {when} by {by}",
  "pms.live.activate": "Activate in {provider}",
  "pms.live.sync_now": "Sync now",
  "pms.live.refresh": "Check status",
  "pms.live.mapping": "What was sent",
  "pms.live.mark_live_link": "Already live in {provider}? Confirm manually",
  "pms.live.mark_live_explain": "Use this only if {provider} does not expose the status. The confirmation is logged with your name.",
  "pms.live.mark_live_note_ph": "Optional note, e.g. published on Airbnb 12 Sept",
  "pms.live.mark_live": "Confirm live",
  "pms.live.marked_live": "Marked as live",
  "pms.live.live_manual": "Confirmed live manually by {by} · {when}",
  "pms.live.live_observed": "Reported live by {provider} · {when}",
  "pms.live.synced_n": "{n} field(s) synced to {provider}",
  "pms.live.nothing_to_sync": "Everything is already in sync with {provider}",
  "pms.live.now_live": "{provider} reports the listing live",
  "pms.live.checked": "Status refreshed from {provider}",
  "pms.live.activation_sent": "Activation requested in {provider}",
  "handoff.choose": "Choose PMS",
  "handoff.review": "Review & push",
  "handoff.review_create": "Review & create in {provider}",
  "handoff.none_available": "No property system is set up yet.",
  "handoff.step.complete": "Complete the listing",
  "handoff.step.send": "Send to {provider}",
  "handoff.step.create": "Create in {provider}",
  "handoff.missing_for": "Still missing for {provider}",
  "handoff.summary_sub": "{n} details ready · {m} need attention",
  "handoff.ready_count": "details ready",
  "handoff.unsaved": "Unsaved changes",
  "handoff.technical": "Technical details",
  "handoff.tech.pms_field": "Field in PMS",
  "handoff.tech.source": "Source in Listed",
  "handoff.link_only_short": "Create the property in {provider}, then link it here.",
  "handoff.connect_first_short": "Not connected — the handover is prepared and stored.",
  "handoff.review_prepare": "Review handover",
  "handoff.connect_first": "Not connected yet — you can still review and prepare the handover.",
  "handoff.link_only_note": "{provider} cannot create properties from Listed. Review the handover, create the property in {provider}, then link it here.",
  "handoff.blocked": "Resolve the {n} launch blocker(s) before pushing.",
  "handoff.not_signed": "The property is created in the PMS once the owner has signed the agreement.",
  "handoff.draft_note": "{n} launch blocker(s) remain — the draft can still be created now; activation waits until the property is ready.",
  "handoff.wf.signed": "Created automatically in {provider} as a draft when the owner signs.",
  "handoff.wf.signed_pending": "Not in {provider} yet — create the draft now, or it is created at the next sync.",
  "handoff.wf.ready": "Created automatically in {provider} when every launch blocker is resolved.",
  "handoff.wf.manual": "Created in {provider} only when you choose to.",
  "handoff.wf.change": "Change",
  "handoff.history": "History",
  "handoff.attempts": "{n} attempts",
  "handoff.open_in": "Open in {provider}",
  "handoff.retry": "Retry",
  "handoff.link_existing": "Link existing",
  "handoff.view_payload": "View payload",
  "handoff.linked": "Linked to {provider}",
  "handoff.status.pushed": "Created",
  "handoff.status.linked": "Linked",
  "handoff.status.prepared": "Prepared",
  "handoff.status.failed": "Failed",
  "handoff.photos_sent": "{sent} photo(s) sent",
  "handoff.photos_failed": "{n} failed",
  "handoff.dialog.title": "Handover to {provider}",
  "handoff.dialog.settings": "Listing settings",
  "handoff.dialog.settings_sub": "Listing details the owner does not provide. Saved on the property and reused for every system.",
  "handoff.dialog.mapping": "What {provider} receives",
  "handoff.dialog.mapping_sub": "What {provider} receives",
  "handoff.dialog.field_title": "Listing title",
  "handoff.dialog.field_summary": "Public description",
  "handoff.dialog.field_base_price": "Nightly base price",
  "handoff.dialog.field_currency": "Currency",
  "handoff.dialog.field_cleaning": "Cleaning fee",
  "handoff.dialog.field_min_nights": "Minimum nights",
  "handoff.dialog.field_check_in": "Check-in",
  "handoff.dialog.field_check_out": "Check-out",
  "handoff.dialog.use_suggested": "Use {amount}",
  "handoff.dialog.suggested_from": "Suggested from {source}",
  "handoff.dialog.suggested": "Suggested from your revenue estimate",
  "handoff.dialog.save_settings": "Save settings",
  "handoff.dialog.blockers": "Required by {provider} and still missing",
  "handoff.dialog.counts.ok": "{n} mapped",
  "handoff.dialog.counts.defaulted": "{n} defaults",
  "handoff.dialog.counts.missing": "{n} missing",
  "handoff.dialog.counts.blocker": "{n} blocking",
  "handoff.dialog.counts.unsupported": "{n} not supported",
  "handoff.dialog.counts.skipped": "{n} withheld",
  "handoff.dialog.photos": "{n} photo(s)",
  "handoff.dialog.push": "Create draft in {provider}",
  "handoff.dialog.pushing": "Creating…",
  "handoff.dialog.prepare": "Prepare handover",
  "handoff.dialog.copy_sheet": "Copy as text",
  "handoff.dialog.result.pushed": "{provider} created the draft",
  "handoff.dialog.result.prepared": "Handover prepared",
  "handoff.dialog.result.failed": "{provider} did not accept the listing",
  "handoff.dialog.hidden_draft": "Created as a hidden draft in {provider}. Onboarding answers keep syncing; it is marked live when {provider} reports it bookable.",
  "handoff.section.listing": "Listing",
  "handoff.section.address": "Address",
  "handoff.section.description": "Description",
  "handoff.section.pricing": "Pricing",
  "handoff.section.terms": "Terms",
  "handoff.section.media": "Media",
  "handoff.section.guest_info": "Guest information",
  "handoff.mstatus.ok": "Mapped",
  "handoff.mstatus.defaulted": "Default",
  "handoff.mstatus.missing": "Missing",
  "handoff.mstatus.blocker": "Required",
  "handoff.mstatus.unsupported": "Not supported",
  "handoff.mstatus.skipped": "Kept in Listed",
  "handoff.link.title": "Link existing {provider} property",
  "handoff.link.sub": "Pick the property you created in {provider}, or paste its id. Listed stores the reference and marks the property live.",
  "handoff.link.pick": "Your {provider} properties",
  "handoff.link.search": "Search name, address or id",
  "handoff.link.suggested": "Suggested match",
  "handoff.link.inactive": "Inactive",
  "handoff.link.unnamed": "Unnamed property",
  "handoff.link.cant_find": "Can't find it? Paste the property id instead",
  "handoff.link.manual": "Property id",
  "handoff.link.manual_hint": "The number in the property URL in {provider} — e.g. …/properties/123456.",
  "handoff.link.manual_ph": "123456",
  "handoff.link.choose": "Choose a property to link",
  "handoff.link.will_link": "Will link to {name}",
  "handoff.link.will_link_id": "Will link to property #{id}",
  "handoff.link.no_results": "Nothing matches your search.",
  "handoff.link.submit": "Link & mark live",
  "handoff.link.none": "No properties visible in {provider} yet.",
  "handoff.link.none_hint": "Create the property in {provider} using the handover sheet, then come back and link it.",

  // Dynamic pricing (foundation)
  "dp.title": "Dynamic pricing",
  "dp.managed": "Managed by Listed · PriceLabs",
  "dp.sub": "Set the nightly guardrails now. Pricing activates once the property is live and Listed switches on the sync.",
  "dp.status.not_started": "Not enabled",
  "dp.status.ready": "Ready — activates when live",
  "dp.status.waiting_platform": "Waiting for Listed",
  "dp.status.queued": "Queued for sync",
  "dp.status.syncing": "Syncing",
  "dp.status.active": "Active",
  "dp.enable": "Enable dynamic pricing when live",
  "dp.strategy": "Strategy",
  "dp.strategy.conservative": "Conservative",
  "dp.strategy.balanced": "Balanced",
  "dp.strategy.aggressive": "Aggressive",
  "dp.strategy_help.conservative": "Higher occupancy, gentler peaks.",
  "dp.strategy_help.balanced": "Market-following rates with seasonal peaks.",
  "dp.strategy_help.aggressive": "Maximise rate on high-demand dates.",
  "dp.min": "Floor",
  "dp.base": "Base",
  "dp.max": "Ceiling",
  "dp.per_night": "per night",
  "dp.reset": "Reset to suggested",
  "dp.save": "Save pricing profile",
  "dp.saved": "Pricing profile saved",
  "dp.foundation_note": "Credentials are held by Listed — nothing is sent to PriceLabs from your account.",

  // HQ · dynamic pricing
  "hq.dp.title": "Dynamic pricing",
  "hq.dp.sub": "Listed owns the PriceLabs key. Tenants only set per-property guardrails; the sync itself is switched on here.",
  "hq.dp.phase": "foundation, no sync yet",
  "hq.dp.key_ready": "Key ready",
  "hq.dp.key_missing_short": "No key",
  "hq.dp.key_missing": "Add and test the key in the PriceLabs card first — the switch stays off until then.",
  "hq.dp.master": "Enable PriceLabs sync",
  "hq.dp.rollout": "Rollout",
  "hq.dp.rollout.none": "No organisations",
  "hq.dp.rollout.selected": "Selected organisations",
  "hq.dp.rollout.all": "All organisations",
  "hq.dp.default_strategy": "Default strategy",
  "hq.dp.min_pct": "Floor × base",
  "hq.dp.max_pct": "Ceiling × base",
  "hq.dp.profiles": "{n} opted in",
  "hq.dp.profiles_live": "{n} live",
  "hq.dp.save": "Save",
  "hq.integ.platform_only": "Platform-owned — never exposed to tenants",
  "lead.delete_confirm": "Delete this lead permanently? Offers, contracts and onboarding data stay in the database but the lead disappears from the pipeline.",
  "common.versions": "Versions",
  "lead.beds": "Beds",
  "lead.size": "Size (m²)",
  "lead.listing_platform": "Platform",
  "lead.listing_id": "Listing ID",
  "lead.sign_method": "Method",
  "team.you": "You",
  "team.since": "Joined {date}",
  "services.inactive": "Inactive",
  "auto.short": "Auto",
  "onbt.placeholder": "Placeholder",
  "onbt.condition_prefix": "if",

  // Landing page (marketing)
  "lp.nav.product": "Product",
  "lp.nav.journey": "How it works",
  "lp.nav.whitelabel": "White-label",
  "lp.nav.integrations": "Integrations",
  "lp.nav.pricing": "Pricing",
  "lp.nav.features": "Features",
  "lp.login": "Log in",
  "lp.cta_start": "Get started",
  "lp.menu": "Menu",
  "lp.hero.badge": "V1 · Built by DigiHome in Bergen",
  "lp.hero.title_a": "Win the owner.",
  "lp.hero.title_b": "Launch the property.",
  "lp.hero.sub": "Listed is the acquisition and launch engine for property managers. One journey — from the address an owner types on your website to a signed agreement and a property that is ready in your PMS.",
  "lp.hero.try_label": "Live demo — the widget your owners see",
  "lp.hero.try_note": "Demo tenant Northstay. Addresses verified with Google Maps. Nothing reaches a real company.",
  "lp.hero.card_accepted": "Offer accepted",
  "lp.hero.card_accepted_sub": "Rua da Prata 42 · 15% Full Service",
  "lp.hero.card_onboarding": "Onboarding",
  "lp.hero.card_ready": "Ready to launch",
  "lp.hero.card_wifi": "Wi-Fi read from router photo",
  "lp.ticker.label": "One journey",

  "lp.journey.eyebrow": "How it works",
  "lp.journey.title": "Eight steps. One record. Nothing typed twice.",
  "lp.journey.sub": "What an owner tells you once is carried through the whole journey — into the offer, the agreement, the onboarding and finally the PMS record.",
  "lp.journey.step": "Step",
  "lp.step.embed.title": "Embed",
  "lp.step.embed.text": "One line of script puts your branded widget on any website. Address or listing link in.",
  "lp.step.lead.title": "Lead",
  "lp.step.lead.text": "Verified address, listing detection and a two-minute intake on the owner's phone.",
  "lp.step.crm.title": "Qualify",
  "lp.step.crm.text": "AI reads the lead, drafts a summary and suggests an offer template. You edit. You decide.",
  "lp.step.offer.title": "Offer",
  "lp.step.offer.text": "Services with live pricing, sent as a branded web page. Not a PDF.",
  "lp.step.accept.title": "Accept",
  "lp.step.accept.text": "The owner toggles options and accepts on their phone. The summary updates as they go.",
  "lp.step.sign.title": "Sign",
  "lp.step.sign.text": "Listed-native e-signature — typed or drawn — with timestamp, IP and document fingerprint.",
  "lp.step.onboard.title": "Onboard",
  "lp.step.onboard.text": "A guided walk through the property. A photo of the router becomes Wi-Fi credentials.",
  "lp.step.ready.title": "Launch",
  "lp.step.ready.text": "Blockers resolved, canonical record complete, payload prepared for your PMS.",

  "lp.show.eyebrow": "Product",
  "lp.show.title": "Four surfaces. One property record.",
  "lp.show.sub": "Owners get a journey on their phone. Your team gets a pipeline on the desktop. Both write to the same record.",
  "lp.show.capture.eyebrow": "Capture",
  "lp.show.capture.title": "Your website becomes the top of the funnel.",
  "lp.show.capture.text": "Owners type an address or paste an Airbnb link. Listed verifies it, detects the platform and asks only what it does not already know — one question per screen.",
  "lp.show.capture.b1": "Addresses verified with Google Maps, with OpenStreetMap as fallback",
  "lp.show.capture.b2": "Airbnb, Booking.com and VRBO links recognised — never a gate",
  "lp.show.capture.b3": "Optional photo upload for a sharper estimate",
  "lp.show.offer.eyebrow": "Offer",
  "lp.show.offer.title": "An offer the owner can play with.",
  "lp.show.offer.text": "Build from your catalogue with required, included and optional services. The owner opens a branded page where toggling a service updates the summary — and accepts with one tap.",
  "lp.show.offer.b1": "Templates suggested per property type and rental plan",
  "lp.show.offer.b2": "Live preview of exactly what the owner sees",
  "lp.show.offer.b3": "Versioned — send a new version and the old one is superseded",
  "lp.show.onboard.eyebrow": "Onboarding",
  "lp.show.onboard.title": "Walk through the home. Listed fills in the record.",
  "lp.show.onboard.text": "Access, Wi-Fi, parking, utilities, safety, house rules. A photo of the router becomes network name and password. Free text becomes structured fields. Everything stays a suggestion until the owner confirms.",
  "lp.show.onboard.b1": "Camera-first uploads with instant AI reading",
  "lp.show.onboard.b2": "Secure fields for codes and passwords",
  "lp.show.onboard.b3": "Progress the owner can pause and resume",
  "lp.show.launch.eyebrow": "Launch",
  "lp.show.launch.title": "Nothing goes live with a blocker open.",
  "lp.show.launch.text": "Owner answers and internal tasks roll up into one readiness score. At 100, Listed maps the canonical record to your PMS format and prepares the payload.",
  "lp.show.launch.b1": "Blocking and non-blocking items, for owner and team",
  "lp.show.launch.b2": "Internal task checklist created automatically at signing",
  "lp.show.launch.b3": "Adapters for DigiHome, Guesty, Lodgify and Hostaway",

  "lp.break.title": "Built in Bergen. Ready for any market.",
  "lp.break.sub": "V1 ships with Norwegian address infrastructure. Every vendor — address, AI, email, signing, PMS — sits behind an adapter, so the next market is configuration, not a rewrite.",

  "lp.wl.eyebrow": "White-label",
  "lp.wl.title": "Your brand on every owner screen.",
  "lp.wl.sub": "Logo, colour, sender name and domain. Owners never see Listed — they see you. Pick a colour to preview the offer page.",
  "lp.wl.try": "Try a brand colour",
  "lp.wl.standard": "Standard plan",
  "lp.wl.pro": "Pro · full white-label",
  "lp.wl.f1.title": "Brand tokens",
  "lp.wl.f1.text": "Primary colour, logo and favicon applied as CSS variables across every owner route.",
  "lp.wl.f2.title": "Custom domain",
  "lp.wl.f2.text": "Serve owner pages from owners.yourcompany.com on the Pro plan.",
  "lp.wl.f3.title": "Branded email",
  "lp.wl.f3.text": "Your sender name, your footer. Every email is logged to the Outbox and the lead timeline.",
  "lp.wl.f4.title": "Editable AI",
  "lp.wl.f4.text": "Summaries, drafts and extractions are suggestions in your voice — never sent without a human.",

  "lp.stats.intake.label": "minute intake",
  "lp.stats.intake.sub": "From address to submitted lead, on a phone",
  "lp.stats.steps.label": "steps, one journey",
  "lp.stats.steps.sub": "Lead to live in a single record",
  "lp.stats.web.label": "web-native",
  "lp.stats.web.sub": "No PDFs to download, print or scan",
  "lp.stats.schema.label": "property schema",
  "lp.stats.schema.sub": "Mapped to each PMS through adapters",

  "lp.arch.eyebrow": "Architecture",
  "lp.arch.title": "Every vendor behind an adapter.",
  "lp.arch.sub": "Listed owns the journey and the canonical property record. Address lookup, AI, email, signing, listing import and PMS are swappable providers — you are never locked in.",
  "lp.arch.schema_note": "one record, many targets",
  "lp.arch.footnote": "Dashed = available behind the same interface, not configured in V1.",
  "lp.arch.address": "Address lookup",
  "lp.arch.ai": "AI",
  "lp.arch.email": "Email",
  "lp.arch.signing": "E-signature",
  "lp.arch.listing": "Listing import",
  "lp.arch.pms": "PMS handoff",

  "lp.int.eyebrow": "Integrations",
  "lp.int.title": "Plays well with the stack you already run.",
  "lp.int.sub": "Listed owns the journey and one canonical property record. Every vendor around it — PMS, channels, address data, AI, signing, email — sits behind an adapter you can swap without touching the owner experience.",
  "lp.int.board.eyebrow": "PMS handoff",
  "lp.int.board.title": "One record. Any PMS.",
  "lp.int.board.sub": "When a property is launch-ready, Listed maps the record to your PMS through a provider adapter — no re-typing, no spreadsheets.",
  "lp.int.record.label": "Canonical record",
  "lp.int.record.complete": "complete",
  "lp.int.field.address": "Verified address",
  "lp.int.field.owner": "Owner & agreement",
  "lp.int.field.access": "Access & keys",
  "lp.int.field.wifi": "Wi-Fi",
  "lp.int.field.rules": "House rules",
  "lp.int.field.photos": "Photos & media",
  "lp.int.field.pricing": "Pricing & services",
  "lp.int.map": "Mapping",
  "lp.int.status.live": "Live",
  "lp.int.status.adapter": "Adapter ready",
  "lp.int.status.detect": "Detection",
  "lp.int.status.default": "Default",
  "lp.int.group.pms": "PMS handoff",
  "lp.int.group.pms_sub": "Push the launch-ready record straight into your property management system.",
  "lp.int.group.channels": "Listing channels",
  "lp.int.group.channels_sub": "Paste a listing URL and Listed detects the platform and imports what it can — never blocking the owner.",
  "lp.int.group.data": "Data & intelligence",
  "lp.int.group.data_sub": "Authoritative Norwegian addresses with a global fallback, and AI that suggests — never decides.",
  "lp.int.legend.live": "Live in V1",
  "lp.int.legend.adapter": "Behind the same adapter — enable when you need it",
  "lp.int.more": "Signing, email and storage follow the same pattern: Listed-native today, Scrive, Signicat, Resend or SendGrid tomorrow.",
  "lp.int.request": "Request an integration",

  "lp.cta.title": "Stop losing owners between the first email and the signed agreement.",
  "lp.cta.sub": "Create your organization and start from a ready service catalogue, offer template and onboarding template. Or open the demo tenant first.",
  "lp.cta.primary": "Create organization",

  "lp.footer.product": "Product",
  "lp.footer.company": "Company",
  "lp.footer.legal": "Legal",
  "legal.privacy": "Privacy policy",
  "legal.terms": "Terms of service",
  "legal.cookie_settings": "Cookie settings",
  "legal.updated": "Last updated",
  "legal.draft_badge": "{version} · pending legal review",
  "legal.draft_note": "This text is a working draft prepared by the Listed team. It describes how the platform is built to work and is published for transparency while it is reviewed by legal counsel. Wording may change before the commercial launch; the date above shows the current version.",
  "legal.print": "Print",
  "legal.contents": "Contents",
  "legal.related": "Related",
  "legal.related_terms": "The terms that apply to property managers using Listed.",
  "legal.related_privacy": "How we handle personal data — for managers, owners and visitors.",
  "legal.questions": "Questions about these documents?",
  "legal.agree_prefix": "By creating a workspace you agree to the",
  "legal.and": "and",
  "legal.privacy_short": "Privacy",
  "legal.terms_short": "Terms",
  "consent.title": "Cookies, briefly",
  "consent.settings_title": "Cookie settings",
  "consent.text": "We use one privacy-focused analytics tool to see which pages are used and where people get stuck. No advertising, no selling of data. Strictly necessary storage is always on.",
  "consent.accept": "Accept analytics",
  "consent.reject": "Only necessary",
  "consent.save": "Save choice",
  "consent.always_on": "Always on",
  "consent.cat.necessary": "Strictly necessary",
  "consent.cat.necessary_sub": "Sign-in, preferences and this choice.",
  "consent.cat.analytics": "Analytics",
  "consent.cat.analytics_sub": "Page views and interactions, so we can improve Listed.",
  "lp.footer.digihome": "DigiHome.no",
  "lp.footer.status": "Status",
  "lp.footer.operational": "All systems operational",
  "lp.footer.tagline": "Acquisition and launch infrastructure for property managers. Built by DigiHome in Bergen.",
  "lp.footer.version": "V1 · English UI · Norwegian address data",

  // Landing V3 — hero stage (cinematic product animation)
  "lp.hero.kicker": "Built for property managers",
  "lp.hero.title": "From owner lead to live property.",
  "lp.hero.sub2": "Listed runs the whole journey — proposal, signature, onboarding and the handoff to your PMS — as one continuous flow. One property, one record, nothing typed twice.",
  "lp.hero.stage.label": "Product preview — one property, start to finish",
  "lp.hero.stage.replay": "Replay",
  "lp.hero.stage.pause": "Pause",
  "lp.hero.stage.play": "Play",
  "lp.hero.stage.address": "Address",
  "lp.hero.stage.property": "Property",
  "lp.hero.stage.proposal": "Proposal",
  "lp.hero.stage.sign": "Signed",
  "lp.hero.stage.ready": "Ready",
  "lp.hero.stage.live": "Live",
  "lp.hero.stage.typed": "Rua da Prata 42, Lisbon",
  "lp.hero.stage.placeholder": "Enter your address",
  "lp.hero.stage.verified": "Verified",
  "lp.hero.stage.city": "1100-420 Lisbon",
  "lp.hero.stage.meta": "Apartment · 3 bed · 92 m²",
  "lp.hero.stage.owner": "Emma Carter",
  "lp.hero.stage.owner_role": "Owner",
  "lp.hero.stage.created": "Property created",
  "lp.hero.stage.plan": "Full Service management",
  "lp.hero.stage.plan_fee": "15%",
  "lp.hero.stage.photo": "Professional photography",
  "lp.hero.stage.photo_price": "€490",
  "lp.hero.stage.sent": "Proposal sent",
  "lp.hero.stage.opened": "Opened by owner",
  "lp.hero.stage.sign_title": "Agreement",
  "lp.hero.stage.signed": "Signed by Emma Carter",
  "lp.hero.stage.signed_time": "14:32 · e-signature",
  "lp.hero.stage.ready_title": "Launch readiness",
  "lp.hero.stage.ready_label": "Launch-ready",
  "lp.hero.stage.chk_access": "Access & keys",
  "lp.hero.stage.chk_wifi": "Wi-Fi",
  "lp.hero.stage.chk_rules": "House rules",
  "lp.hero.stage.chk_photos": "Photos",
  "lp.hero.stage.live_label": "Live",
  "lp.hero.stage.pms": "Created in",
  "lp.hero.stage.channels": "Listed on",
  "lp.hero.stage.days": "2 days from lead to live",
  "lp.hero.stage.sugg_city": "1100-420 Lisbon · Google Maps",
  "lp.hero.stage.toast.property": "Lead qualified · AI summary ready",
  "lp.hero.stage.toast.proposal": "Emma opened the proposal · 2 min",
  "lp.hero.stage.toast.sign": "Agreement v2 · fingerprint 8f3a…c1",
  "lp.hero.stage.toast.ready": "Internal tasks 4/4 · no blockers",
  "lp.hero.stage.toast.live": "Created in Guesty · distributed",
  "lp.hero.stage.owner_confirms": "Owner confirms every AI suggestion",

  // Landing V3 — integrations handoff demo
  "lp.int.handoff.eyebrow": "PMS handoff",
  "lp.int.handoff.title": "One record. Any PMS.",
  "lp.int.handoff.sub": "When a property is launch-ready, Listed maps the canonical record to the format your PMS expects and creates the property — no re-typing, no spreadsheets. Pick a target to see the mapping.",
  "lp.int.handoff.record": "Canonical record",
  "lp.int.handoff.target": "Target",
  "lp.int.handoff.native": "Consumed natively — no mapping needed",
  "lp.int.handoff.create": "Create in {pms}",
  "lp.int.handoff.auto": "Auto-cycling · click a PMS to pin",
  "lp.int.handoff.pinned": "Pinned · click again to resume",
  "lp.int.hub.packets": "Owner answers flowing to your stack",

  // Landing V3 — journey (scroll-driven story around one property)
  "lp.jr.eyebrow": "How it works",
  "lp.jr.title": "Follow one property through Listed.",
  "lp.jr.sub": "Rua da Prata 42 in Lisbon. Owner Emma Carter, manager Northstay. Scroll, and watch the same property move from a first enquiry to a live listing — without leaving the record.",
  "lp.jr.step": "Step",
  "lp.jr.day": "Day {n}",
  "lp.jr.lead.title": "An enquiry from your website.",
  "lp.jr.lead.text": "The owner enters an address on your site and receives an instant estimate. You receive a structured lead: verified address, owner contact and the property basics — in your pipeline within seconds.",
  "lp.jr.lead.caption": "Lead · northstay.com",
  "lp.jr.property.title": "A property record, not an email.",
  "lp.jr.property.text": "The lead becomes a property and an owner in your pipeline. Every answer is already a field, and Listed drafts a summary and suggests an offer template for your review. Nothing to re-type.",
  "lp.jr.property.caption": "Property · Listed pipeline",
  "lp.jr.proposal.title": "The offer, from your own catalogue.",
  "lp.jr.proposal.text": "Assemble management fee, photography and extras from your services and send it as a branded web page — not a PDF. You see the moment it is opened, adjusted and accepted.",
  "lp.jr.proposal.caption": "Proposal · sent",
  "lp.jr.sign.title": "Signed on the owner’s phone.",
  "lp.jr.sign.text": "The agreement carries the accepted terms. E-signed, timestamped and versioned — stored on the record, with a copy to both parties.",
  "lp.jr.sign.caption": "Agreement · signed",
  "lp.jr.onboarding.title": "Onboarding writes to the record.",
  "lp.jr.onboarding.text": "A guided walk through the home: access, Wi-Fi read from a photo of the router, house rules and photos. Every answer lands as a field — no second visit, no WhatsApp thread.",
  "lp.jr.onboarding.caption": "Onboarding · complete",
  "lp.jr.pms.title": "Created in your PMS.",
  "lp.jr.pms.text": "At 100% readiness, Listed creates the property in Guesty, Hostaway, Lodgify or DigiHome — mapped field by field. Nothing typed twice.",
  "lp.jr.pms.caption": "Handoff · Guesty",
  "lp.jr.live.title": "Live, two days after the first tap.",
  "lp.jr.live.text": "Distributed to Airbnb and Booking.com through your PMS. The record stays the source of truth — for this property, and for the next owner who lands on your website.",
  "lp.jr.live.caption": "Live · Airbnb, Booking.com",
  "lp.jr.stage.form_title": "What could your home earn?",
  "lp.jr.stage.form_sub": "A free estimate in seconds.",
  "lp.jr.stage.form_address": "Property address",
  "lp.jr.stage.form_beds": "Bedrooms",
  "lp.jr.stage.form_plan": "Rental plan",
  "lp.jr.stage.form_plan_value": "Full service",
  "lp.jr.stage.form_cta": "Get a free estimate",
  "lp.jr.stage.new_lead": "New lead",
  "lp.jr.stage.qualified": "Qualified",
  "lp.jr.stage.ai_summary": "AI summary",
  "lp.jr.stage.ai_text": "3-bed apartment in Baixa, Lisbon — 92 m², sleeps 6. Emma entered the details herself and wants full service from June.",
  "lp.jr.stage.detected": "Details from owner",
  "lp.jr.stage.estimate": "Estimate €42–48k",
  "lp.jr.stage.template": "Template · Full Service",
  "lp.jr.stage.send": "Send proposal",
  "lp.jr.stage.sent_opened": "Sent · opened 2 min later",
  "lp.jr.stage.total": "One-time",
  "lp.jr.stage.agreement_title": "Your agreement with Northstay",
  "lp.jr.stage.agreement_sub": "Full Service · 15% · Photography included",
  "lp.jr.stage.sign_here": "Sign here",
  "lp.jr.stage.signed_meta": "Signed · 14:32 · v2",
  "lp.jr.stage.onb_title": "Almost there, Emma",
  "lp.jr.stage.onb_wifi_note": "Read from router photo",
  "lp.jr.stage.onb_photos_note": "12 uploaded",
  "lp.jr.stage.onb_parking": "Parking",
  "lp.jr.stage.mapping": "Mapping",
  "lp.jr.stage.created_in": "Created in Guesty",
  "lp.jr.stage.pms_target": "guesty.listing",
  "lp.jr.stage.live_title": "Live",
  "lp.jr.stage.live_sub": "Bookable from today",
  "lp.jr.stage.listed": "Listed",
  "lp.jr.stage.first_booking": "First booking",
  "lp.jr.stage.first_booking_value": "Day 4",
  "lp.jr.stage.lead_to_live": "Lead to live",
  "lp.jr.stage.lead_to_live_value": "2 days",
  "lp.jr.stage.owner_ctx": "Owner surface",
  "lp.jr.stage.admin_ctx": "Listed admin",

  // Landing V3 — integrations hub
  "lp.int.hub.center": "Canonical property record",
  "lp.int.hub.kicker": "Adapter architecture",
  "lp.int.hub.title": "Listed in the middle. Your stack around it.",
  "lp.int.hub.record.title": "One record, many targets",
  "lp.int.hub.record.text": "Every owner answer lands in one property record — then maps to whichever PMS you run.",
  "lp.int.hub.adapter.title": "Vendors behind adapters",
  "lp.int.hub.adapter.text": "PMS, channels, address data, AI, signing, email. Swap one without touching the owner experience.",
  "lp.int.hub.swap.title": "Honest status",
  "lp.int.hub.swap.text": "Live in V1 today, adapter-ready tomorrow. We label the difference so you can plan.",

  // Landing V4 — quiet, product-first
  "l4.hero.title": "From owner lead to live listing.",
  "l4.hero.sub": "Listed takes every property from the owner’s first enquiry through offer, signature and onboarding — then hands it to your PMS. One record. Nothing typed twice.",
  "l4.hero.cta": "Get started",
  "l4.hero.demo": "See the owner journey",
  "l4.hero.hint": "Hover to pause · click a step to jump",
  "l4.frame.workspace": "{brand}",
  "l4.frame.nav.pipeline": "Pipeline",
  "l4.frame.nav.properties": "Properties",
  "l4.frame.nav.proposals": "Proposals",
  "l4.frame.nav.outbox": "Outbox",
  "l4.frame.nav.settings": "Settings",
  "l4.frame.crumb": "Pipeline",
  "l4.frame.address": "Rua da Prata 42",
  "l4.frame.city": "1100-420 Lisbon",
  "l4.frame.owner": "Emma Carter",
  "l4.frame.source": "via {domain}",
  "l4.frame.facts": "Property",
  "l4.frame.fact.type": "Type",
  "l4.frame.fact.type_v": "Apartment · 92 m²",
  "l4.frame.fact.beds": "Bedrooms",
  "l4.frame.fact.beds_v": "3 · sleeps 6",
  "l4.frame.fact.listing": "Existing listing",
  "l4.frame.fact.listing_v": "Full year · from June",
  "l4.frame.fact.estimate": "Revenue estimate",
  "l4.frame.fact.estimate_v": "€42–48k / yr",
  "l4.frame.fact.plan": "Rental plan",
  "l4.frame.fact.plan_v": "Full service · from June",
  "l4.frame.owner_h": "Owner",
  "l4.frame.owner_email": "emma.carter@mail.com",
  "l4.frame.owner_phone": "+351 9•• ••• •••",
  "l4.frame.activity": "Activity",
  "l4.frame.act.lead": "Lead received via northstay.com",
  "l4.frame.act.property": "Address verified · details confirmed by owner",
  "l4.frame.act.proposal": "Proposal v1 sent · opened 2 min later",
  "l4.frame.act.signed": "Agreement signed by Emma Carter",
  "l4.frame.act.ready": "Onboarding complete · 0 blockers",
  "l4.frame.act.live": "Created in Guesty · distributed",
  "l4.frame.status.lead": "New lead",
  "l4.frame.status.property": "Qualified",
  "l4.frame.status.proposal": "Proposal sent",
  "l4.frame.status.signed": "Signed",
  "l4.frame.status.ready": "Launch-ready",
  "l4.frame.status.live": "Live",
  "l4.frame.step.lead": "New lead",
  "l4.frame.step.property": "Property",
  "l4.frame.step.proposal": "Proposal",
  "l4.frame.step.signed": "Signed",
  "l4.frame.step.ready": "Launch-ready",
  "l4.frame.step.live": "Live",
  "l4.frame.lead.title": "Lead intake",
  "l4.frame.lead.address": "Address",
  "l4.frame.lead.verifying": "Verifying with Google Maps…",
  "l4.frame.lead.verified": "Verified · Google Maps",
  "l4.frame.lead.owner": "Owner",
  "l4.frame.lead.plan": "Wants",
  "l4.frame.lead.plan_v": "Full service, from June",
  "l4.frame.lead.note": "Owner note",
  "l4.frame.lead.note_v": "“Currently on Airbnb myself — too much work alongside my job.”",
  "l4.frame.property.title": "Summary",
  "l4.frame.property.tag": "Drafted for your review",
  "l4.frame.property.text": "3-bed apartment in Baixa, Lisbon — 92 m², sleeps 6. Emma entered the details herself and wants full service from June. Good fit for the Full Service template.",
  "l4.frame.property.fit": "Fit 9/10",
  "l4.frame.property.suggest": "Suggested template",
  "l4.frame.property.suggest_v": "Full Service",
  "l4.frame.property.action": "Create proposal",
  "l4.frame.proposal.title": "Proposal v1",
  "l4.frame.proposal.row1": "Full Service management",
  "l4.frame.proposal.row1_v": "15% of revenue",
  "l4.frame.proposal.row2": "Professional photography",
  "l4.frame.proposal.row2_v": "€490",
  "l4.frame.proposal.row3": "Interior styling",
  "l4.frame.proposal.row3_v": "€1,200",
  "l4.frame.proposal.sent": "Sent 09:14",
  "l4.frame.proposal.opened": "Opened 09:16",
  "l4.frame.proposal.viewing": "Emma is viewing the proposal",
  "l4.frame.signed.title": "Agreement",
  "l4.frame.signed.version": "v2 · Full Service · Photography",
  "l4.frame.signed.by": "Signed by Emma Carter",
  "l4.frame.signed.meta": "14:32 · e-signature · v2",
  "l4.frame.ready.title": "Launch readiness",
  "l4.frame.ready.i1": "Access & keys",
  "l4.frame.ready.i2": "Wi-Fi — read from router photo",
  "l4.frame.ready.i3": "House rules",
  "l4.frame.ready.i4": "Photos · 12 uploaded",
  "l4.frame.ready.i5": "Internal tasks 4/4",
  "l4.frame.ready.pct": "complete",
  "l4.frame.live.title": "Handoff",
  "l4.frame.live.created": "Created in",
  "l4.frame.live.channels": "Distributed to",
  "l4.frame.live.kpi1": "Lead to live",
  "l4.frame.live.kpi1_v": "2 days",
  "l4.frame.live.kpi2": "First booking",
  "l4.frame.live.kpi2_v": "Day 4",
  "l4.trust.label": "Hands off to your PMS. Distributes through your channels.",
  // Hero narrative — two surfaces, seven scenes
  "l4.h.surface.phone": "Owner · phone",
  "l4.h.surface.desktop": "You · Listed",
  "l4.h.step.capture": "Owner enquiry",
  "l4.h.step.lead": "Lead",
  "l4.h.step.qualify": "Qualified",
  "l4.h.step.proposal": "Proposal",
  "l4.h.step.sign": "Signed",
  "l4.h.step.onboard": "Onboarding",
  "l4.h.step.live": "Live",
  "l4.h.cap.capture": "Emma enters her address on northstay.com. Google Maps verifies it as she types.",
  "l4.h.cap.lead": "The lead lands in your pipeline — address, owner and intent already structured.",
  "l4.h.cap.qualify": "Her address and details become a structured property record, with a drafted summary for your review.",
  "l4.h.cap.proposal": "You build the proposal from your service catalogue and send it as a branded page — not a PDF.",
  "l4.h.cap.sign": "Emma picks her options and signs on her phone. Timestamped, fingerprinted, versioned.",
  "l4.h.cap.onboard": "She completes onboarding on her phone. A photo of the router becomes the Wi-Fi credentials.",
  "l4.h.cap.live": "At 100% readiness, Listed creates the property in Guesty. Live on Airbnb and Booking.com.",
  "l4.h.ph.site_title": "What could your home earn?",
  "l4.h.ph.site_sub": "A free estimate in seconds. A tailored proposal within a day.",
  "l4.h.ph.address_label": "Your address",
  "l4.h.ph.placeholder": "Street and number",
  "l4.h.ph.sugg_meta": "1100-420 Lisbon · Google Maps",
  "l4.h.ph.cta": "Get a free estimate",
  "l4.h.ph.thanks_title": "Thanks, Emma.",
  "l4.h.ph.thanks_sub": "Northstay has your details and will send a proposal within a day.",
  "l4.h.ph.thanks_meta": "Rua da Prata 42 · 3 bedrooms · Full service",
  "l4.h.ph.notif": "New proposal from Northstay",
  "l4.h.ph.notif_sub": "Rua da Prata 42 · Full Service · 15%",
  "l4.h.ph.prop_title": "Your proposal",
  "l4.h.ph.prop_sub": "Rua da Prata 42 · from Northstay",
  "l4.h.ph.accept": "Accept and sign",
  "l4.h.ph.sign_here": "Sign here",
  "l4.h.ph.signed": "Signed · 14:32",
  "l4.h.ph.signing": "Emma is signing…",
  "l4.h.ph.onb_title": "Almost there, Emma",
  "l4.h.ph.onb_sub": "Five things before we go live.",
  "l4.h.ph.wifi_read": "Read from photo",
  "l4.h.ph.live_title": "Rua da Prata 42 is live",
  "l4.h.ph.live_sub": "Bookable on Airbnb and Booking.com from today.",
  "l4.h.board.new": "New",
  "l4.h.board.qualified": "Qualified",
  "l4.h.board.proposal": "Offer sent",
  "l4.h.board.signed": "Signed",
  "l4.h.board.just_now": "just now",
  "l4.h.rec.awaiting": "Awaiting owner signature",
  "l4.h.rec.onb_progress": "Owner onboarding in progress",
  "l4.h.rec.act.qualify": "Address verified · details confirmed · summary drafted",
  "l4.h.rec.act.live": "Created in Guesty · live on 2 channels",
  "l4.jr.eyebrow": "One record",
  "l4.jr.title": "One property record, start to finish.",
  "l4.jr.sub": "Rua da Prata 42 in Lisbon. Owner Emma Carter, manager Northstay. Scroll to follow the same record from first enquiry to live listing.",
  "l4.jr.owner_ctx": "Owner · {domain}",
  "l4.jr.admin_ctx": "You · Listed",
  "l4.jr.sub2": "Every step writes to the same record — the one that ends up in your PMS. Scroll, and watch Rua da Prata 42 fill in from first enquiry to live listing.",
  "l4.jr.writes": "Writes to the record",
  "l4.jr.pending": "Not yet written",
  "l4.jr.written": "{n} of {total} sections written",
  "l4.jr.record": "Property record",
  "l4.jr.sec.lead.title": "Address & estimate",
  "l4.jr.sec.lead.summary": "Rua da Prata 42, Lisbon · €42–48k",
  "l4.jr.sec.property.title": "Owner & listing",
  "l4.jr.sec.property.summary": "Emma Carter · 3 bedrooms · from June",
  "l4.jr.sec.proposal.title": "Proposal v1",
  "l4.jr.sec.proposal.summary": "Full Service 15% · Photography · opened",
  "l4.jr.sec.sign.title": "Agreement v2",
  "l4.jr.sec.sign.summary": "Signed 14:32 · version 2",
  "l4.jr.sec.onboarding.title": "Onboarding",
  "l4.jr.sec.onboarding.summary": "Access · Wi-Fi · Rules · 12 photos · Parking",
  "l4.jr.sec.pms.title": "Handoff",
  "l4.jr.sec.pms.summary": "Created in Guesty · 6 fields",
  "l4.jr.sec.live.title": "Distribution",
  "l4.jr.sec.live.summary": "Airbnb · Booking.com · live",
  "l4.jr.w.lead": "Address · Owner · Estimate",
  "l4.jr.w.property": "Listing · Type · Summary",
  "l4.jr.w.proposal": "Services · Pricing · Delivery",
  "l4.jr.w.sign": "Signature · Audit trail · Version",
  "l4.jr.w.onboarding": "Access · Wi-Fi · Rules · Photos",
  "l4.jr.w.pms": "Guesty property · 6 fields",
  "l4.jr.w.live": "Channels · Dates",
  "l4.jr.r.source": "Source",
  "l4.jr.r.address": "Address",
  "l4.jr.r.owner": "Owner",
  "l4.jr.r.wants": "Wants",
  "l4.jr.r.bedrooms": "Bedrooms",
  "l4.jr.r.note": "Note",
  "l4.jr.r.listing": "Listing",
  "l4.jr.r.type": "Type",
  "l4.jr.r.estimate": "Estimate",
  "l4.jr.r.estimate_v": "€42–48k / yr · medium confidence",
  "l4.jr.r.summary": "Summary",
  "l4.jr.r.reviewed": "Reviewed by Sarah",
  "l4.jr.r.sent": "Sent 09:14",
  "l4.jr.r.opened": "Opened by Emma 09:16",
  "l4.jr.r.signed_by": "Signed by Emma Carter",
  "l4.jr.r.signed_meta": "14:32 · e-signature · v2",
  "l4.jr.r.fingerprint": "SHA-256",
  "l4.jr.r.access": "Access",
  "l4.jr.r.access_v": "Key box by the door · code ••••",
  "l4.jr.r.wifi": "Wi-Fi",
  "l4.jr.r.wifi_v": "Northstay-Guest · ••••••••",
  "l4.jr.r.from_photo": "from router photo",
  "l4.jr.r.rules": "House rules",
  "l4.jr.r.rules_v": "No parties · quiet 22–07 · no smoking",
  "l4.jr.r.photos": "Photos",
  "l4.jr.r.parking": "Parking",
  "l4.jr.r.parking_v": "Street parking · zone 3",
  "l4.jr.r.payload": "Payload",
  "l4.jr.r.created": "Created in Guesty",
  "l4.jr.r.channels": "Channels",
  "l4.jr.r.lead_to_live": "Lead → live",
  "l4.jr.r.first_booking": "First booking",
  "l4.jr.r.complete": "Record complete",
  "l4.cap.eyebrow": "What's included",
  "l4.cap.title": "Everything between the enquiry and the listing.",
  "l4.cap.sub": "Four surfaces, one property record. Owners work from their phone; your team works from the pipeline.",
  "l4.cap.1.title": "Branded capture",
  "l4.cap.1.text": "An address field embedded on your own website — or a hosted page and a QR code when you need them. Verified addresses, listing detection and a thirty-second intake.",
  "l4.cap.1.meta": "Embed · Hosted · QR",
  "l4.cap.2.title": "Offers and e-signature",
  "l4.cap.2.text": "Build the offer from your service catalogue and send it as a branded web page — not a PDF. Owners select options and sign on their phone.",
  "l4.cap.2.meta": "Versioned · Timestamped",
  "l4.cap.3.title": "Owner onboarding",
  "l4.cap.3.text": "A guided walk through the home: access, Wi-Fi, house rules and photos. AI reads photos into fields, and the owner confirms every suggestion.",
  "l4.cap.3.meta": "Mobile-first · Resumable",
  "l4.cap.4.title": "PMS handoff",
  "l4.cap.4.text": "Nothing goes live while a blocker is open. At 100% readiness, Listed maps the record to your PMS format and creates the property.",
  "l4.cap.4.meta": "Guesty · Hostaway · Hostfully · Beds24 · Lodgify · Smoobu · Uplisting · Hospitable · DigiHome",
  "l4.wl.eyebrow": "White-label",
  "l4.wl.title": "Your brand on every owner screen.",
  "l4.wl.sub": "Logo, colour, sender name and domain. Owners see you — never Listed. Pick a colour to preview the offer page.",
  "l4.wl.r1.title": "Brand tokens",
  "l4.wl.r1.text": "Your primary colour, logo and favicon on every owner-facing page.",
  "l4.wl.r2.title": "Custom domain",
  "l4.wl.r2.text": "Serve owner pages from owners.yourcompany.com on the Pro plan.",
  "l4.wl.r3.title": "Branded email",
  "l4.wl.r3.text": "Your sender name and footer on every email — each message logged to the timeline.",
  "l4.int.eyebrow": "Integrations",
  "l4.int.title": "Built to sit beside your PMS — not replace it.",
  "l4.int.sub": "Listed owns the journey and one canonical property record. Everything around it — PMS, channels, address data, AI, signing, email — sits behind an adapter you can swap without touching the owner experience.",
  "l4.int.col.integration": "Integration",
  "l4.int.col.role": "Role",
  "l4.int.col.status": "Status",
  "l4.int.role.pms": "PMS handoff",
  "l4.int.role.channel": "Listing detection",
  "l4.int.role.address": "Address data",
  "l4.int.role.estimate": "Revenue estimates",
  "l4.int.role.pricing": "Dynamic pricing",
  "l4.int.role.ai": "Summaries and drafts",
  "l4.int.status.live": "Live",
  "l4.int.status.adapter": "Adapter ready",
  "l4.int.status.detect": "Live",
  "l4.int.footnote": "Adapter ready means the interface is built and tested against the vendor's format; enable it with your own credentials.",
  "l4.cta.title": "Stop losing owners between the first email and the signed agreement.",
  "l4.cta.sub": "Create your organization and start from a ready-made service catalogue, offer template and onboarding flow.",
  "l4.cta.primary": "Create organization",
  "l4.cta.note": "Free until your first owner signs · No credit card · No owner accounts required",
  "l4.cta.pricing": "See pricing",

  /* landing v10 · hero proof row */
  "l10.proof.1": "No owner accounts required",
  "l10.proof.2": "Free until your first owner signs",
  "l10.proof.3": "Hands off to Guesty, Hostaway and Lodgify",
  /* landing v10 · numbers band */
  "l10.num.eyebrow": "One property, in numbers",
  "l10.num.1.value": "2",
  "l10.num.1.suffix": " days",
  "l10.num.1.label": "From first enquiry to live listing",
  "l10.num.1.sub": "Enquiry, estimate, offer, signature, onboarding, PMS — one record the whole way.",
  "l10.num.2.value": "30",
  "l10.num.2.suffix": " sec",
  "l10.num.2.label": "Owner intake, on the phone",
  "l10.num.2.sub": "Address, property type, bedrooms, availability and a note. No forms, no login.",
  "l10.num.3.value": "0",
  "l10.num.3.suffix": "",
  "l10.num.3.label": "Fields typed twice",
  "l10.num.3.sub": "Every answer becomes a structured field on the property record — never a line in an email.",
  "l10.num.4.value": "100",
  "l10.num.4.suffix": "%",
  "l10.num.4.label": "Your brand, every screen",
  "l10.num.4.sub": "Capture, offer, agreement, onboarding and email — the owner sees you, never Listed.",
  /* landing v10 · FAQ */
  "l10.faq.eyebrow": "Questions",

  /* landing v12 · hero with brand preview */
  "l12.hero.eyebrow": "For holiday-rental property managers",
  "l12.hero.title": "Win new owners from your own website.",
  "l12.hero.sub": "Put an instant rental estimate on your website, in your brand. Listed takes every owner enquiry through offer, e-signature and onboarding to a live listing in your PMS — nothing typed twice.",
  "l12.hero.sub_brand": "This is {domain} with Listed. A homeowner gets an instant estimate in {name}’s brand — and you get a property record that runs through offer, e-signature and onboarding straight into your PMS. Nothing typed twice.",
  "l12.hero.showing_demo": "Showing the {name} demo",
  "l12.hero.showing_yours": "Showing {name} · read from {domain}",
  "l12.hero.demo_link": "Or see the full owner journey",
  "l12.hero.story_link": "Follow the full journey",
  "l12.hero.reading": "Reading {domain}…",
  "l12.bp.label": "Your website",
  "l12.bp.placeholder": "yourcompany.com",
  "l12.bp.cta": "Show it in my brand",
  "l12.bp.cta_short": "Preview",
  "l12.bp.cta_again": "Try another",
  "l12.bp.read_from": "Read from {domain}",
  "l12.bp.start_short": "Get started",
  "l12.bp.keep": "Keep {name}",
  "l12.bp.partial_logo_short": "no logo found, so we use your initial",
  "l12.bp.partial_color_short": "no clear brand colour, so we keep it neutral",
  "l12.bp.hint": "No signup · Nothing is published · Free until your first owner signs",
  "l12.bp.step1": "Reading your website…",
  "l12.bp.step2": "Finding your logo…",
  "l12.bp.step3": "Picking your colour…",
  "l12.bp.step4": "Rendering the owner journey in your brand…",
  "l12.bp.err_generic": "We could not reach that website. Check the address, or try with https://.",
  "l12.bp.partial_logo": "We could not read a logo from your site — adjust it here, or continue; the colour and name are yours.",
  "l12.bp.partial_color": "We could not find a clear brand colour — pick one under Adjust.",
  "l12.bp.adjust": "Adjust",
  "l12.bp.reset": "Try another site",
  "l12.bp.adjust_name": "Company name",
  "l12.bp.adjust_logo": "Logo URL (https://…)",
  "l12.bp.start_with": "Get started as {name}",
  "l12.bp.copy_link": "Share this page",
  "l12.bp.link_copied": "Preview link copied",
  "l12.bp.link_failed": "Could not copy the link",
  "l12.story.eyebrow": "One home, start to finish",
  "l12.story.title": "Follow one home from first tap to live listing.",
  "l12.story.title_brand": "Follow one home from first tap to live listing — as {name}.",
  "l12.story.sub": "Rua da Prata 42, Lisbon — six moments across two days. Pick one to see the finished screen: the owner’s phone on one side, your Listed workspace on the other, one property record underneath it all.",
  "l12.preview.eyebrow": "Brand preview",
  "l12.preview.title": "Listed, as {name} would run it.",
  "l12.preview.sub": "Every owner-facing screen below is rendered in {name}'s brand, read from {domain}. This is what your owners would see — nothing has been published.",
  "l12.preview.missing": "This preview link has expired or does not exist.",
  "l12.preview.make_own": "Make your own preview",
  "l13.loop.site": "It starts on your website",
  "l13.loop.capture": "Address, verified with Google Maps",
  "l13.loop.details": "A few details — one tap each",
  "l13.loop.estimate": "Instant estimate · a structured lead for you",
  "l13.loop.offer": "Your offer, as a branded web page",
  "l13.loop.sign": "E-signed on the phone",
  "l13.loop.photo": "Photography booked from your calendar",
  "l13.loop.onboard": "Onboarding, room by room — AI reads the router",
  "l13.loop.live": "Live in your PMS and on the channels",
  "l13.stage.live": "Live demo",
  "l13.tr.play": "Play",
  "l13.tr.pause": "Pause",
  "l13.tr.prev": "Previous step",
  "l13.tr.next": "Next step",
  "l13.tr.speed": "Playback speed",
  "l13.tr.steps": "Steps in the owner journey",
  "l13.tr.owner_phone": "The owner's phone",
  "register.brand_ready": "{name} brand ready — colour and logo will be applied to your organization",

  /* landing v11 · the problem today */
  "l11.pb.eyebrow": "Why Listed",
  "l11.pb.title": "Winning one owner still costs you a week of email.",
  "l11.pb.sub": "The enquiry lands in an inbox. The estimate waits for a site visit. The offer is a PDF, the agreement a scan, onboarding a WhatsApp thread — and the PMS is typed by hand. Listed replaces that week with one property record.",
  "l11.pb.today": "Today",
  "l11.pb.today_meta": "Six tools, one inbox — nothing on record",
  "l11.pb.listed": "With Listed",
  "l11.pb.listed_meta": "One property record, in your brand",
  "l11.pb.step": "Step",
  "l11.pb.1.step": "The enquiry",
  "l11.pb.1.today": "A contact-form email or a phone call: no verified address, half the details missing — and it lands in one person’s inbox.",
  "l11.pb.1.chip": "Fwd: Contact form · inbox",
  "l11.pb.1.listed": "A structured lead with a verified address, the property facts and the owner’s note — in your pipeline within seconds.",
  "l11.pb.2.step": "Getting to a number",
  "l11.pb.2.today": "A call-back to ask the same questions again, then a site visit before anyone can talk about revenue. The owner waits days for a price.",
  "l11.pb.2.chip": "Calendar · site visit · 2.5 h",
  "l11.pb.2.listed": "An instant, range-based estimate on your website. Site visits happen when they add value — not to get started.",
  "l11.pb.3.step": "The offer",
  "l11.pb.3.today": "A Word document saved as a PDF and attached to an email. Versions multiply, and nobody knows whether it was opened.",
  "l11.pb.3.chip": "Offer_v3_final_FINAL.pdf",
  "l11.pb.3.listed": "Built from your service catalogue and sent as a branded web page. You see when it is opened, adjusted and accepted.",
  "l11.pb.4.step": "The agreement",
  "l11.pb.4.today": "Print, sign, scan — or a separate e-signature tool nobody connected. The signed PDF ends up in a folder.",
  "l11.pb.4.chip": "Scan_0034.pdf · Contracts folder",
  "l11.pb.4.listed": "Signed on the owner’s phone, timestamped and versioned — stored on the property record.",
  "l11.pb.5.step": "Onboarding",
  "l11.pb.5.today": "Wi-Fi password by text message, keys by phone, house rules from memory, forty photos as attachments — and often a second visit.",
  "l11.pb.5.chip": "WhatsApp · 41 photos · “wifi pw?”",
  "l11.pb.5.listed": "A guided walk through the home on the owner’s phone. AI reads the router photo, and every answer lands as a field.",
  "l11.pb.6.step": "Into the PMS",
  "l11.pb.6.today": "Someone re-types everything into Guesty or Hostaway. Fields are missed, typos slip through, and the listing waits.",
  "l11.pb.6.chip": "owners.xlsx → PMS, by hand",
  "l11.pb.6.listed": "At 100% readiness, Listed creates the property in your PMS — mapped field by field. Nothing typed twice.",
  "l11.pb.7.step": "The overview",
  "l11.pb.7.today": "Who is waiting for an answer? Who has an open offer? Nobody knows — and owners go quiet between the first email and the signature.",
  "l11.pb.7.chip": "“Did you get my email?”",
  "l11.pb.7.listed": "One pipeline: every owner, every stage, every blocker — and follow-ups that do not depend on memory.",
  "l11.pb.8.step": "The overview",
  "l11.pb.8.today": "Who is waiting for an answer? Who has an open offer? Nobody knows — and owners go quiet between the first email and the signature.",
  "l11.pb.8.chip": "\"Did you get my email?\"",
  "l11.pb.8.listed": "One pipeline: every owner, every stage, every blocker — and follow-ups that do not depend on memory.",
  "l11.pb.sum.today": "Weeks to go live · dozens of emails · everything typed three or four times · nothing on record",
  "l11.pb.sum.listed": "Two days · one record · nothing typed twice",
  "l11.pb.cta": "See what is included",
  "l11.pb.tl.day": "Day {n}",
  "l11.pb.tl.axis": "One enquiry · 30 days",
  "l11.pb.tl.today.inbox": "Contact form lands in the info@ inbox",
  "l11.pb.tl.today.callback": "Call-back — the same questions again",
  "l11.pb.tl.today.visit": "Site visit before anyone can name a price",
  "l11.pb.tl.today.pdf": "Offer_v3_final_FINAL.pdf goes out",
  "l11.pb.tl.today.scan": "Print · sign · scan · file",
  "l11.pb.tl.today.chat": "“wifi pw?” · 41 photos on WhatsApp",
  "l11.pb.tl.today.typed": "Everything typed into the PMS by hand",
  "l11.pb.tl.today.end": "…and still not live",
  "l11.pb.tl.today.figure": "Weeks",
  "l11.pb.tl.today.figure_sub": "Dozens of emails · everything typed three or four times · nothing on record",
  "l11.pb.tl.listed.enquiry": "Enquiry · instant estimate · offer accepted · e-signed",
  "l11.pb.tl.listed.signed": "Agreement e-signed on the phone",
  "l11.pb.tl.listed.live": "Photos in · onboarded · created in your PMS · live",
  "l11.pb.tl.listed.end": "Live on Airbnb & Booking.com",
  "l11.pb.tl.listed.figure": "2 days",
  "l11.pb.tl.listed.figure_sub": "One property record from first tap to live listing · nothing typed twice",
  "l11.pb.rec.example": "Example property",
  "l11.pb.rec.enquiry.step": "Enquiry",
  "l11.pb.rec.enquiry.fact": "Verified address · owner · a note in their words",
  "l11.pb.rec.estimate.step": "Estimate",
  "l11.pb.rec.estimate.fact": "€42–48k a year, instantly — no site visit first",
  "l11.pb.rec.offer.step": "Offer",
  "l11.pb.rec.offer.fact": "A branded web page · opened 09:16 · accepted 09:21",
  "l11.pb.rec.agreement.step": "Agreement",
  "l11.pb.rec.agreement.fact": "E-signed on the phone · timestamped · versioned",
  "l11.pb.rec.onboarding.step": "Onboarding",
  "l11.pb.rec.onboarding.fact": "Wi-Fi read from a router photo · access · rules · 12 photos",
  "l11.pb.rec.pms.step": "Your PMS",
  "l11.pb.rec.pms.fact": "Property created · 24 fields mapped · nothing typed twice",
  "l11.pb.pp.1.t": "Every enquiry arrives structured",
  "l11.pb.pp.1.p": "Verified address, property facts and the owner’s note land in your pipeline in seconds — not in someone’s inbox, waiting for a call-back.",
  "l11.pb.pp.2.t": "Offer, signature and onboarding on one record",
  "l11.pb.pp.2.p": "A branded web page instead of a PDF. E-signed on the phone. A guided walk through the home instead of a WhatsApp thread — every answer becomes a field.",
  "l11.pb.pp.3.t": "Handed to your PMS, field by field",
  "l11.pb.pp.3.p": "At 100% readiness, Listed creates the property in your PMS with everything the owner gave you. Two days from first tap to live listing — and nothing typed twice.",
  "l11.pb.total": "In total",

  /* capture tile v11 */
  "l6.cap.capture.embedded": "Embedded on your site",
  "l6.cap.capture.get_estimate": "Get estimate",
  "l6.cap.capture.google": "Verified with Google Maps",
  "l6.cap.capture.default": "Default",
  "l6.cap.capture.embed_sub": "one line · listed.js",
  "l6.cap.capture.hosted_sub": "/start/northstay",
  "l6.cap.capture.qr_sub": "print-ready",
  "l10.faq.title": "Straight answers.",
  "l10.faq.sub": "What property managers ask before they connect their first owner.",
  "l10.faq.1.q": "Do owners need to create an account?",
  "l10.faq.1.a": "No. Owners open secure, personal links on their phone — the offer, the agreement and onboarding all work without a login. Everything they do is written to the property record in your workspace.",
  "l10.faq.2.q": "Which PMS can Listed hand the property to?",
  "l10.faq.2.a": "Guesty, Hostaway, Hostfully and Beds24 (property creation, updates and — where the API allows — photos), Lodgify, Smoobu, Uplisting and Hospitable (link, read and sync — their public APIs do not allow property creation, so Listed prepares the handover sheet and attaches the signed owner to a listing you already run) and DigiHome. Hostfully, Beds24, Uplisting and Hospitable are in beta. You connect your own PMS credentials under Settings → Integrations.",
  "l10.faq.3.q": "Where does the revenue estimate come from?",
  "l10.faq.3.a": "From your estimate configuration: a per-market range you control, optionally backed by a market-data provider. The estimate is shown as a range, in your brand, and stored on the record so the offer and the owner see the same number.",
  "l10.faq.4.q": "Can I use my own domain and sender name?",
  "l10.faq.4.a": "Yes. Logo, colour, sender name and footer are yours on every plan; a custom owner domain (owners.yourcompany.com) is included on Pro.",
  "l10.faq.5.q": "What does it cost?",
  "l10.faq.5.a": "Listed is free to use — no monthly fee, no seats, no setup. You pay one flat amount only when an owner signs on the platform; if an owner never signs, nothing is charged. See the pricing page for the current amount and volume tiers.",
  "l10.faq.6.q": "Does it replace my PMS?",
  "l10.faq.6.a": "No. Listed runs the journey from enquiry to a launch-ready property, then creates it in the PMS you already use. Your PMS stays the system of record for calendars, pricing and guests.",
  "l4.footer.contact": "Contact",
  "l4.footer.email": "hello@digihome.no",
  "l4.footer.location": "Bergen, Norway",


  "hq.brand": "Listed HQ",
  "hq.shell.sub": "DigiHome platform",
  "hq.shell.platform": "Platform",
  "hq.badge": "Platform",
  "hq.nav.overview": "Overview",
  "hq.nav.organizations": "Organizations",
  "hq.nav.integrations": "Integrations",
  "hq.nav.settings": "Platform settings",
  "hq.nav.growth": "Growth",

  /* ---- HQ · Growth (outbound prospecting) ---- */
  "hq.growth.title": "Growth",
  "hq.growth.sub": "Import the research sheet, review each e-mail exactly as written, approve, and send from your own mailbox — a few good e-mails a day, not a blast.",
  "hq.growth.import": "Import leads",
  "hq.growth.run_research": "Research new companies",
  "hq.growth.run_draft": "Draft for scored companies",
  "hq.growth.running": "Agent running…",
  "hq.growth.run_done": "Run finished: {done} done · {failed} failed",
  "hq.growth.run_started": "Agent started — this takes 30–90 seconds per company.",
  "hq.growth.kpi.companies": "Companies",
  "hq.growth.kpi.scored": "Scored",
  "hq.growth.kpi.avg": "Avg. score",
  "hq.growth.kpi.tier_a": "Tier A",
  "hq.growth.kpi.drafts": "Awaiting approval",
  "hq.growth.kpi.approved": "Approved",
  "hq.growth.kpi.sent": "Sent",
  "hq.growth.kpi.capacity": "Today's capacity",
  "hq.growth.tab.companies": "Companies",
  "hq.growth.tab.queue": "Queue",
  "hq.growth.tab.waitlist": "Early access",
  "hq.growth.tab.settings": "Settings & mailboxes",
  "hq.growth.tab.settings_short": "Settings",
  "hq.growth.stats.companies": "{n} companies",
  "hq.growth.stats.ready": "{n} ready",
  "hq.growth.stats.sent": "{n} sent",
  "hq.growth.stats.replied": "{n} replied",
  "hq.growth.pipeline": "Pipeline",
  "hq.growth.pipeline_help": "Every step is a filter — click to jump.",
  "hq.growth.plan.blocked_chip": "Sending blocked",
  "hq.growth.plan.fix_short": "Fix",
  "hq.growth.search": "Search company, domain or city",
  "hq.growth.filter.status": "Status",
  "hq.growth.filter.tier": "Tier",
  "hq.growth.filter.all": "All",
  "hq.growth.sort.score": "Score",
  "hq.growth.sort.recent": "Recent activity",
  "hq.growth.sort.name": "Name",
  "hq.growth.sort.created": "Newest",
  "hq.growth.col.company": "Company",
  "hq.growth.col.score": "Score",
  "hq.growth.col.status": "Status",
  "hq.growth.col.contacts": "Contacts",
  "hq.growth.col.drafts": "Drafts",
  "hq.growth.col.activity": "Last activity",
  "hq.growth.empty.title": "No companies yet",
  "hq.growth.empty.sub": "Import a CSV with company, website and email columns to get started.",
  "hq.growth.empty.filtered": "Nothing matches these filters.",
  "hq.growth.status.new": "Imported",
  "hq.growth.status.researched": "Researched",
  "hq.growth.status.scored": "Scored",
  "hq.growth.status.drafted": "Ready",
  "hq.growth.status.approved": "Approved",
  "hq.growth.status.contacted": "Sent",
  "hq.growth.status.replied": "Replied",
  "hq.growth.status.won": "Won",
  "hq.growth.status.lost": "Lost",
  "hq.growth.status.suppressed": "Suppressed",
  "hq.growth.not_scored": "Not scored",
  "hq.growth.thin": "Website unreachable — research is thin",
  "hq.growth.detail.research": "Research",
  "hq.growth.detail.score": "Score breakdown",
  "hq.growth.detail.contacts": "Contacts",
  "hq.growth.detail.messages": "Drafts & messages",
  "hq.growth.detail.timeline": "Timeline",
  "hq.growth.detail.run": "Run research & score",
  "hq.growth.detail.rerun": "Re-run research",
  "hq.growth.detail.rescore": "Re-score",
  "hq.growth.detail.draft": "Draft email",
  "hq.growth.detail.no_research": "Not researched yet. The agent reads the company website, summarises what they do, finds decision-makers and scores the fit.",
  "hq.growth.detail.summary": "Summary",
  "hq.growth.detail.portfolio": "Portfolio",
  "hq.growth.detail.markets": "Markets",
  "hq.growth.detail.tools": "PMS / tools",
  "hq.growth.detail.channels": "Channels",
  "hq.growth.detail.owner_flow": "How owners sign up today",
  "hq.growth.detail.decision_makers": "Decision-makers found",
  "hq.growth.detail.signals": "Signals",
  "hq.growth.detail.fit": "Why Listed fits",
  "hq.growth.detail.risks": "Risks",
  "hq.growth.detail.hook": "Opening hook",
  "hq.growth.detail.angle": "Best angle",
  "hq.growth.detail.rationale": "Rationale",
  "hq.growth.detail.sources": "Sources",
  "hq.growth.detail.add_contact": "Add contact",
  "hq.growth.detail.generic": "generic inbox",
  "hq.growth.detail.no_contacts": "No contacts yet — add the decision-maker's email.",
  "hq.growth.detail.no_messages": "No drafts yet.",
  "hq.growth.detail.notes": "Notes",
  "hq.growth.detail.override": "Manual score",
  "hq.growth.detail.delete": "Delete company",
  "hq.growth.detail.delete_confirm": "Delete this company, its contacts, drafts and history?",
  "hq.growth.contact.name": "Full name",
  "hq.growth.contact.role": "Role",
  "hq.growth.contact.email": "Email",
  "hq.growth.contact.language": "Language",
  "hq.growth.contact.unsubscribe": "Mark do-not-contact",
  "hq.growth.msg.approve": "Approve",
  "hq.growth.msg.reject": "Reject",
  "hq.growth.msg.edit": "Edit",
  "hq.growth.msg.send": "Send now",
  "hq.growth.msg.subject": "Subject",
  "hq.growth.msg.body": "Body",
  "hq.growth.msg.to": "To",
  "hq.growth.msg.status.draft": "Draft",
  "hq.growth.msg.status.approved": "Approved",
  "hq.growth.msg.status.sent": "Sent",
  "hq.growth.msg.status.rejected": "Rejected",
  "hq.growth.msg.status.replied": "Replied",
  "hq.growth.msg.status.bounced": "Bounced",
  "hq.growth.msg.approved_ok": "Approved — nothing is sent until you press Send now.",
  "hq.growth.msg.rejected_ok": "Draft rejected.",
  "hq.growth.queue.title": "Outreach queue",
  "hq.growth.queue.sub": "Next → preview → send → next. Every e-mail is exactly what was imported; nothing is regenerated unless you ask.",
  "hq.growth.queue.empty": "Nothing to send. Import a research sheet to fill the queue.",
  "hq.growth.plan.title": "Today's send plan",
  "hq.growth.plan.sub": "What would go out today given caps, windows and suppression.",
  "hq.growth.plan.capacity": "{remaining} of {cap} left today",
  "hq.growth.plan.planned": "Planned",
  "hq.growth.plan.blocked": "Held back",
  "hq.growth.plan.none": "No approved messages.",
  "hq.growth.plan.window": "Send window {start}:00–{end}:00, {days}, recipient's local time",
  "hq.growth.plan.weekdays": "weekdays only",
  "hq.growth.plan.everyday": "every day",
  "hq.growth.settings.caps": "Daily limits",
  "hq.growth.settings.caps_sub": "Cold outreach stays deliverable at low, human volumes. These caps are enforced when sending.",
  "hq.growth.settings.daily_cap_total": "Total per day",
  "hq.growth.settings.per_mailbox_cap": "Per mailbox per day",
  "hq.growth.settings.per_company_daily_cap": "Per company per day",
  "hq.growth.settings.min_score": "Minimum score to send",
  "hq.growth.settings.window": "Send window",
  "hq.growth.settings.start_hour": "From (hour)",
  "hq.growth.settings.end_hour": "To (hour)",
  "hq.growth.settings.weekdays_only": "Weekdays only",
  "hq.growth.settings.local_time": "Use recipient's local time",
  "hq.growth.settings.identity": "Sender identity & message",
  "hq.growth.settings.identity_sub": "Used in every draft. The model writes the body in the recipient's language; the signature and opt-out line are appended verbatim.",
  "hq.growth.settings.sender_name": "Your name",
  "hq.growth.settings.sender_title": "Title",
  "hq.growth.settings.reply_to": "Reply-to (optional)",
  "hq.growth.settings.value_prop": "What Listed is (for the model)",
  "hq.growth.settings.cta": "Call to action",
  "hq.growth.settings.signature": "AI draft signature (leave empty to use name + title)",
  "hq.growth.settings.signature_help": "Only used when the AI drafts an e-mail. Imported drafts keep their own sign-off; the sender card is added below it.",
  "hq.growth.settings.unsubscribe": "Opt-out line",
  "hq.growth.settings.default_language": "Default language",
  "hq.growth.settings.mailboxes": "Mailboxes",
  "hq.growth.settings.mailboxes_sub": "Microsoft 365 Business mailboxes on a dedicated sending domain. Add the mailbox, then press Connect and sign in with that account — Listed gets permission to send and to read replies in that inbox, nothing else.",
  "hq.growth.settings.add_mailbox": "Add Microsoft 365 mailbox",
  "hq.growth.settings.mailbox_address": "Mailbox address",
  "hq.growth.settings.mailbox_name": "Display name",
  "hq.growth.settings.mailbox_cap": "Daily cap",
  "hq.growth.settings.connect": "Connect",
  "hq.growth.settings.connect_soon": "Sign in with Microsoft to connect",
  "hq.growth.settings.mailbox.not_connected": "Not connected",
  "hq.growth.settings.mailbox.connected": "Connected",
  "hq.growth.settings.mailbox.paused": "Paused",
  "hq.growth.settings.no_mailboxes": "No mailboxes yet.",
  "hq.growth.settings.suppression": "Suppression list",
  "hq.growth.settings.suppression_sub": "Emails or whole domains that must never be contacted. Adding one cancels any pending drafts.",
  "hq.growth.settings.suppression_placeholder": "name@company.com or company.com",
  "hq.growth.settings.no_suppression": "Nothing suppressed.",
  "hq.growth.import.title": "Import researched leads",
  "hq.growth.import.sub": "Upload an Excel file containing companies, research and prepared outreach. Everything is stored exactly as written — nothing is rewritten, nothing unmapped is discarded.",
  "hq.growth.import.source": "Source label",
  "hq.growth.import.upload": "Choose file",
  "hq.growth.import.preview": "{rows} rows detected · columns: {cols}",
  "hq.growth.import.submit": "Import",
  "hq.growth.import.result": "{companies} companies created · {matched} matched · {contacts} contacts added · {skipped} skipped",
  "hq.growth.import.errors": "{n} rows had problems",
  "hq.growth.status.meeting": "Meeting",
  "hq.growth.import.drop_title": "Upload the lead spreadsheet",
  "hq.growth.import.drop_sub": "xlsx with several sheets works — pick which sheets to use in the next step. csv / tsv also fine.",
  "hq.growth.import.paste": "…or paste CSV text",
  "hq.growth.import.continue": "Continue",
  "hq.growth.import.principle": "The sheet is the source of truth for research and copy. Growth computes fit and tier from the four fit components; the sheet's own total is kept as source score.",
  "hq.growth.import.step.upload": "Upload",
  "hq.growth.import.step.map": "Check mapping",
  "hq.growth.import.step.done": "Imported",
  "hq.growth.import.preset_name": "Save mapping as",
  "hq.growth.import.preset_save": "Remember this mapping for the next sheet with the same headers",
  "hq.growth.import.preset_applied": "mapping “{name}” applied",
  "hq.growth.import.optout": "Append the opt-out line when sending",
  "hq.growth.import.optout_help": "The body stays verbatim; only the one-line opt-out from Settings is added at the end of the e-mail.",
  "hq.growth.import.rows": "rows",
  "hq.growth.import.mapped": "columns mapped",
  "hq.growth.import.no_company": "No company column — sheet is skipped",
  "hq.growth.import.col_header": "Column in sheet",
  "hq.growth.import.col_field": "Becomes",
  "hq.growth.import.col_sample": "First value",
  "hq.growth.import.keep_custom": "Keep as custom field",
  "hq.growth.detail.from_sheet": "from “{name}”",
  "hq.growth.import.need_company": "Map at least one column to Company (or Website / E-mail) on an included sheet.",
  "hq.growth.import.submit_n": "Import {n} companies",
  "hq.growth.import.done_title": "{n} companies in Growth",
  "hq.growth.import.done_sub": "{created} new · {updated} refreshed · {contacts} contacts · {drafts} new e-mails to review · {drafts_updated} e-mails refreshed from the sheet · {kept} kept as they were (edited, approved or sent)",
  "hq.growth.import.done_toast": "Imported {n} companies",
  "hq.growth.import.open_queue": "Open the queue",
  "hq.growth.funnel.companies": "Companies",
  "hq.growth.funnel.tier_a": "{n} tier A",
  "hq.growth.funnel.ready": "Ready to send",
  "hq.growth.funnel.approved": "{n} approved",
  "hq.growth.funnel.linkedin": "{n} via LinkedIn / form",
  "hq.growth.funnel.sent": "Sent",
  "hq.growth.funnel.replied": "Replied",
  "hq.growth.funnel.rate": "{pct}% reply rate",
  "hq.growth.funnel.meetings": "Meetings",
  "hq.growth.funnel.won": "Won",
  "hq.growth.funnel.today": "Sent today",
  "hq.growth.funnel.mailboxes": "{n} mailbox connected",
  "hq.growth.funnel.connect": "No mailbox connected — set up",
  "hq.growth.bucket.short.ready": "Ready",
  "hq.growth.bucket.short.linkedin_form": "LinkedIn",
  "hq.growth.bucket.short.needs_email": "Needs e-mail",
  "hq.growth.bucket.short.sent": "Sent",
  "hq.growth.queue.search": "Search leads",
  "hq.growth.queue.no_match": "No leads match",
  "hq.growth.queue.count": "{n} leads",
  "hq.growth.queue.filtered": "of {n}",
  "hq.growth.queue.kbd_move": "to move",
  "hq.growth.queue.position": "{i} of {n}",
  "hq.growth.plan.blocked_title": "Sending is blocked",
  "hq.growth.plan.fix": "Fix in Settings",
  "hq.growth.lead.pms_unknown": "Not publicly identified",
  "hq.growth.lead.confidence": "confidence",
  "hq.growth.outreach.imported_help": "Subject and body are exactly as imported from the sheet. Nothing is regenerated unless you ask.",
  "hq.growth.outreach.edit_help": "Your edits are kept — a later re-import will not overwrite them.",
  "hq.growth.outreach.assist_help": "Optional. Loads a suggestion into the editor; nothing changes until you save.",
  "hq.growth.outreach.no_mailbox": "No mailbox connected — Send is blocked until Microsoft 365 is set up.",
  "hq.growth.outreach.no_mailbox_cta": "Set up mailbox",
  "hq.growth.test.send_me_title": "Sends a [Test] copy to {to}",
  "hq.growth.bucket.ready": "Ready to send",
  "hq.growth.bucket.linkedin_form": "LinkedIn / contact form",
  "hq.growth.bucket.needs_email": "Needs e-mail enrichment",
  "hq.growth.bucket.sent": "Sent",
  "hq.growth.bucket.suppressed": "Suppressed",
  "hq.growth.bucket.incomplete": "Needs copy",
  "hq.growth.bucket.empty.ready": "Nothing ready to send",
  "hq.growth.bucket.empty.ready_sub": "Import a lead sheet with subject + e-mail body, or add an address to a lead that needs enrichment.",
  "hq.growth.bucket.empty.linkedin_form": "No LinkedIn / form-only leads",
  "hq.growth.bucket.empty.needs_email": "Every lead has a verified address",
  "hq.growth.bucket.empty.sent": "Nothing sent yet",
  "hq.growth.channel.direct_email": "Direct e-mail",
  "hq.growth.channel.company_email": "Company inbox",
  "hq.growth.channel.linkedin": "LinkedIn",
  "hq.growth.channel.contact_form": "Contact form",
  "hq.growth.channel.manual_research_required": "No verified e-mail",
  "hq.growth.col.fit": "Fit",
  "hq.growth.col.pms": "PMS",
  "hq.growth.col.channel": "Channel",
  "hq.growth.sort.priority": "Sheet priority",
  "hq.growth.fit.title": "Research fit 0–10 (owner acquisition + onboarding complexity + scale + buy likelihood)",
  "hq.growth.kpi.meetings": "Meetings & won",
  "hq.growth.kpi.named_direct": "named, direct",
  "hq.growth.automation": "Automation",
  "hq.growth.automation_help": "Optional — never runs on its own",
  "hq.growth.detail.run_help_imported": "This lead was researched in the sheet. Running the AI researcher adds a second opinion; it never touches the imported e-mail.",
  "hq.growth.lead.pms": "PMS / stack",
  "hq.growth.lead.decision_maker": "Decision maker",
  "hq.growth.lead.contactability": "Contactability",
  "hq.growth.lead.owner": "Owner",
  "hq.growth.lead.priority": "Sheet priority {n}",
  "hq.growth.lead.not_identified": "Not identified",
  "hq.growth.lead.why": "Why this lead",
  "hq.growth.lead.why_fits": "Why Listed fits",
  "hq.growth.lead.why_now": "Why now",
  "hq.growth.lead.owner_journey": "Owner journey today",
  "hq.growth.lead.angle": "Recommended angle",
  "hq.growth.lead.integration_path": "Integration path",
  "hq.growth.lead.previous_stack": "Previous / adjacent stack",
  "hq.growth.lead.owner_portal": "Owner portal / booking layer",
  "hq.growth.lead.evidence": "Evidence",
  "hq.growth.lead.shared_inbox": "shared inbox",
  "hq.growth.lead.direct": "direct",
  "hq.growth.lead.no_email": "No e-mail yet",
  "hq.growth.lead.legal": "Before you send (not legal advice)",
  "hq.growth.lead.custom": "{n} more fields from the sheet",
  "hq.growth.outreach.imported": "Imported verbatim",
  "hq.growth.outreach.mismatch_title": "Written to {name}, but the address is a shared inbox",
  "hq.growth.outreach.mismatch_body": "Sending “Hi {name}” to info@ can read as a guess. Pick an opening — or keep it as written.",
  "hq.growth.outreach.mismatch_chip": "Check greeting",
  "hq.growth.outreach.opening_applied": "Opening updated",
  "hq.growth.outreach.optout_note": "The one-line opt-out from Settings is appended when this is sent (see Preview).",
  "hq.growth.outreach.sent_ok": "Sent.",
  "hq.growth.outreach.assist": "Improve",
  "hq.growth.outreach.assist_shorter": "Make it shorter",
  "hq.growth.outreach.assist_more_personal": "More personal",
  "hq.growth.outreach.assist_less_salesy": "Less salesy",
  "hq.growth.outreach.assist_alt_subject": "Alternative subjects",
  "hq.growth.outreach.assist_ready": "Suggestion loaded into the editor — save to keep it, cancel to discard.",
  "hq.growth.outreach.media_missing": "Media placeholder points at a file we don't host: {name}",
  "hq.growth.outreach.media_heavy": "{name} is {mb} MB — heavy for a first e-mail",
  "hq.growth.outreach.media_light": "A lighter variant exists: {name}. Replace the file name in the [[GIF: …]] placeholder to use it.",
  "hq.growth.outreach.media_alt": "Listed product walkthrough",
  "hq.growth.outreach.media_switched": "Walkthrough: {name}",
  "hq.growth.outreach.media_use_light": "Use {name}",
  "hq.growth.outreach.source": "Source",
  "hq.growth.outreach.source_help": "The stored text with its [[GIF: …]] placeholder — what Edit works on.",
  "hq.growth.outreach.from_none": "No mailbox connected yet",
  "hq.growth.outreach.keep_as_written": "Keep as written",
  "hq.growth.outreach.optout_preview": "Opt-out line is appended when sent",
  "hq.growth.msg.unapprove": "Back to draft",
  "hq.growth.msg.reopened": "Back to draft.",
  "hq.growth.noemail.open_linkedin": "Open LinkedIn",
  "hq.growth.reject.why": "Why? (kept on the lead)",
  "hq.growth.reject.not_fit": "Not a fit",
  "hq.growth.reject.wrong_person": "Wrong person",
  "hq.growth.reject.later": "Later — not now",
  "hq.growth.reject.rewrite": "Needs a rewrite",
  "hq.growth.reject.no_reason": "Reject without a reason",
  "hq.growth.fit.sheet": "Sheet said {n}/10 {tier}",
  "hq.growth.fit.short": "Research fit",
  "hq.growth.fit.owner_acquisition": "Owner acquisition",
  "hq.growth.fit.onboarding_complexity": "Onboarding complexity",
  "hq.growth.fit.scale": "Scale",
  "hq.growth.fit.buy_likelihood": "Buy likelihood",
  "hq.growth.lead.next_step": "Suggested next step",
  "hq.growth.media.title": "Product walkthrough",
  "hq.growth.media.language": "Language",
  "hq.growth.media.size": "Size",
  "hq.growth.media.lang.en": "English",
  "hq.growth.media.lang.nb": "Norwegian",
  "hq.growth.media.standard": "Standard",
  "hq.growth.media.light": "Light",
  "hq.growth.media.mb": "{mb} MB",
  "hq.growth.media.recommended": "Recommended for this lead: {label}",
  "hq.growth.media.use_recommended": "Use recommended",
  "hq.growth.media.recommended_on": "Recommended",
  "hq.growth.media.note": "Hosted, not attached — the e-mail itself stays a few KB. The GIF animates in Gmail, Apple Mail and Outlook on the web; Outlook for Windows shows the first frame.",
  "hq.growth.media.heavy": "Standard is {mb} MB — Light loads faster on mobile and looks the same in the inbox.",
  "hq.growth.media.remove": "Remove from e-mail",
  "hq.growth.media.removed": "Walkthrough removed from the e-mail.",
  "hq.growth.media.add": "Add product walkthrough",
  "hq.growth.media.add_help": "Inserts the GIF just before the sign-off. Move the [[GIF: …]] line in Edit if you want it elsewhere.",
  "hq.growth.media.added": "Walkthrough added before the sign-off.",
  "hq.growth.media.switched": "Walkthrough: {label}",
  "hq.growth.media.open": "Open full size",
  "hq.growth.media.missing_body": "The e-mail refers to {name}, which is not hosted. Pick a variant below or remove it.",
  "hq.growth.media.pick": "Use this file",
  "hq.growth.media.inline_line": "The [[GIF: …]] line marks where the walkthrough appears. Switch language or size below the e-mail after saving.",

  "hq.growth.outcome.title": "Outcome",
  "hq.growth.outcome.sent": "sent {when}",
  "hq.growth.outcome.saved": "Outcome recorded",
  "hq.growth.outcome.replied_positive": "Positive reply",
  "hq.growth.outcome.replied_negative": "Not interested",
  "hq.growth.outcome.not_now": "Not now",
  "hq.growth.outcome.wrong_person": "Wrong person",
  "hq.growth.outcome.meeting": "Meeting booked",
  "hq.growth.outcome.customer": "Became a customer",
  "hq.growth.outcome.no_response": "No response",
  "hq.growth.outcome.bounced": "Bounced",
  "hq.growth.outcome.unsubscribed": "Unsubscribed",
  "hq.growth.assets.title": "Also in the sheet",
  "hq.growth.assets.stored": "Copy from the sheet",
  "hq.growth.assets.follow_up_1": "Follow-up 1",
  "hq.growth.assets.follow_up_2": "Follow-up 2",
  "hq.growth.assets.linkedin_dm": "LinkedIn DM",
  "hq.growth.assets.copy": "Copy",
  "hq.growth.assets.copied": "Copied",
  "hq.growth.assets.copy_failed": "Could not copy to the clipboard",
  "hq.growth.noemail.title": "No verified e-mail address yet",
  "hq.growth.noemail.linkedin": "The research found a named person on LinkedIn but no address. Send the LinkedIn DM, or add an e-mail and the stored copy becomes a draft.",
  "hq.growth.noemail.form": "Only a contact form is public. Use the form (or LinkedIn), or add an e-mail and the stored copy becomes a draft.",
  "hq.growth.noemail.manual": "No person, e-mail or LinkedIn was found. Research a contact, then add the e-mail here.",
  "hq.growth.noemail.stored_copy": "Show the stored e-mail copy “{subject}”",
  "hq.growth.noemail.add_label": "Add an e-mail address",
  "hq.growth.noemail.add": "Add",
  "hq.growth.noemail.added": "E-mail added — the stored copy is now a draft in Ready.",
  "hq.growth.noemail.help": "Verify deliverability before sending. Shared addresses (info@, hello@) are marked as a company inbox.",
  "hq.growth.ai_off": "AI is not configured — research, scoring and drafting are disabled.",
  "hq.growth.websearch_off": "Web search not connected — research is grounded on the company website only.",
  "hq.nav.workspace": "Back to workspace",
  "hq.nav.admin_link": "Listed HQ",
  "hq.impersonating": "Viewing {org} as {name}",
  "hq.impersonating_exit": "Back to HQ",
  "hq.overview.title": "Platform overview",
  "hq.overview.sub": "Every tenant, every key, every handoff — from one place.",
  "hq.overview.orgs": "Organizations",
  "hq.overview.users": "Team members",
  "hq.overview.leads": "Leads",
  "hq.overview.offers": "Offers sent",
  "hq.overview.signed": "Signed",
  "hq.overview.live": "Live",
  "hq.overview.estimates": "Estimates fetched",
  "hq.overview.integrations": "Platform integrations",
  "hq.overview.recent_orgs": "Newest organizations",
  "hq.overview.audit": "Audit trail",
  "hq.overview.audit_empty": "No platform actions yet.",
  "hq.overview.stages": "Leads by stage (all tenants)",
  "hq.orgs.title": "Organizations",
  "hq.orgs.sub": "Tenants on the platform. Open any workspace to support them.",
  "hq.orgs.create": "New organization",
  "hq.orgs.open": "Open workspace",
  "hq.orgs.plan": "Plan",
  "hq.orgs.estimate_mode": "Estimate mode",
  "hq.orgs.members": "Members",
  "hq.orgs.leads": "Leads",
  "hq.orgs.live": "Live",
  "hq.orgs.last_activity": "Last activity",
  "hq.orgs.install.installed": "Installed on {host}",
  "hq.orgs.install.more": "+{n} more",
  "hq.orgs.install.not_installed": "Widget not installed yet",
  "hq.orgs.install.leads": "{n} via widget",
  "hq.orgs.install.seen": "seen {ago}",
  "hq.orgs.created": "Created",
  "hq.orgs.search": "Search organizations…",
  "hq.orgs.empty": "No organizations yet.",
  "hq.orgs.form.name": "Organization name",
  "hq.orgs.form.admin_name": "Admin name",
  "hq.orgs.form.admin_email": "Admin email",
  "hq.orgs.form.password": "Temporary password",
  "hq.orgs.form.color": "Primary color",
  "hq.orgs.form.submit": "Create organization",
  "hq.orgs.created_ok": "Organization created",
  "hq.orgs.opening": "Opening workspace…",
  "hq.integ.title": "Platform integrations",
  "hq.integ.sub": "Keys stored here are encrypted at rest and shared with every tenant unless they add their own. Nothing is ever shown back in full.",
  "hq.integ.test": "Test connection",
  "hq.integ.save": "Save key",
  "hq.integ.remove": "Remove key",
  "hq.integ.disable": "Disable",
  "hq.integ.enable": "Enable",
  "hq.integ.last_test": "Last test",
  "hq.integ.never_tested": "Never tested",
  "hq.integ.tenant_overrides": "{n} tenant(s) use their own key",
  "hq.integ.status.connected": "Connected",
  "hq.integ.status.not_connected": "No key",
  "hq.integ.status.disabled": "Disabled",
  "hq.integ.capability.estimate": "Revenue estimate",
  "hq.integ.capability.pricing": "Pricing (post-launch)",
  "hq.integ.encrypted": "Encrypted at rest · masked in every response",
  "hq.integ.internal": "Internal model",
  "hq.integ.internal_note": "Always available as fallback. Tune its baseline under Platform settings.",
  "hq.settings.title": "Platform settings",
  "hq.settings.sub": "Defaults for new organizations and the baseline of Listed's internal revenue model.",
  "hq.settings.defaults": "Defaults for new organizations",
  "hq.settings.model": "Internal revenue model",
  "hq.settings.model_sub": "Used when no market data provider is connected. Nightly rate × occupancy × 365, widened by the spread. Always labelled 'Internal model'.",
  "hq.settings.base_adr": "Base nightly rate (NOK)",
  "hq.settings.occupancy": "Occupancy",
  "hq.settings.extra_bedroom": "Per extra bedroom (NOK)",
  "hq.settings.spread": "Spread (±%)",
  "hq.settings.reset": "Reset to defaults",
  "hq.settings.bootstrap": "Superadmin access",
  "hq.settings.bootstrap_note": "Platform admins are flagged on the user record (is_superadmin) or bootstrapped from the SUPERADMIN_EMAILS environment variable. Keys are encrypted with PLATFORM_SECRET.",
  "hq.login.title": "Listed HQ",
  "hq.login.sub": "Platform access for DigiHome.",

  /* ---- Settings: Install & share ---- */
  "settings.install": "Install & share",
  "install.title": "Install Listed on your website",
  "install.sub": "One link, one line of code — or plug straight into your stack. Pick the way that fits your site; everything stays on-brand.",
  "install.status.installed_on": "Installed on",
  "install.status.more_sites": "+{n} more",
  "install.status.seen": "seen",
  "install.status.host_leads": "{n} enquiries",
  "install.status.leads_line": "Widget {widget} · start page {page} enquiries",
  "install.status.not_detected": "Not detected on your website yet",
  "install.status.not_detected_sub": "Paste a snippet below and publish. The moment a visitor loads the page, this turns green — nothing to configure.",
  "install.status.check": "Check again",
  "install.status.checked_ok": "Live on {host}",
  "install.status.checked_none": "Nothing yet — publish the page and try again",
  "install.status.all_sites": "All {n} sites",
  "install.status.hide_sites": "Hide sites",
  "install.status.forget": "Forget site",
  "install.status.forget_confirm": "Forget {host}? It reappears automatically the next time the script loads there. Enquiries keep their attribution.",
  "install.status.forgotten": "Forgot {host}",
  "install.dev.events": "Conversion events",
  "install.dev.events_sub": "Every completed enquiry fires an event on your page — so Google Analytics, Tag Manager, Meta or your own scripts can count it as a conversion.",
  "install.dev.events_note": "gtag() and fbq() are called automatically when present on the page. Works in every mode, including the popup.",
  "install.eyebrow": "Choose how owners reach you",
  "install.mode.link": "Hosted link",
  "install.mode.link_sub": "A ready-made page on your brand. Share it anywhere.",
  "install.mode.inline": "Inline widget",
  "install.mode.inline_sub": "Address search embedded directly in your page.",
  "install.mode.button": "Button",
  "install.mode.button_sub": "A call-to-action that opens the journey in a popup.",
  "install.mode.floating": "Floating launcher",
  "install.mode.floating_sub": "A pill in the corner of every page. Always one tap away.",
  "install.mode.developer": "API & webhooks",
  "install.mode.developer_sub": "Send leads anywhere: Zapier, Make, HubSpot or your own CRM.",
  "install.step.copy": "Copy",
  "install.step.paste": "Paste",
  "install.step.publish": "Publish",
  "install.snippet": "Your snippet",
  "install.snippet_note": "Paste it where the widget should appear. It loads asynchronously and never slows down your page.",
  "install.snippet_note_floating": "Paste it once before the closing </body> tag — the launcher then follows visitors across your site.",
  "install.snippet_note_button": "Paste it where the button should appear. Prefer your own button? Add data-listed-open to any element instead.",
  "install.copy_snippet": "Copy snippet",
  "install.copied": "Copied to clipboard",
  "install.preview": "Live preview",
  "install.preview_note": "Exactly what visitors see — with your current branding and copy.",
  "install.preview_page": "Your website",
  "install.try_popup": "Try the popup",
  "install.options": "Options",
  "install.opt.cta": "Button text",
  "install.opt.cta_help": "Leave empty to use the text from Lead capture.",
  "install.opt.accent": "Button colour",
  "install.opt.accent_help": "Defaults to ink. Use your brand colour for a stronger match.",
  "install.opt.position": "Corner",
  "install.opt.position.right": "Bottom right",
  "install.opt.position.left": "Bottom left",
  "install.opt.open": "On click",
  "install.opt.open.popup": "Open in a popup",
  "install.opt.open.tab": "Open in a new tab",
  "install.opt.max_width": "Max width",
  "install.opt.source": "Lead source tag",
  "install.opt.source_help": "Shown on every lead so you know which placement converts.",
  "install.link.title": "Your start page",
  "install.link.sub": "Fully branded, mobile-first, no code. Use it in ads, newsletters, listings and your navigation.",
  "install.link.open": "Open page",
  "install.link.copy": "Copy link",
  "install.link.utm": "Campaign link builder",
  "install.link.utm_sub": "Add tracking so every lead tells you where it came from.",
  "install.link.utm_source": "Source (utm_source)",
  "install.link.utm_medium": "Medium (utm_medium)",
  "install.link.utm_campaign": "Campaign (utm_campaign)",
  "install.link.result": "Tracked link",
  "install.qr.title": "QR code",
  "install.qr.sub": "Print-ready. Put it on flyers, key boxes, invoices and business cards.",
  "install.qr.download": "Download SVG",
  "install.qr.copy": "Copy image link",
  "install.guides": "Platform guides",
  "install.guides_sub": "Step-by-step for the tools property managers actually use. Same snippet everywhere.",
  "install.guide.wordpress": "WordPress",
  "install.guide.webflow": "Webflow",
  "install.guide.squarespace": "Squarespace",
  "install.guide.wix": "Wix",
  "install.guide.framer": "Framer",
  "install.guide.shopify": "Shopify",
  "install.guide.html": "Any HTML site",
  "install.guide.wordpress.1": "Edit the page and add a **Custom HTML** block where the widget should appear (or use a Code Block widget in Elementor / Divi).",
  "install.guide.wordpress.2": "Paste the snippet and click **Update**.",
  "install.guide.wordpress.3": "For the floating launcher, paste it once in **Appearance → Theme File Editor → footer.php** before </body>, or use a “Header & Footer Scripts” plugin.",
  "install.guide.webflow.1": "Drag an **Embed** element (Add → Components → Embed) onto the page.",
  "install.guide.webflow.2": "Paste the snippet, save and **Publish**.",
  "install.guide.webflow.3": "For the floating launcher, paste it in **Project settings → Custom code → Footer code** instead.",
  "install.guide.squarespace.1": "Add a **Code** block to the page section where you want the widget.",
  "install.guide.squarespace.2": "Paste the snippet (keep “HTML” selected) and save.",
  "install.guide.squarespace.3": "For the floating launcher use **Settings → Advanced → Code Injection → Footer**.",
  "install.guide.wix.1": "In the editor click **Add → Embed code → Embed HTML** and place the box where the widget goes.",
  "install.guide.wix.2": "Paste the snippet, click **Update** and resize the box to about 720 × 320 px.",
  "install.guide.wix.3": "For the floating launcher use **Settings → Custom code → Add code → Body – end**.",
  "install.guide.framer.1": "Insert an **Embed** component and switch it to **HTML**.",
  "install.guide.framer.2": "Paste the snippet and publish.",
  "install.guide.framer.3": "For the floating launcher use **Site settings → General → Custom code → End of body**.",
  "install.guide.shopify.1": "Open **Online Store → Themes → Customize** and add a **Custom Liquid** section where the widget goes.",
  "install.guide.shopify.2": "Paste the snippet and save.",
  "install.guide.shopify.3": "For the floating launcher paste it in **theme.liquid** just before </body>.",
  "install.guide.html.1": "Open the HTML file of the page.",
  "install.guide.html.2": "Paste the snippet where the widget should render (inline / button) or right before </body> (floating).",
  "install.guide.html.3": "Deploy. The script is ~4 KB, loads async and has no dependencies.",
  "install.dev.title": "Developer access",
  "install.dev.sub": "Everything the widget does is available as a public, tenant-scoped API — and every important event can be pushed to you.",
  "install.dev.api": "Lead API",
  "install.dev.api_sub": "Create a lead from any form, chatbot or backend. No key needed — the endpoint is scoped to your public slug and rate-limited.",
  "install.dev.endpoint": "Endpoint",
  "install.dev.example": "Example request",
  "install.dev.fields": "Fields",
  "install.dev.field.owner": "owner.name, owner.email (required), owner.phone",
  "install.dev.field.property": "property.name, property.address{label,street,postal_code,city,country,lat,lon}, property_type, bedrooms, bathrooms, max_guests",
  "install.dev.field.plans": "rental_plan (all_year | part_of_year | when_not_using | unknown), start_timing (asap | date | exploring), start_date, currently_rented (none | airbnb | booking | other)",
  "install.dev.field.meta": "source (api | link | ads | social …), source_url, utm{utm_source, utm_medium, utm_campaign}, owner_note, listing{platform,url}",
  "install.dev.js_api": "JavaScript API",
  "install.dev.js_api_sub": "Open the journey from your own buttons, menus or after a form submit.",
  "install.webhooks": "Webhooks",
  "install.webhooks_sub": "We POST signed JSON to your endpoint the moment something happens. Works out of the box with Zapier, Make and n8n “Catch hook” triggers.",
  "install.webhooks.add": "Add endpoint",
  "install.webhooks.url": "Endpoint URL",
  "install.webhooks.description": "Label",
  "install.webhooks.description_ph": "e.g. Zapier → HubSpot",
  "install.webhooks.events": "Events",
  "install.webhooks.create": "Create endpoint",
  "install.webhooks.secret_title": "Signing secret",
  "install.webhooks.secret_note": "Shown once. Store it in your integration and verify X-Listed-Signature = HMAC-SHA256(secret, timestamp + “.” + body).",
  "install.webhooks.test": "Send test",
  "install.webhooks.rotate": "Rotate secret",
  "install.webhooks.disable": "Pause",
  "install.webhooks.enable": "Resume",
  "install.webhooks.delete": "Delete",
  "install.webhooks.delete_confirm": "Delete this endpoint? Deliveries stop immediately.",
  "install.webhooks.empty": "No endpoints yet",
  "install.webhooks.empty_sub": "Add one to push new leads into your CRM, a Slack channel or a spreadsheet — without writing code.",
  "install.webhooks.last": "Last delivery",
  "install.webhooks.never": "No deliveries yet",
  "install.webhooks.paused": "Paused",
  "install.webhooks.active": "Active",
  "install.webhooks.test_ok": "Delivered — your endpoint answered {code}",
  "install.webhooks.test_fail": "Delivery failed{code} — {error}",
  "install.webhooks.deliveries": "Recent deliveries",
  "install.webhooks.payload": "Payload",
  "install.webhooks.headers": "Headers",
  "install.webhooks.attempts": "{n} attempt(s)",
  "install.readonly_note": "Admins can add and change endpoints.",

  /* ---- Estimate card (lead detail) ---- */
  "lead.estimate_suggested_by": "Suggested by {source}",
  "lead.estimate_fetched": "Fetched {when}",
  "lead.estimate_cached": "from cache",
  "lead.estimate_fresh": "fresh",
  "lead.estimate_scope.platform": "platform key",
  "lead.estimate_scope.tenant": "your key",
  "lead.estimate_scope.builtin": "built-in model",
  "lead.estimate_internal_badge": "Internal model · indicative",
  "lead.estimate_internal_note": "No market-data provider is connected, so this comes from Listed's internal baseline. Treat it as a starting point and adjust before confirming.",
  "lead.estimate_manual_title": "Set the range manually",
  "lead.estimate_manual_sub": "Type the annual range you want the owner to see. This becomes the confirmed estimate.",
  "lead.estimate_applied": "Estimate confirmed — draft offers updated",
  "lead.estimate_dismissed": "Suggestion dismissed",
  "lead.estimate_status.confirmed": "Confirmed",
  "lead.estimate_status.suggested": "Suggestion",
  "lead.estimate_owner_visibility.off": "Hidden from owners (estimates are off)",
  "lead.estimate_owner_visibility.offer_only": "Shown to the owner in the offer",
  "lead.estimate_owner_visibility.instant": "Also shown instantly in the capture form",
  "lead.estimate_change": "Change",
  "builder.estimate_from_lead": "Uses the confirmed estimate on the lead. Edit here to override for this offer only.",
  "builder.estimate_hidden": "Estimates are switched off for owners in Lead capture settings — this range stays internal.",
  "capture.est.source.pricelabs": "PriceLabs (pricing only — not for estimates)",
  "capture.est.mode_help": "Default is “Only in the offer”: you review the numbers first, then the owner sees them.",
  "capture.est.policy": "Presentation policy",
  "capture.est.policy_sub": "Applied on top of what the provider returns, so owners see a safe, rounded range.",
  "capture.behaviour": "Behaviour",
  "capture.copy": "Copy",
  "capture.copy_sub": "The words on your widget and start page.",
  "capture.install_moved": "Looking for the embed code? It moved to Install & share.",
  "capture.go_install": "Open Install & share",
  "intake.estimate.unavailable_title": "We'll include your estimate in the proposal",
  "intake.estimate.unavailable_sub": "We could not calculate an instant range for this address right now. Nothing is lost — continue and we'll do it properly.",
  "intake.estimate.source": "Based on {source}",
  "intake.popup.close": "Close",
  "intake.done.close": "Close window",
  "widget.open_journey": "Continue",

  /* ---- Tenant landing (public start page) ---- */
  "tenant.nav.label": "Owner menu",
  "tenant.nav.how": "How it works",
  "tenant.nav.services": "What we handle",
  "tenant.nav.homes": "Homes",
  "tenant.nav.faq": "Questions",
  "tenant.hero.kicker": "{org} · Short-term rental management",
  "tenant.scene.location": "Bergen · Norway",
  "tenant.scene.payout_label": "Average owner payout, last 12 months",
  "tenant.scene.payout_value": "NOK 412 000",
  "tenant.scene.payout_delta": "+18% vs long-term rent",
  "tenant.scene.rating_label": "Guest rating across all homes",
  "tenant.stat.homes": "homes in our care",
  "tenant.stat.occupancy": "average occupancy",
  "tenant.stat.rating": "guest rating, 2 300+ reviews",
  "tenant.stat.response": "from enquiry to proposal",
  "tenant.services.kicker": "What we handle",
  "tenant.services.title": "Everything between the keys and the payout.",
  "tenant.services.sub": "You own the home. We run it as a hotel would — with the numbers, the guests and the little things taken care of.",
  "tenant.service.listing.title": "Listing & photography",
  "tenant.service.listing.text": "Professional photos, copy that converts and a listing live on every major channel within a week.",
  "tenant.service.pricing.title": "Dynamic pricing",
  "tenant.service.pricing.text": "Rates adjust daily to demand, events and season — so you never leave money on the table.",
  "tenant.service.guests.title": "Guest care, 24/7",
  "tenant.service.guests.text": "Screening, check-in, questions at midnight and reviews that keep your rating high.",
  "tenant.service.cleaning.title": "Cleaning & linen",
  "tenant.service.cleaning.text": "Hotel-standard turnovers with quality checks after every stay. Linen included.",
  "tenant.service.maintenance.title": "Maintenance & inspections",
  "tenant.service.maintenance.text": "Small fixes handled on the spot; anything bigger you approve with one tap.",
  "tenant.service.reporting.title": "Reporting & payouts",
  "tenant.service.reporting.text": "A clear monthly statement and your net income paid out — no chasing, no spreadsheets.",
  "tenant.homes.kicker": "Homes in our care",
  "tenant.homes.title": "From city apartments to fjord cabins.",
  "tenant.homes.sub": "A selection of the homes we manage — every one prepared, priced and looked after by our local team.",
  "tenant.home.bergen.title": "Open-plan loft, Sentrum",
  "tenant.home.bergen.meta": "2 bedrooms · sleeps 4",
  "tenant.home.bergen.rating": "4.96",
  "tenant.home.bryggen.title": "Townhouse by Bryggen",
  "tenant.home.bryggen.meta": "3 bedrooms · sleeps 6",
  "tenant.home.bryggen.rating": "4.91",
  "tenant.home.voss.title": "Mountain cabin, Voss",
  "tenant.home.voss.meta": "4 bedrooms · sleeps 8",
  "tenant.home.voss.rating": "4.88",
  "tenant.home.hardanger.title": "Fjord house, Hardanger",
  "tenant.home.hardanger.meta": "3 bedrooms · sleeps 6",
  "tenant.home.hardanger.rating": "4.94",
  "tenant.home.nordnes.title": "Apartment, Nordnes",
  "tenant.home.nordnes.meta": "1 bedroom · sleeps 2",
  "tenant.home.nordnes.rating": "4.90",
  "tenant.how.title": "From first message to first guest, in four steps.",
  "tenant.proposal.kicker": "Your proposal, within 24 hours",
  "tenant.proposal.kicker_instant": "Your estimate, instantly",
  "tenant.proposal.title": "A tailored proposal — not a brochure.",
  "tenant.proposal.title_instant": "See what your home could earn, right away.",
  "tenant.proposal.revenue.title": "Estimated annual revenue",
  "tenant.proposal.revenue.text": "Based on comparable homes and real market data for your address.",
  "tenant.proposal.services.title": "Services that fit your home",
  "tenant.proposal.services.text": "Pick what you need. Everything is priced upfront.",
  "tenant.proposal.fee.title": "One clear fee",
  "tenant.proposal.fee.text": "Accept and sign online — no PDFs, no printing, no surprises.",
  "tenant.quote.text": "“I expected spreadsheets and phone calls. Instead I got a proposal on my phone, signed it the same evening, and the first guests arrived three weeks later.”",
  "tenant.quote.name": "Ingrid Solheim",
  "tenant.quote.meta": "Owner · Townhouse by Bryggen · since 2023",
  "tenant.faq.kicker": "Questions owners ask",
  "tenant.faq.title": "Good to know before you start.",
  "tenant.faq.fee.q": "What does it cost?",
  "tenant.faq.fee.a": "A percentage of the rental income — you only pay when the home earns. The exact fee, and what it covers, is in your proposal before you decide anything.",
  "tenant.faq.control.q": "Can I still use the home myself?",
  "tenant.faq.control.a": "Yes. Block the dates you want in the owner app and we plan around them. Many owners rent only part of the year.",
  "tenant.faq.guests.q": "Who are the guests?",
  "tenant.faq.guests.a": "Verified travellers on Airbnb, Booking.com and Vrbo. We screen every booking, hold deposits where relevant and are on call around the clock.",
  "tenant.faq.cleaning.q": "How is cleaning handled?",
  "tenant.faq.cleaning.a": "Our own teams clean after every stay to a hotel standard, with photo-verified checks. Cleaning is paid by the guest as a fee where possible.",
  "tenant.faq.term.q": "Am I locked in?",
  "tenant.faq.term.a": "No. Agreements run month to month with three months' notice — you stay because it works, not because you have to.",
  "tenant.final.title": "Find out what your home could earn.",
  "tenant.final.sub": "Two minutes on your phone. {org} comes back with a tailored, no-obligation proposal.",
  "tenant.footer.blurb": "{org} runs short-term rentals for owners who want the income without the work. Local team, hotel standards, transparent numbers.",
  "tenant.footer.owners": "For owners",
  "tenant.footer.company": "Company",
  "tenant.footer.address": "Strandgaten 18, 5013 Bergen",

  // ---------------------------------------------------------------
  // Landing v5 — hero (two surfaces, eight scenes)
  // ---------------------------------------------------------------
  "l5.h.surface.phone": "Owner · phone",
  "l5.h.surface.desktop": "You · Listed",
  "l5.h.step.capture": "Enquiry",
  "l5.h.step.estimate": "Estimate",
  "l5.h.step.qualify": "Qualified",
  "l5.h.step.proposal": "Offer sent",
  "l5.h.step.offer": "Owner accepts",
  "l5.h.step.sign": "Signed",
  "l5.h.step.onboard": "Onboarding",
  "l5.h.step.live": "Live",
  "l5.h.cap.capture": "Emma enters her address on northstay.com. Google Maps verifies it as she types.",
  "l5.h.cap.estimate": "She gets an instant revenue estimate. The same second, the lead lands in your pipeline.",
  "l5.h.cap.qualify": "Her address and details become a structured property record, with a drafted summary for your review.",
  "l5.h.cap.proposal": "You build the proposal from your service catalogue and send it — a branded page, not a PDF.",
  "l5.h.cap.offer": "Emma opens it in Northstay's brand: her home, her estimate, her price. She adds photography and accepts.",
  "l5.h.cap.sign": "She signs on her phone. Timestamped and versioned — still in your brand.",
  "l5.h.cap.onboard": "Emma snaps a photo of her router — Listed reads the Wi-Fi details. House rules, access and photos follow, one step at a time.",
  "l5.h.cap.live": "At 100% readiness Listed creates the property in Guesty. Live on Airbnb and Booking.com.",
  "l5.h.tap": "Tap a step to jump",
  // phone
  "l5.ph.site_title": "What could your home earn?",
  "l5.ph.site_sub": "Start with the address. An estimate in seconds — no account needed.",
  "l5.ph.address_label": "Your address",
  "l5.ph.mode_label": "How would you like to start?",
  "l5.ph.mode_address": "Address",
  "l5.ph.mode_link": "Listing link",
  "l5.ph.placeholder": "Street and number",
  "l5.ph.sugg_meta": "1100-420 Lisbon",
  "l5.ph.verified": "Verified · Google Maps",
  "l5.ph.live_booking_title": "New booking request · Airbnb",
  "l5.ph.live_booking_meta": "12–16 July · 4 nights · 2 guests",
  "l5.ph.live_booking_amount": "€1,240",
  "l5.ph.bedrooms": "Bedrooms",
  "l5.ph.cta": "Get a free estimate",
  "l5.ph.est_eyebrow": "Your estimate",
  "l5.ph.est_meta": "Baixa, Lisbon · Emma Carter",
  "l5.ph.est_label": "Estimated annual revenue",
  "l5.ph.est_value": "€42,000 – €48,000",
  "l5.ph.est_note": "Based on comparable homes nearby. Not a guarantee.",
  "l5.ph.est_sent": "Copy sent to emma.carter@mail.com",
  "l5.ph.est_next": "{brand} will send you a tailored offer within a day.",
  "l5.ph.notif": "Your offer is ready",
  "l5.ph.notif_sub": "Rua da Prata 42 · Full Service · 15%",
  "l5.ph.offer_eyebrow": "Your offer",
  "l5.ph.offer_title": "We think Rua da Prata 42 can become a very good rental property.",
  "l5.ph.offer_meta": "Prepared for Emma Carter · Offer v1",
  "l5.ph.offer_plan": "Your plan",
  "l5.ph.offer_plan_name": "Full Service",
  "l5.ph.offer_plan_pct": "15%",
  "l5.ph.offer_of_revenue": "of revenue",
  "l5.ph.offer_inc1": "Listing, pricing and guest communication",
  "l5.ph.offer_inc2": "Cleaning and linen coordination",
  "l5.ph.offer_inc3": "Monthly owner statement",
  "l5.ph.offer_extras": "Optional extras",
  "l5.ph.offer_extras_sub": "Tap to add — the summary updates live.",
  "l5.ph.offer_photo": "Professional photography",
  "l5.ph.offer_photo_p": "€490 · one-time",
  "l5.ph.offer_styling": "Interior styling",
  "l5.ph.offer_styling_p": "€1,200 · one-time",
  "l5.ph.offer_summary": "Summary",
  "l5.ph.offer_fee": "Management fee",
  "l5.ph.offer_one_time": "One-time costs",
  "l5.ph.offer_net": "Estimated net to you (year 1)",
  "l5.ph.offer_net_short": "Net to you (year 1)",
  "l5.ph.offer_net_v": "≈ €38,000",
  "l5.ph.offer_net_v2": "≈ €37,500",
  "l5.ph.offer_accept": "Accept and continue",
  "l5.ph.offer_accepted": "Accepted · next: sign",
  "l5.ph.sign_eyebrow": "Agreement",
  "l5.ph.sign_title": "Your agreement with {brand}",
  "l5.ph.sign_meta": "Version 2 · Full Service · Photography",
  "l5.ph.sign_here": "Sign here",
  "l5.ph.signing": "Emma is signing…",
  "l5.ph.signed": "Signed · 14:32",
  "l5.ph.signed_meta": "Timestamped · versioned · copy sent to both parties",
  "l5.ph.onb_title": "Almost there, Emma",
  "l5.ph.onb_eyebrow": "Onboarding",
  "l5.ph.onb_sub": "A few quick steps — everything lands on your property record.",
  "l5.ph.onb_done": "Ready for launch — {brand} takes it from here.",
  "l5.ph.onb_rules": "House rules",
  "l5.ph.onb_photos": "Photos",
  "l5.ph.onb_photos_hint": "From Thursday’s shoot with {brand} Studio",
  "l5.ph.onb_photos_done": "12 photos added to the listing",
  "l5.ph.onb_cal": "First availability",
  "l5.ph.onb_cal_hint": "When can the first guests arrive?",
  "l5.ph.onb_cal_month": "May",
  "l5.ph.onb_cal_done": "Calendar opens Tue 20 May",
  "l5.ph.onb_ready_title": "100% ready",
  "l5.ph.onb_ready_sub": "{brand} publishes the listing — nothing more to do.",
  "l5.ph.onb_handoff_title": "Created in Guesty",
  "l5.ph.onb_handoff_sub": "24 fields mapped · 12 photos · calendar synced",
  "l5.ph.onb_now": "now",
  "l5.ph.wifi_read": "Read from photo",
  "l5.ph.live_title": "Rua da Prata 42 is live",
  "l5.ph.live_sub": "Bookable on Airbnb and Booking.com from today.",
  // desktop
  "l5.d.just_now": "just now",
  "l5.d.status.accepted": "Accepted",
  "l5.d.act.estimate": "Lead received via {domain} · estimate shown",
  "l5.d.act.qualify": "Details confirmed · summary drafted",
  "l5.d.act.proposal": "Proposal v1 sent to Emma",
  "l5.d.act.offer": "Opened · photography added · accepted",
  "l5.d.act.sign": "Agreement signed by Emma Carter",
  "l5.d.act.onboard": "Onboarding complete · 0 blockers",
  "l5.d.act.live": "Created in Guesty · live on 2 channels",
  "l5.d.action.qualify": "Create proposal",
  "l5.d.action.proposal": "Open offer",
  "l5.d.action.offer": "Open offer",
  "l5.d.action.sign": "View agreement",
  "l5.d.action.onboard": "Open onboarding",
  "l5.d.action.live": "Open in Guesty",
  "l5.d.reviewed": "Reviewed by Sarah",
  "l5.d.proposal.title": "Proposal v1 · Full Service",
  "l5.d.proposal.send": "Send to Emma",
  "l5.d.proposal.sent": "Sent 09:14",
  "l5.d.proposal.delivered": "Delivered to emma.carter@mail.com",
  "l5.d.offer.title": "Owner activity",
  "l5.d.offer.opened": "Opened by Emma",
  "l5.d.offer.viewing": "Reading the estimate and services",
  "l5.d.offer.added": "Added Professional photography",
  "l5.d.offer.accepted": "Accepted the proposal",
  "l5.d.sign.title": "Agreement v2",
  "l5.d.sign.awaiting": "Awaiting Emma's signature",
  "l5.d.sign.signed": "Signed by Emma Carter",
  "l5.d.sign.meta": "14:32 · e-signature · v2",
  "l5.d.ready.title": "Launch readiness",
  "l5.d.ready.progress": "Owner onboarding in progress",
  "l5.d.live.title": "Handoff",
  "l5.d.live.record": "Property record",
  "l5.d.live.created": "Created in Guesty",
  "l5.d.live.channels": "Distributed to",
  "l5.d.facts.type": "Type",
  "l5.d.facts.type_v": "Apartment · 92 m²",
  "l5.d.facts.beds": "Bedrooms",
  "l5.d.facts.beds_v": "3 · sleeps 6",
  "l5.d.facts.listing": "Availability",
  "l5.d.facts.listing_v": "Full year · from June",
  "l5.d.facts.estimate": "Revenue estimate",
  "l5.d.facts.estimate_v": "€42–48k / yr",
  "l5.d.facts.plan": "Rental plan",
  "l5.d.facts.plan_v": "Full service · from June",
  "l5.d.open_leads": "{n} open leads",
  "l5.d.proposal.template": "Template · Full Service",
  "l5.d.proposal.to": "To Emma Carter · emma.carter@mail.com",
  "l5.d.offer.live": "Live",
  "l5.d.offer.choices": "Emma's choices",
  "l5.d.proposal.services": "Services",
  "l5.d.proposal.row1_d": "Listing, pricing, guest communication and owner statements",
  "l5.d.proposal.row2_d": "Shoot and 25 edited photos, delivered before launch",
  "l5.d.proposal.row3_d": "Stylist visit with a prioritised shopping list",
  "l5.d.facts.estimate_short": "€42–48k / yr",
  "l5.ph.est_next_title": "What happens next",
  "l5.ph.est_n1": "{brand} reviews your home today",
  "l5.ph.est_n2": "You get a tailored offer within a day",
  "l5.ph.est_n3": "Sign online and go live in about a week",
  "l5.d.proposal.add": "Add from service catalogue",
  "l5.d.proposal.owner_sees": "What Emma sees",
  "l5.d.proposal.optional_note": "Optional extras",
  "l5.d.sign.terms": "Terms",
  "l5.d.sign.term": "Term",
  "l5.d.sign.term_v": "Month to month · 3 months' notice",
  "l5.d.sign.start": "Start",
  "l5.d.sign.start_v": "1 June",
  "l5.d.sign.signature": "Signature",
  "l5.d.sign.esign": "Listed e-signature",
  "l5.d.ready.count": "{n} of 5 complete",
  "l5.d.ready.blockers": "{n} waiting on the owner",
  "l5.d.ready.zero": "0 blockers · ready to launch",
  "l5.d.ready.checklist": "Checklist",
  "l5.d.ready.owner": "Owner · phone",
  "l5.d.ready.internal": "Internal",
  "l5.ph.onb_wifi_hint": "Snap a photo of your router — we read the details.",
  "l5.ph.onb_take_photo": "Take a photo",
  "l5.ph.onb_reading": "Reading…",
  "l5.ph.onb_read_done": "Read from photo",
  "l5.ph.onb_network": "Network",
  "l5.ph.onb_password": "Password",
  "l5.ph.onb_looks_right": "Looks right",
  "l5.ph.onb_rules_hint": "Tap what applies. Guests see this before booking.",
  "l5.ph.onb_rules_more": "Anything else? (optional)",
  "l5.ph.onb_continue": "Continue",
  // trust strip
  "l5.trust.eyebrow": "Ends in the PMS you already run",
  "l5.trust.s1": "Listed hands the signed property to",
  "l5.trust.or": "or",
  "l5.trust.s2": "as a controlled draft — every field filled in, nothing typed twice — or links it to the listing you already run in",
  "l5.trust.end": ".",
  // ---------------------------------------------------------------
  // Landing v5 — integrations
  // ---------------------------------------------------------------
  "l5.int.eyebrow": "Integrations",
  "l5.int.title": "Your PMS stays the system of record.",
  "l5.int.sub": "Listed runs the journey up to a launch-ready property, then creates it in the PMS you already use. Channels, address data and AI sit behind adapters you can swap without touching the owner experience.",
  "l5.int.handoff.title": "One record. Created in your PMS.",
  "l5.int.handoff.sub": "When the last blocker clears, Listed maps the property record to your PMS — created as a controlled draft in Guesty, Hostaway or DigiHome, linked to the listing you already run in Lodgify or Smoobu. Nothing re-typed. Pick a PMS to watch it land.",
  "l5.int.record": "Property record",
  "l5.int.ready": "Launch-ready",
  "l5.int.complete": "7 of 7 complete",
  "l5.int.new_property": "New property",
  "l5.int.active": "Active",
  "l5.int.open_in": "Open in {pms}",
  "l5.int.created_in": "Created in {pms}",
  "l5.int.native": "DigiHome runs on the same record — nothing to map.",
  "l5.int.auto": "Auto-cycling · tap a PMS to pin",
  "l5.int.pinned": "Pinned · tap again to resume",
  "l5.int.f.address": "Verified address",
  "l5.int.f.owner": "Owner & agreement",
  "l5.int.f.access": "Check-in & access",
  "l5.int.f.wifi": "Wi-Fi",
  "l5.int.f.rules": "House rules",
  "l5.int.f.photos": "Photos (12)",
  "l5.int.f.pricing": "Pricing & fees",
  "l5.int.grid.title": "Everything around the record",
  "l5.int.grid.sub": "Real names, honest status. Connected means live today; Adapter ready means built to the vendor's format and enabled with your own credentials; Links existing listings means the vendor's API does not create properties yet, so Listed attaches the signed owner to a listing you already run.",
  "l5.int.role.pms": "PMS",
  "l5.int.role.channel": "Channel",
  "l5.int.role.address": "Addresses",
  "l5.int.role.estimate": "Revenue data",
  "l5.int.role.pricing": "Dynamic pricing",
  "l5.int.role.ai": "AI drafts",
  "l5.int.status.live": "Connected",
  "l5.int.status.adapter": "Adapter ready",
  "l5.int.status.detect": "Detects listings",
  "l5.int.request": "Request an integration",
  "l5.int.request_sub": "Missing a PMS or channel? Let us know — adapters are quick to add.",
  // ---------------------------------------------------------------
  // Landing v5 — journey record (humanised)
  // ---------------------------------------------------------------
  "l5.jr.record_meta": "Property record · Northstay",
  "l5.jr.adds": "Added to the record",
  "l5.jr.r.estimate_owner": "Shown to owner",
  "l5.jr.r.audit": "Audit trail",
  "l5.jr.r.audit_v": "Timestamp · IP · document version",
  "l5.jr.r.new_in": "New property in Guesty",
  "l5.jr.r.created": "Created in Guesty",
  "l5.jr.pms.f1": "Address",
  "l5.jr.pms.f2": "Check-in instructions",
  "l5.jr.pms.f3": "Wi-Fi",
  "l5.jr.pms.f4": "House rules",
  "l5.jr.pms.f5": "12 photos",
  "l5.jr.pms.f6": "Base price",

  // ---- Landing v6 · Journey "One property, start to finish." ----
  "l6.jr.sub": "Every step writes to the same record — the one that ends up in your PMS. Scroll, and watch Rua da Prata 42 fill in: from the first tap on your website to a live listing, two days later.",
  "l6.jr.t0": "First enquiry",
  "l6.jr.t9": "Live",
  "l6.jr.out.lead": "Verified address · owner · estimate",
  "l6.jr.out.property": "Type · bedrooms · availability · note",
  "l6.jr.out.proposal": "Offer v1 · opened · accepted",
  "l6.jr.out.sign": "Signature · agreement · start date",
  "l6.jr.out.onboarding": "Access · Wi-Fi · house rules · 12 photos",
  "l6.jr.out.pms": "PMS ID · 24 fields mapped",
  "l6.jr.out.live": "Airbnb · Booking.com · first booking",
  "l6.jr.lead.via": "Your website · estimate",
  "l6.jr.lead.est": "Instant estimate · shown to Emma",
  "l6.jr.lead.est_note": "Per year · 3 bedrooms in Baixa, Lisbon · medium confidence",
  "l6.jr.proposal.title": "Offer to Emma",
  "l6.jr.sign.title": "Agreement",
  "l6.jr.sign.copies": "Copy to both parties",
  "l6.jr.onb.title": "Onboarding",
  "l6.jr.onb.by": "Completed by Emma · on her phone",
  "l6.jr.live.done": "Lead to live in 2 days · nothing typed twice",

  // ---- Landing v6 · Hero narrator (short typewritten titles) ----
  "l6.h.title.capture": "Emma enters her address.",
  "l6.h.title.estimate": "An estimate, in seconds.",
  "l6.h.title.qualify": "Her details become a property.",
  "l6.h.title.proposal": "You build her offer.",
  "l6.h.title.offer": "She opens it — in your brand.",
  "l6.h.title.sign": "Signed on her phone.",
  "l6.h.title.onboard": "Onboarding, room by room.",
  "l6.h.title.live": "Rua da Prata\u00a042 goes live.",

  // ---- Landing v6 · Hero detail copy ----
  "l6.h.prop.delivery": "Delivery",
  "l6.h.prop.to": "To",
  "l6.h.prop.valid": "Valid until",
  "l6.h.prop.valid_v": "30 June",
  "l6.h.prop.sender": "From",
  "l6.h.sign.payout": "Payout",
  "l6.h.sign.payout_v": "Monthly · by the 10th",
  "l6.h.sign.notice": "Notice",
  "l6.h.sign.notice_v": "3 months, either side",
  "l6.h.sign.term_short": "Month to month",
  "l6.h.sign.ts": "Timestamp",
  "l6.h.sign.ip": "IP",
  "l6.h.sign.doc": "Document",
  "l6.h.sign.copy": "Copy sent to you",
  "l6.h.sign.next": "Continue to onboarding",
  "l6.h.lock.hint": "Swipe up to open",

  // ---- Landing v6 · Capabilities fragments ----
  "l6.cap.capture.hosted": "Hosted",
  "l6.cap.capture.embed": "Embed",
  "l6.cap.capture.qr": "QR code",
  "l6.cap.capture.qr_desc": "Print-ready QR code",
  "l6.cap.capture.qr_alt": "QR code to the Northstay start page",
  "l6.cap.onb.title": "Owner checklist",
  "l6.cap.onb.photos_v": "12 uploaded",
  "l6.cap.onb.parking_v": "Waiting on Emma",
  "l6.cap.onb.router": "Router photo",
  "l6.cap.onb.network": "Network",
  "l6.cap.onb.password": "Password",
  "l6.cap.onb.confirmed": "Confirmed by Emma",
  "l6.cap.handoff.readiness": "Launch readiness",
  "l6.cap.handoff.no_blockers": "No open blockers",
  "l6.cap.handoff.blockers_sub": "Nothing goes live with a blocker open.",
  // ---- Landing v6 · White-label ----
  "l6.wl.hosted": "Hosted by Listed",
  "l6.wl.hosted_short": "listed · hosted",

  // ---- Landing v6 · Hero narrator (descriptive, sentence by sentence) ----
  "l6.h.desc.capture": "Emma lands on northstay.com. She can start with her address or a link to an existing listing — she types the address. Google Maps verifies it as she types, she picks the number of bedrooms, and asks for an estimate. No forms, no account.",
  "l6.h.desc.estimate": "She gets an instant revenue estimate for Rua da Prata 42. The same second, a structured lead lands in your pipeline: address, owner, bedrooms, estimate. Nothing to re-type.",
  "l6.h.desc.qualify": "The address and details Emma entered become a structured property record: type, bedrooms, availability, estimate. Listed drafts a summary for you. You review it, adjust what you like, and pick the proposal template that fits.",
  "l6.h.desc.proposal": "From your own service catalogue you put together the offer for Rua da Prata 42: management fee, photography, optional extras. Then you send it as a branded web page — not a PDF attachment.",
  "l6.h.desc.offer": "Emma opens it on her phone, in Northstay's colours: her home, her estimate, her price. She adds professional photography and accepts. You watch it happen in real time.",
  "l6.h.desc.sign": "She signs the agreement with a finger. Timestamped, versioned and stored on the property record. Both parties get a copy — still in your brand.",
  "l6.h.desc.onboard": "A guided walk through the home, one step at a time. She photographs the router and Listed reads the Wi-Fi details. House rules, access and photos follow. Every answer lands on the record.",
  "l6.h.desc.live": "At 100% readiness, Listed creates the property in Guesty: address, check-in, Wi-Fi, rules, photos, price. Two days after the first enquiry, Rua da Prata 42 is live on Airbnb and Booking.com.",

  /* ---- Landing v8 hero — one property, one surface at a time, nine chapters ---- */
  "l7.h.group.enquiry": "Enquiry",
  "l7.h.group.offer": "Offer",
  "l7.h.group.agreement": "Agreement",
  "l7.h.group.onboarding": "Onboarding",
  "l7.h.group.live": "Live",
  "l7.h.surface.phone": "Homeowner · {domain}",
  "l7.h.surface.desktop": "You · Listed workspace",
  "l7.h.step.site": "Your website",
  "l7.h.step.capture": "Verified address",
  "l7.h.step.details": "Property details",
  "l7.h.step.estimate": "Instant estimate",
  "l7.h.step.qualify": "Qualified record",
  "l7.h.step.proposal": "Offer sent",
  "l7.h.step.offer": "Offer accepted",
  "l7.h.step.sign": "E-signed",
  "l7.h.step.photo": "Photography booked",
  "l7.h.step.onboard": "Onboarding complete",
  "l7.h.step.live": "Live in your PMS",

  "l7.h.title.site": "It starts on your website.",
  "l7.h.title.capture": "One address. Verified instantly.",
  "l7.h.title.details": "Every answer becomes a field.",
  "l7.h.title.estimate": "An instant estimate. A structured lead.",
  "l7.h.title.qualify": "A complete record before the first call.",
  "l7.h.title.proposal": "The offer, built in minutes.",
  "l7.h.title.offer": "A branded web page, not a PDF.",
  "l7.h.title.sign": "Signed on the phone.",
  "l7.h.title.photo": "Photography, booked in a tap.",
  "l7.h.title.onboard": "Onboarding, room by room.",
  "l7.h.title.live": "Live in your PMS. Nothing typed twice.",
  "l7.h.desc.capture": "Emma owns an apartment on Rua da Prata in Lisbon and wants someone to run it as a rental. She lands on northstay.com — your site, your brand — and types her address. Google Maps verifies it as she types. No forms, no account.",
  "l7.h.desc.details": "Property type, bedrooms, bathrooms, when it is available — and a note in her own words. Thirty seconds on Emma's phone. Every answer becomes a field on the property record, not a line in an email.",
  "l7.h.desc.estimate": "She gets an instant revenue estimate for Rua da Prata 42. The same second, a structured lead lands in your pipeline: address, owner, bedrooms, estimate. Nothing to re-type.",
  "l7.h.desc.qualify": "Everything Emma entered is already a property record: type, bedrooms, availability, estimate. Listed drafts a summary for you. You review it, adjust what you like, and pick the offer template that fits.",
  "l7.h.desc.proposal": "From your own service catalogue you put together the offer for Rua da Prata 42: management fee, photography, optional extras. You preview it exactly as Emma will see it — then send it as a branded web page, not a PDF attachment.",
  "l7.h.desc.offer": "Emma opens it on her phone, in Northstay's colours: her home, her estimate, her price. She adds professional photography and accepts. You watch it happen, live, on the record.",
  "l7.h.desc.sign": "She signs the agreement with a finger. Timestamped, versioned and stored on the property record. Both parties get a copy — still in your brand.",
  "l7.h.desc.photo": "Photography was part of the offer, so the booking comes next. Emma picks a day and a time from your photographer's availability. The shoot lands on the record, the photographer is briefed, and the reminders send themselves.",
  "l7.h.desc.onboard": "A guided walk through the home, one step at a time. She photographs the router and Listed reads the Wi-Fi details. House rules, access and photos follow. Every answer lands on the record.",
  "l7.h.desc.live": "At 100% readiness, Listed creates the property in Guesty: address, check-in, Wi-Fi, rules, photos, price. Two days after the first enquiry, Rua da Prata 42 is live on Airbnb and Booking.com.",

  /* hero v9 · narration beats — each caption lands exactly when the same thing happens on screen */
  "l8.h.beat.site.1": "A homeowner lands on {brand}’s website — your site, your brand, your promise.",
  "l8.h.beat.site.2": "Listed adds one entry point: a free rental estimate.",
  "l8.h.beat.site.3": "Tap it, and Listed opens right there — still on {domain}, still your brand.",
  "l8.h.beat.capture.1": "The first question is the address. Nothing else yet.",
  "l8.h.beat.capture.2": "Google Maps suggests the exact match while it is being typed.",
  "l8.h.beat.capture.3": "Verified instantly and pinned on the map. No form, no account.",
  "l8.h.beat.capture.4": "One tap to continue.",
  "l8.h.beat.details.1": "Property type, bedrooms and bathrooms — one tap each.",
  "l8.h.beat.details.2": "When the home becomes available.",
  "l8.h.beat.details.3": "A short note from the owner gives you context before the first call.",
  "l8.h.beat.details.4": "Thirty seconds in total. Every answer lands as a structured field on the property record — never a line in an email.",
  "l8.h.beat.estimate.1": "The owner receives an instant revenue estimate for Rua da Prata 42, presented in your brand.",
  "l8.h.beat.estimate.2": "The enquiry is submitted, with a clear picture of what happens next.",
  "l8.h.beat.estimate.3": "Meanwhile, in your Listed workspace…",
  "l8.h.beat.estimate.4": "A structured lead arrives in your pipeline: verified address, owner, bedrooms and estimate. Nothing to re-type.",
  "l8.h.beat.qualify.1": "Everything the owner entered is already a property record: verified address, key facts and the note.",
  "l8.h.beat.qualify.2": "Listed drafts a summary and suggests the offer template that fits best.",
  "l8.h.beat.qualify.3": "Review, adjust, move on — about a minute of your time.",
  "l8.h.beat.proposal.1": "Assemble the offer from your own service catalogue: management fee, photography and optional extras.",
  "l8.h.beat.proposal.2": "Preview it exactly as the owner will see it: a branded web page, not a PDF attachment.",
  "l8.h.beat.proposal.3": "Send it with one click.",
  "l8.h.beat.proposal.4": "Delivered — and tracked from here on: opened, adjusted, accepted.",
  "l8.h.beat.offer.1": "A notification lands on the owner’s phone.",
  "l8.h.beat.offer.2": "The offer opens in {brand}’s colours: the home, the estimate and the price.",
  "l8.h.beat.offer.3": "Extras can be added on the spot — the total updates instantly.",
  "l8.h.beat.offer.4": "Accepted with one tap.",
  "l8.h.beat.offer.5": "You see it happen live on the property record.",
  "l8.h.beat.sign.1": "The agreement opens on the phone — the same terms, the same brand.",
  "l8.h.beat.sign.2": "Signed with a finger.",
  "l8.h.beat.sign.3": "Timestamped, versioned and stored on the record.",
  "l8.h.beat.sign.4": "Both parties receive a copy. The record moves to Signed.",
  "l8.h.beat.photo.1": "Photography was part of the offer, so the booking comes next.",
  "l8.h.beat.photo.2": "The owner picks a date and time from your photographer’s availability.",
  "l8.h.beat.photo.3": "Confirmed.",
  "l8.h.beat.photo.4": "The shoot is added to the record. Your photographer is briefed, and reminders go out automatically.",
  "l8.h.beat.onboard.1": "A guided walk through the home on the owner’s phone — one step at a time, no second visit.",
  "l8.h.beat.onboard.2": "A photo of the router: Listed reads the network name and password.",
  "l8.h.beat.onboard.3": "House rules — a tap each.",
  "l8.h.beat.onboard.4": "The photographer’s 12 photos arrive on the record by themselves. Then the first availability.",
  "l8.h.beat.onboard.5": "Launch readiness: 100%. Listed creates the property in your PMS — 24 fields mapped, nothing typed twice.",
  "l8.h.beat.onboard.6": "In your workspace the record is complete: access, Wi-Fi, rules, photos, calendar — and a PMS ID.",
  "l8.h.beat.live.1": "At 100% readiness, Listed creates the property in Guesty.",
  "l8.h.beat.live.2": "Address, check-in, Wi-Fi, house rules, photos and pricing — mapped field by field.",
  "l8.h.beat.live.3": "Live on Airbnb and Booking.com.",
  "l8.h.beat.live.4": "Two days after the first enquiry — and nothing typed twice.",
  /* phone · details step */
  "l7.ph.cta_continue": "Continue",
  "l7.site.eyebrow": "Holiday-rental management",
  "l7.site.title": "Rent out your home, without the work.",
  "l7.site.cta": "Get my estimate",
  "l7.site.how": "How it works",
  "l7.site.t1": "Dynamic pricing",
  "l7.site.t2": "Guest care, 24/7",
  "l7.site.t3": "Monthly payouts",
  "l7.site.homes": "Homes we manage",
  "l7.ph.cap_eyebrow": "Free rental estimate",
  "l7.d.owner_role": "Homeowner",
  "l7.d.preview.cta": "Preview",
  "l7.d.preview.title": "Preview · exactly what Emma sees",
  "l7.d.preview.desktop": "Desktop",
  "l7.d.preview.mobile": "Mobile",
  "l7.d.preview.est_short": "Est. annual revenue",
  "l7.d.preview.zero": "€0",
  "l7.d.tl.previewed": "Previewed as Emma sees it",
  "l5.ph.offer_fee_v": "15% of revenue",
  "l7.ph.det_eyebrow": "About your home",
  "l7.ph.det_title": "Tell us about Rua da Prata 42",
  "l7.ph.det_sub": "Four quick questions, then your estimate.",
  "l7.ph.det_type": "Property type",
  "l7.ph.det_type_apartment": "Apartment",
  "l7.ph.det_type_house": "House",
  "l7.ph.det_type_villa": "Villa",
  "l7.ph.det_beds": "Bedrooms",
  "l7.ph.det_baths": "Bathrooms",
  "l7.ph.det_from": "Available from",
  "l7.ph.det_from_now": "Now",
  "l7.ph.det_from_june": "June",
  "l7.ph.det_from_later": "Later",
  "l7.ph.det_note": "Anything we should know?",
  "l7.ph.det_note_ph": "Optional — in your own words",
  "l7.ph.det_note_v": "Renting it out myself today — too much work next to my job.",
  "l7.ph.est_beds": "3 bedrooms",
  "l7.ph.est_baths": "2 bathrooms",
  "l7.ph.det_cta": "Get my estimate",
  "l7.ph.det_privacy": "No account needed · 30 seconds",
  "l7.ph.det_q_type": "What kind of home is it?",
  "l7.ph.det_q_rooms": "Bedrooms and bathrooms?",
  "l7.ph.det_q_from": "When could guests arrive?",
  "l7.ph.det_type_apartment_h": "A flat in a shared building",
  "l7.ph.det_type_house_h": "A whole house",
  "l7.ph.det_type_villa_h": "Villa, cabin or holiday home",
  "l7.ph.det_from_now_h": "The home is ready today",
  "l7.ph.det_from_june_h": "After the current season",
  "l7.ph.det_from_later_h": "Not sure yet",
  "l7.ph.det_note_hint": "Optional — helps us prepare for the first call.",
  "l7.ph.det_tap_hint": "Tap an answer to continue",

  /* phone · photo shoot booking */
  "l7.ph.photo_eyebrow": "Photography",
  "l7.ph.photo_title": "Book your photo shoot",
  "l7.ph.photo_sub": "Our photographer comes to you. Pick a time that suits.",
  "l7.ph.photo_week": "June",
  "l7.ph.photo_free": "Available",
  "l7.ph.photo_slots": "Time",
  "l7.ph.photo_meta": "{brand} Studio · ~2 hours",
  "l7.ph.photo_meta_sub": "25 edited photos before launch",
  "l7.ph.photo_onsite": "You meet the photographer on site",
  "l7.ph.photo_cta": "Confirm booking",
  "l7.ph.photo_hint": "Free to move up to 48 hours before",
  "l7.ph.photo_done": "Booked · Thu 12 June, 10:00",
  "l7.ph.photo_done_sub": "Added to your calendar. We remind you the day before.",

  /* desktop · photo shoot */
  "l7.d.action.photo": "Open calendar",
  "l7.d.photo.title": "Photo shoot",
  "l7.d.photo.when": "Thursday 12 June · 10:00",
  "l7.d.photo.who": "Photographer",
  "l7.d.photo.who_v": "Nuno · {brand} Studio",
  "l7.d.photo.dur": "Duration",
  "l7.d.photo.dur_v": "≈ 2 hours",
  "l7.d.photo.access": "Access",
  "l7.d.photo.access_v": "Emma meets on site",
  "l7.d.photo.status": "Confirmed by Emma",
  "l7.d.photo.next": "Done for you",
  "l7.d.photo.n1": "Photographer briefed · address, access, 25 photos",
  "l7.d.photo.n2": "Reminder to Emma scheduled · 11 June",
  "l7.d.photo.n3": "Onboarding link sent to Emma",
  "l7.d.tl.photo": "Photo shoot booked · 12 June",

  /* ---- Pricing page ---- */
  "pr.eyebrow": "Pricing",
  "pr.title": "Free until you sign an owner.",
  "pr.sub": "No monthly fee. No seats. No setup. Run every enquiry, estimate and offer through Listed — and pay one flat amount only when an owner signs on the platform.",
  "pr.currency": "Currency",
  "pr.card.use": "To use Listed",
  "pr.card.per_month": "per month, forever",
  "pr.card.signed": "Per signed owner",
  "pr.card.one_time": "one-time, when the agreement is signed",
  "pr.card.note": "Volume pricing applies automatically. If an owner never signs, nothing is charged.",
  "pr.card.cta": "Start for free",
  "pr.card.cta2": "Talk to us",
  "pr.card.included": "Everything included",
  "pr.inc.1": "Unlimited users, leads and properties",
  "pr.inc.2": "Website widget and instant estimate pages",
  "pr.inc.3": "Pipeline, property records and AI summaries",
  "pr.inc.4": "Branded offers with e-signature",
  "pr.inc.5": "Owner onboarding and photo-shoot booking",
  "pr.inc.6": "PMS handoff: Guesty, Hostaway, Hostfully, Beds24, Lodgify, Smoobu, Uplisting, Hospitable, DigiHome",
  "pr.inc.7": "White-label domain and sender",
  "pr.inc.8": "Webhooks, Zapier and Make",
  "pr.tiers.eyebrow": "Volume pricing",
  "pr.tiers.title": "The more you sign, the less you pay.",
  "pr.tiers.sub": "Tiers are per calendar year and apply automatically. Cross a threshold, and every owner after it costs less — no plan changes, no calls.",
  "pr.tiers.t1": "First 10 owners",
  "pr.tiers.t2": "Owners 11–50",
  "pr.tiers.t3": "Owner 51 and up",
  "pr.tiers.each": "per signed owner",
  "pr.tiers.enterprise": "Enterprise",
  "pr.tiers.enterprise_sub": "Multiple brands, SSO, an SLA and a dedicated success manager — on a custom agreement.",
  "pr.tiers.enterprise_cta": "Let's talk",
  "pr.count.eyebrow": "What counts",
  "pr.count.title": "One fee. One moment. Once per property.",
  "pr.count.s1": "The owner accepts your offer",
  "pr.count.s1_d": "Estimates, offers and revisions are free — send as many as you like.",
  "pr.count.s2": "They sign the agreement in Listed",
  "pr.count.s2_d": "The e-signature on the management agreement is the trigger. Nothing before it costs anything.",
  "pr.count.s3": "The fee is added to your monthly invoice",
  "pr.count.s3_d": "At your current tier. Renewals and re-signing the same property are free. Cancelled within 14 days? Credited in full.",
  "pr.roi.eyebrow": "Return",
  "pr.roi.title": "One signed owner pays for itself in days.",
  "pr.roi.sub": "Move the sliders to your numbers. Listed is a fraction of the first month's commission — and there is no cost for the owners who don't sign.",
  "pr.roi.revenue": "Average annual revenue per property",
  "pr.roi.fee": "Your management fee",
  "pr.roi.owners": "Owners you sign per year",
  "pr.roi.commission": "Your commission per owner, year 1",
  "pr.roi.listed": "Listed per signed owner",
  "pr.roi.share": "Share of first-year commission",
  "pr.roi.payback": "Paid back after",
  "pr.roi.days": "{n} days",
  "pr.roi.day": "1 day",
  "pr.roi.total": "Per year",
  "pr.roi.total_commission": "Commission from signed owners",
  "pr.roi.total_listed": "Listed, total",
  "pr.roi.note": "Illustrative. Commission depends on your fee and the property's revenue; Listed fees exclude VAT.",
  "pr.faq.eyebrow": "Questions",
  "pr.faq.title": "Straight answers.",
  "pr.faq.q1": "Is it really free to use?",
  "pr.faq.a1": "Yes. Every seat, lead, estimate, offer and property record is free — for as long as you like. The only invoice you ever get is for owners who signed through Listed.",
  "pr.faq.q2": "When exactly am I charged?",
  "pr.faq.a2": "The moment an owner signs the management agreement in Listed. Signed owners are collected on one invoice at the end of the month, priced at your current volume tier.",
  "pr.faq.q3": "What if the owner backs out?",
  "pr.faq.a3": "If the agreement is cancelled within 14 days of signing, the fee is credited in full. After that the property is yours to manage and the fee stands.",
  "pr.faq.q4": "Do I pay for owners I bring in myself?",
  "pr.faq.a4": "Only if they sign in Listed. You can run your own leads through the same pipeline and offer flow — and pay the same flat fee when they sign. Owners you sign outside the platform cost nothing.",
  "pr.faq.q5": "Are PMS integrations extra?",
  "pr.faq.a5": "No. The handoff to Guesty, Hostaway, Hostfully, Beds24, Lodgify, Smoobu, Uplisting, Hospitable and DigiHome is included. Your PMS subscription is between you and the PMS.",
  "pr.faq.q6": "Which currencies do you invoice in?",
  "pr.faq.a6": "NOK or EUR, your choice per workspace. Prices exclude VAT.",
  "pr.faq.q7": "Is there a contract or a minimum?",
  "pr.faq.a7": "No. Create a workspace, invite your team and install the widget in an afternoon. Leave whenever you want and take your data with you.",
  "pr.cta.title": "Start for free. Pay when it works.",
  "pr.cta.sub": "Set up your workspace, install the widget and send your first offer today. Your first invoice arrives when your first owner signs.",

  /* desktop · frame */
  "l7.d.crumb.pipeline": "Pipeline",
  "l7.d.crumb.properties": "Properties",
  "l7.d.search": "Search",
  "l7.d.tab.overview": "Overview",
  "l7.d.tab.offer": "Offer",
  "l7.d.tab.agreement": "Agreement",
  "l7.d.tab.onboarding": "Onboarding",
  "l7.d.tab.activity": "Activity",
  "l7.d.timeline": "Activity",
  "l7.d.tl.enquiry": "Enquiry from {domain}",
  "l7.d.tl.details": "Details added by Emma",
  "l7.d.tl.estimate": "Estimate sent to Emma",
  "l7.d.tl.summary": "Summary drafted",
  "l7.d.tl.reviewed": "Reviewed by Sarah",
  "l7.d.tl.offer_sent": "Offer v1 sent",
  "l7.d.tl.opened": "Opened by Emma",
  "l7.d.tl.viewing": "Reading services and price",
  "l7.d.tl.added": "Added photography",
  "l7.d.tl.accepted": "Offer accepted",
  "l7.d.tl.signed": "Agreement v2 signed",
  "l7.d.tl.wifi": "Wi-Fi read from router photo",
  "l7.d.tl.onboarded": "Onboarding complete",
  "l7.d.tl.created": "Created in Guesty",
  "l7.d.tl.live": "Live on Airbnb, Booking.com",
  "l7.d.facts": "Property",
  "l7.d.facts.type": "Type",
  "l7.d.facts.type_v": "Apartment",
  "l7.d.facts.beds": "Bedrooms",
  "l7.d.facts.beds_v": "3",
  "l7.d.facts.baths": "Bathrooms",
  "l7.d.facts.baths_v": "2",
  "l7.d.facts.from": "Available",
  "l7.d.facts.from_v": "From June",
  "l7.d.facts.estimate": "Estimate",
  "l7.d.facts.estimate_v": "€42–48k / yr",
  "l7.d.facts.source": "Source",
  "l7.d.facts.source_v": "{domain}",
  "l7.d.note": "Owner's note",
  "l7.d.summary": "Summary",
  "l7.d.summary_tag": "Drafted for your review",
  "l7.d.summary_text": "3-bed, 2-bath apartment in Baixa, Lisbon. Emma rents it out herself today and wants full service from June. Strong fit for the Full Service template.",
  "l7.d.fit": "Fit 9/10",
  "l7.d.template": "Template",
  "l7.d.template_v": "Full Service",
  "l7.d.action.offer": "Create offer",
  "l7.d.offer.title": "Offer v1",
  "l7.d.offer.services": "Services",
  "l7.d.offer.preview": "Owner page",
  "l7.d.offer.preview_v": "{ownerDomain}/emma",
  "l7.d.offer.valid": "Valid until 30 June",
  "l7.d.offer.send": "Send to Emma",
  "l7.d.offer.sent": "Sent 09:14",
  "l7.d.offer.delivered": "Delivered · emma.carter@mail.com",
  "l7.d.offer.live": "Emma is on the page",
  "l7.d.offer.preview_short": "{ownerDomain}",
  "l7.d.offer.device": "Device",
  "l7.d.offer.device_v": "iPhone · Lisbon",
  "l7.d.offer.time": "Time on page",
  "l7.d.offer.time_v": "4 min",
  "l7.d.offer.choices": "Emma's choices",
  "l7.d.offer.net": "Estimated net to owner (year 1)",
  "l7.d.offer.accepted": "Accepted · 09:21",
  "l7.d.sign.title": "Agreement v2",
  "l7.d.sign.terms": "Terms",
  "l7.d.sign.signature": "Signature",
  "l7.d.sign.awaiting": "Awaiting Emma's signature",
  "l7.d.sign.signed": "Signed by Emma Carter",
  "l7.d.onb.title": "Launch readiness",
  "l7.d.onb.checklist": "Checklist",
  "l7.d.live.handoff": "Handoff",
  "l7.d.live.record": "Property record",
  "l7.d.live.created": "Created in Guesty",
  "l7.d.live.channels": "Distributed to",
  "l7.d.live.kpi1": "Lead to live",
  "l7.d.live.kpi1_v": "2 days",
  "l7.d.live.kpi2": "First booking",
  "l7.d.live.kpi2_v": "Day 4",
  "l12.story.sub_brand": "Every owner screen below is rendered in {name}’s brand. Pick a moment: the owner’s phone on one side, your workspace on the other — one property record from the first tap to a live listing in your PMS.",
  "l7.site.sub": "Guests, cleaning and pricing handled. You receive the payouts.",
  "l7.site.entry_eyebrow": "Free estimate",
  "l7.site.entry_title": "What could your home earn?",
  "l7.site.entry_time": "30 sec",
  "l7.site.all": "View all",
  "l6.jr.rec.title": "Property record",
  "l6.jr.rec.fields": "{n} of {total} fields",
  "l6.jr.rec.address": "Address",
  "l6.jr.rec.owner": "Owner",
  "l6.jr.rec.estimate": "Estimate",
  "l6.jr.rec.type": "Type",
  "l6.jr.rec.beds": "Bedrooms",
  "l6.jr.rec.from": "Available from",
  "l6.jr.rec.offer": "Offer",
  "l6.jr.rec.accepted": "Accepted",
  "l6.jr.rec.signature": "Signature",
  "l6.jr.rec.access": "Access",
  "l6.jr.rec.wifi": "Wi-Fi",
  "l6.jr.rec.rules": "House rules",
  "l6.jr.rec.photos": "Photos",
  "l6.jr.rec.pms": "PMS ID",
  "l6.jr.rec.channels": "Channels",
  "l6.jr.rec.on_record": "On the record",
  /* One record — the finished property record as a product shot */
  "l6.jr.pt.1.t": "Two days, not two weeks",
  "l6.jr.pt.1.p": "From the first tap on your website to a live listing in your PMS — with the owner completing onboarding on their own phone.",
  "l6.jr.pt.2.t": "Every step writes to the same record",
  "l6.jr.pt.2.p": "Estimate, offer, signature, onboarding and handoff are not attachments in an inbox. They are fields on one property record.",
  "l6.jr.pt.3.t": "Both sides see the same truth",
  "l6.jr.pt.3.p": "The owner sees it in your brand, on their phone. You see it in your Listed workspace. Nothing is typed twice.",
  "l6.jr.cta": "See what’s included",
  "l6.jr.crumb": "Properties",
  "l6.jr.synced": "In sync with your PMS",
  "l6.jr.tab.overview": "Overview",
  "l6.jr.tab.offer": "Offer",
  "l6.jr.tab.agreement": "Agreement",
  "l6.jr.tab.onboarding": "Onboarding",
  "l6.jr.tab.activity": "Activity",
  "l6.jr.activity": "Activity",
  "l6.jr.act.enquiry": "Enquiry from your website — verified address, 3 bedrooms, owner’s note",
  "l6.jr.act.estimate": "Instant estimate shown to the owner: €42–48k / yr",
  "l6.jr.act.offer_sent": "Offer sent as a branded web page",
  "l6.jr.act.accepted": "Offer accepted — photography added",
  "l6.jr.act.signed": "Agreement e-signed by Emma Carter",
  "l6.jr.act.onboarded": "Onboarding complete — 100% launch-ready",
  "l6.jr.act.live": "Created in Guesty · live on Airbnb and Booking.com",
  "l6.jr.on_record": "On the record",
  "l6.jr.readiness": "100% ready",
  "l6.jr.fact.estimate.l": "Estimate",
  "l6.jr.fact.estimate.v": "€42–48k / yr",
  "l6.jr.fact.offer.l": "Offer",
  "l6.jr.fact.offer.v": "Full Service 15% · photography",
  "l6.jr.fact.agreement.l": "Agreement",
  "l6.jr.fact.agreement.v": "Signed · v2 · 14:32",
  "l6.jr.fact.access.l": "Access & Wi-Fi",
  "l6.jr.fact.access.v": "Key box · Prata_Guest",
  "l6.jr.fact.photos.l": "Photos",
  "l6.jr.fact.photos.v": "12 professional",
  "l6.jr.fact.calendar.l": "Available from",
  "l6.jr.fact.calendar.v": "20 May",
  "l6.jr.pms.title": "Handed to your PMS",
  "l6.jr.pms.sub": "24 fields mapped · distributed to",
  /* How it works — pinned story */
  "l14.st.day": "Day {n}",
  "l14.st.replay": "Watch again",
  "l14.st.scroll": "Scroll to continue",
  /* How it works — in-flow player (phones and tablets) */
  "l14.st.player": "The owner journey, step by step",
  "l14.st.chapter": "Chapter {n} of {total}",
  "l14.st.paused": "Paused",
  "l14.st.swipe": "Swipe or tap a chapter",
  /* Marketing header — mobile menu */
  "lp.nav.on_page": "On this page",
  "lp.nav.problem": "Why Listed",
  "lp.nav.capabilities": "What's included",
  "lp.nav.faq": "Questions",
  /* Settings › Branding › E-mail sender */
  "email.sender.title": "E-mail sender",
  "email.sender.sub": "Offers, agreements and onboarding links are sent by Listed in your name. Replies go straight to your own mailbox — we never touch your inbox.",
  "email.sender.from": "From",
  "email.sender.reply_to": "Reply-to",
  "email.sender.reply_to_none": "Your admin login e-mail",
  "email.sender.reply_to_help": "Where owners' replies land. Defaults to your admin e-mail.",
  "email.sender.name": "Sender name",
  "email.sender.name_help": "Shown as the sender. Defaults to your organization name.",
  "email.sender.footer": "E-mail footer",
  "email.level.custom": "Your own domain",
  "email.level.platform": "Listed domain, your name",
  "email.level.sandbox": "Test mode",
  "email.level.log": "Not sending yet",
  "email.delivery.log": "E-mail delivery is not switched on for this platform yet — every message is stored in the Outbox so nothing is lost.",
  "email.delivery.sandbox": "No verified platform domain yet: messages can only reach the platform account's own address until one is added.",
  "email.test.cta": "Send me a test e-mail",
  "email.test.sent": "Test e-mail sent to {to}",
  "email.test.logged": "Stored in the Outbox (delivery is not switched on yet)",
  "email.domain.title": "Send from your own domain",
  "email.domain.sub": "Optional. Add your domain, publish the DNS records once, and every owner e-mail leaves from post@yourdomain — no trace of Listed in the sender.",
  "email.domain.add": "Add domain",
  "email.domain.added": "Domain added — publish the DNS records below",
  "email.domain.removed": "Domain removed — back to the Listed sending domain",
  "email.domain.check": "Check DNS",
  "email.domain.verified_toast": "Domain verified — you now send from your own domain",
  "email.domain.pending_toast": "Checking DNS… records can take a few minutes to propagate",
  "email.domain.instructions": "Add these records at your DNS provider (Domeneshop, One.com, Cloudflare…). Then press Check DNS. Propagation usually takes minutes, occasionally up to 24 hours.",
  "email.domain.live": "Owner e-mails now leave from {from}.",
  "email.domain.status.verified": "Verified",
  "email.domain.status.pending": "Checking",
  "email.domain.status.not_started": "Waiting for DNS",
  "email.domain.status.failed": "Failed",
  "email.domain.status.temporary_failure": "Retrying",
  "email.dns.type": "Type",
  "email.dns.name": "Name / host",
  "email.dns.value": "Value",
  "email.dns.status": "Status",
  "nav.collapse": "Collapse",
  "nav.expand": "Expand",

  // Settings → Integrations (one PMS per organisation)
  "integ.sub2": "Your PMS and the services Listed runs for you.",
  "pms.one.title": "Your PMS",
  "pms.one.sub": "Signed properties are handed over to one property management system. Switch any time — disconnect first, then connect the next.",
  "pms.one.choose": "Choose the system your properties go live in",
  "pms.one.connected_hint": "Disconnect {provider} to switch",
  "pms.one.other": "Other systems",
  "pms.one.switch_blocked": "{provider} is connected. Disconnect it first to switch.",
  "pms.one.live_count": "{n} live",
  "pms.one.live_none": "No live properties yet",
  "pms.one.since": "Connected {date}",
  "pms.one.credentials": "Credentials",
  "pms.one.readonly_hint": "Read-only API — Listed prepares the handover, you create the property in {provider} and link it.",
  "pms.one.creates_hint": "Creates the listing with photos, prices and house rules.",
  "pms.one.select": "Select",
  "svc.title": "Included with Listed",
  "svc.sub": "Run by Listed for every organisation. Nothing to configure.",
  "svc.address": "Address lookup",
  "svc.address_note": "Verified addresses on the owner start page and in every offer.",
  "svc.ai": "AI assistant",
  "svc.ai_note": "Drafts, summaries and onboarding help. Every output is an editable suggestion.",
  "svc.ai_off": "Not enabled",
  "svc.signing": "E-signature",
  "svc.signing_note": "Owners sign the management agreement online with an audit trail.",
  "svc.email": "Email delivery",
  "svc.email_note": "Sent in your name via Listed. Sender identity and your own domain live under Branding.",
  "svc.email_action": "Sender settings",
  "svc.active": "Active",
  "svc.native": "Native",
  "settings.mobile_hint": "Pick a section",

  // Contract template editor
  "contract.sub2": "Signed by the owner right after accepting an offer. Edit on the left — the preview is exactly what the owner sees.",
  "contract.name": "Template name",
  "contract.name_help": "Internal — shown in your pipeline, not to the owner.",
  "contract.doc_title": "Document title",
  "contract.doc_title_help": "Printed at the top of the agreement.",
  "contract.intro": "Preamble",
  "contract.intro_ph": "This agreement is made between {{org_name}} (\"the Manager\") and {{owner_name}} (\"the Owner\") …",
  "contract.intro_help": "Who the parties are and which property the agreement covers.",
  "contract.clauses": "Clauses",
  "contract.clauses_help": "Numbered automatically. Hover a clause to reorder, duplicate or remove it.",
  "contract.clause_heading_ph": "Clause heading",
  "contract.clause_body_ph": "Write the clause. Use Insert variable for names, addresses and the chosen services.",
  "contract.add_clause": "Add clause",
  "contract.blank_clause": "Blank clause",
  "contract.library_title": "Standard clauses",
  "contract.library_sub": "Professional starting points for short-term rental management in Norway. Add, then adapt the wording to your business.",
  "contract.library_add": "Add",
  "contract.library_added": "In use",
  "contract.library_added_toast": "Added “{heading}”",
  "contract.closing": "Closing line",
  "contract.closing_ph": "Signed electronically by the Owner on {{signed_at}}.",
  "contract.closing_help": "Shown above the signature block. {{signed_at}} is stamped the moment the owner signs.",
  "contract.insert_var": "Insert variable",
  "contract.variables": "Variables",
  "contract.move_up": "Move up",
  "contract.move_down": "Move down",
  "contract.duplicate": "Duplicate",
  "contract.remove": "Remove",
  "contract.preview": "Preview",
  "contract.preview_sub": "Exactly as the owner sees it — with sample data.",
  "contract.preview_open": "Expand",
  "contract.preview_full_title": "Agreement preview",
  "contract.reset": "Reset to standard",
  "contract.reset_title": "Reset to the standard agreement?",
  "contract.reset_sub": "Your title, preamble, clauses and closing line are replaced with Listed's standard agreement. Nothing is saved until you press Save.",
  "contract.reset_done": "Standard agreement loaded — review and save.",
  "contract.saved": "Agreement template saved",
  "contract.need_clause": "Add at least one clause.",
  "contract.last_saved": "Saved {date} by {by}",
  "contract.never_saved": "Using Listed's standard agreement — not saved yet",
  "contract.disclaimer": "Standard text is a starting point, not legal advice. Have your counsel review it.",

  // Agreement document (owner sign page + preview)
  "doc.date": "Date",
  "doc.property": "Property",
  "doc.offer_ref": "Offer v{version} · {date}",
  "doc.manager": "The Manager",
  "doc.owner": "The Owner",
  "doc.for_manager": "For the Manager",
  "doc.for_owner": "For the Owner",
  "doc.manager_accepted": "Bound by the accepted offer (v{version})",
  "doc.signed_on": "Signed electronically {date}",
  "doc.awaiting_signature": "Awaiting signature",
  "doc.service": "Service",
  "doc.fee": "Fee",
  "doc.added": "Added",
  "doc.no_services": "No services selected.",

  /* ---- humanised values (never show raw keys) ---- */
  "source.widget": "Website widget",
  "source.start_page": "Start page",
  "source.manual": "Added by your team",
  "source.api": "API",
  "source.import": "Imported",
  "source.test": "Test lead",
  "source.automation": "Automation",
  "source.hq": "Listed HQ",
  "lead.via": "via {source}",
  "sig.method.typed": "Typed signature",
  "sig.method.drawn": "Drawn signature",
  "sig.verified": "Digitally signed · tamper-evident",
  "sig.fingerprint": "Document fingerprint",
  "lead.contract.signed_on": "Signed {date}",
  "lead.contract.awaiting": "Sent to the owner — awaiting signature",
  "lead.contract.none": "The agreement is created automatically when the owner accepts an offer.",
  "lead.contract.preview": "Preview agreement",
  "lead.contract.view_signed": "View signed agreement",
  "lead.contract.download_pdf": "PDF",
  "lead.offer.preview": "Preview offer",
  "lead.offer.sent_on": "Sent {date}",
  "lead.offer.opened_on": "Opened {date}",
  "lead.offer.accepted_on": "Accepted {date}",
  "lead.offer.declined_on": "Declined {date}",
  "lead.offer.not_sent": "Not sent yet",
  "lead.summary": "Summary",
  "lead.summary_generated": "Generated from the enquiry",
  "lead.fit": "Fit {score}/10",
  "lead.suggested_plan": "Suggested: {name}",
  "lead.estimate_sub_pm": "The range the owner sees in the offer. Enter it manually or adjust the suggestion.",
  "lead.property_facts": "Property",
  "lead.created_ago": "Enquired {ago}",
  "viewer.open_as_owner": "Open as owner",
  "viewer.copy_link": "Copy link",
  "viewer.print": "Print / PDF",
  "viewer.offer_title": "Offer preview",
  "viewer.agreement_title": "Agreement",
  "viewer.sample_note": "Preview with sample data — the real agreement is filled in when an owner accepts an offer.",
  "viewer.live_note": "Exactly what the owner sees.",
  "contract.vars_hint": "Type naturally. Insert a variable where the owner's details should appear — it fills in automatically.",
  "contract.intro_label": "Opening paragraph",
  "contract.closing_label": "Closing paragraph",
  "contract.editor_title": "Agreement",
  "contract.clause_n": "Clause {n}",
  "contract.template_meta": "Template",
  "builder.preview_open": "Open full preview",
  "builder.preview_sub": "What the owner sees when they open the link.",
  "builder.locked_title": "Accepted and locked",
  "builder.edited_title": "Changes not sent yet",
  "builder.pct_suffix": "% of revenue",
  "builder.reorder": "Reorder",
  "branding.plan_standard_short": "Standard",
  "branding.plan_pro_short": "Pro",
  "branding.plan_hint_standard": "Owner pages show “Powered by DigiHome”.",
  "branding.plan_hint_pro": "Full white-label — no Listed or DigiHome mention.",
  "branding.logo": "Logo",
  "branding.logo_help": "Shown on offers, agreements and onboarding. SVG or PNG on a transparent background works best.",
  "branding.favicon": "Browser icon",
  "branding.favicon_help": "Shown in the browser tab on your owner pages.",
  "branding.paste_url": "Paste image link",
  "branding.remove": "Remove",
  "branding.domain_locked": "Available on Pro",
  "branding.identity": "Identity",
  "branding.locale": "Market",
  "branding.colour_help": "Buttons and highlights on every owner page.",
  "install.utm_source": "Source",
  "install.utm_medium": "Medium",
  "install.utm_campaign": "Campaign",
  "install.utm_help": "Added to the link so each lead tells you where it came from.",
  "automations.days_after": "days after",
  "automations.then": "then",
  "team.role": "Role",
  "common.pct_of_revenue": "% of revenue",
  "common.per_year_short": "/ year",

  /* ---- portal workspace (Phase 14) ---- */
  "common.platform": "Platform",
  "common.size": "Size",
  "common.beds": "Beds",
  "common.method": "Method",
  "platform.airbnb": "Airbnb",
  "platform.booking": "Booking.com",
  "platform.vrbo": "Vrbo",
  "platform.unknown": "Other platform",
  "pipeline.waiting_short_owner": "Owner",
  "pipeline.waiting_short_you": "You",
  "pipeline.hide_closed": "Hide lost & archived",
  "pipeline.cards": "{n} properties",
  "builder.reorder_up": "Move up",
  "builder.reorder_down": "Move down",
  "builder.paper_note": "Live preview · updates as you type",
  "dash.kpi_hint": "Tap a number to open that view",
  "outbox.audience": "Audience",
  "login.eyebrow": "Property-manager portal",

  // Customer type — private individual vs business
  "customer.type": "Customer type",
  "customer.private": "Private individual",
  "customer.business": "Business",
  "customer.private_hint": "I own the property personally",
  "customer.business_hint": "A company owns the property",
  "customer.private_sub": "Private individual",
  "customer.business_sub": "Business customer",
  "customer.company_name": "Company name",
  "customer.org_number": "Organisation number",
  "customer.vat_number": "VAT number",
  "customer.vat_number_opt": "VAT no. (optional)",
  "customer.vat_number_help": "Needed for reverse charge across borders.",
  "customer.contact_person": "Contact person",
  "customer.contact_role": "Contact's role",
  "customer.contact_role_ph": "e.g. Managing director",
  "customer.attn": "attn. {name}",
  "intake.error.company": "Please enter the company name.",
  "common.country": "Country",

  // Settings → Tax
  "settings.tax": "Tax & VAT",
  "settings.billing": "Billing",
  "tax.sub": "How tax is shown to owners and written into agreements. Prices you enter are always net of tax.",
  "tax.saved": "Tax settings saved.",
  "tax.registered": "Registered for tax (VAT / MVA / GST)",
  "tax.registered_help": "Off → no tax line anywhere. On → tax is added or included according to the rules below.",
  "tax.label": "Tax name",
  "tax.label_help": "As owners know it: MVA, VAT, GST…",
  "tax.rate": "Standard rate",
  "tax.rate_help": "Applied to your fees.",
  "tax.reg_number": "Registration number",
  "tax.reg_number_help": "Shown on agreements. Format: {hint}",
  "tax.display_title": "How owners see your prices",
  "tax.display_sub": "Private owners usually expect prices including tax; businesses expect them excluding tax.",
  "tax.b2c_help": "Consumers — prices in offers and agreements",
  "tax.b2b_help": "Companies — tax is added on invoices",
  "tax.incl": "Including tax",
  "tax.excl": "Excluding tax",
  "tax.incl_short": "incl. {label}",
  "tax.excl_short": "excl. {label}",
  "tax.no_tax_short": "no tax",
  "tax.reverse_charge": "Reverse charge for foreign business owners",
  "tax.reverse_charge_help": "A business owner in another country with a valid VAT number is invoiced without tax and accounts for it at home.",
  "tax.revenue_basis": "What percentage fees are calculated on",
  "tax.revenue_basis_help": "Written into every agreement so there is no discussion later about what “booking revenue” means.",
  "tax.use_defaults": "Use {country} defaults",
  "tax.defaults_loaded": "Loaded the standard values for {country}. Save to apply.",
  "tax.disclaimer": "Starting values only — confirm rates and registration with your accountant. Listed presents tax the way you configure it; it does not give tax advice.",
  "tax.example_title": "Live example",
  "tax.example_sub": "A 15 % fee, cleaning and photography as each owner type sees them",
  "tax.example_fee": "Management fee",
  "tax.example_cleaning": "Cleaning",
  "tax.example_photo": "Photography",
  "tax.example_incl_note": "{net}% net + {rate}% {label} = {gross}% shown to the owner.",
  "tax.example_reverse": "Foreign business owners with a valid VAT number: 0 % {label}, reverse charge noted in the agreement.",
  "tax.note_incl": "All fees include {rate}% {label}.",
  "tax.note_excl": "All fees exclude {label}. {rate}% {label} is added on invoices.",
  "tax.note_reverse": "No {label} charged — reverse charge; the owner accounts for tax in its own country.",
  "tax.note_none": "No tax is added to these fees.",
  "builder.tax_line": "Prices shown for a {who}.",
  "services.net_note": "Amounts are entered net of tax. How owners see them — including or excluding — is decided per customer type in Tax & VAT.",

  // Template previews (own tab)
  "templates.preview": "Preview",
  "templates.save_and_preview": "Save & preview",
  "templates.preview_new_tab": "Open preview in new tab",
  "templates.preview_hint": "See the offer exactly as an owner would",
  "templates.save_to_preview": "Save the template to preview it",
  "preview.sample_note": "Sample data — nothing is saved",
  "preview.sample_footer": "This is a preview with fictional sample data. Real agreements are filled from the owner’s accepted offer.",
  "preview.back_to_editor": "Back to editor",
  "preview.back_to_templates": "Back to templates",
  "preview.offer_title": "Offer preview · {name}",
  "preview.inert": "This is a preview — nothing is sent or saved.",
  "preview.sample_owner": "Sample owner",
  "contract.preview_new_tab": "Open in new tab",
  "contract.preview_owner_type": "Preview as",

  // Agreement document
  "doc.on_behalf_of": "On behalf of {company}",
  "doc.org_no": "Org. no. {n}",
  "doc.vat_no": "VAT no. {n}",
  "doc.reg_no": "Reg. no. {n}",
  "doc.represented_by": "Represented by {name}",

  // "Kom i gang" — first-run setup wizard (/app/setup), dashboard card and sidebar entry
  "setup.nav": "Get started",
  "setup.title": "Set up {org}",
  "setup.back": "Dashboard",
  "setup.of": "{a} of {b} done",
  "setup.steps": "Setup steps",
  "setup.step_n": "Step {n} of {total}",
  "setup.skip": "Skip for now",
  "setup.continue": "Save and continue",
  "setup.continue_short": "Continue",
  "setup.status.done": "Done",
  "setup.status.skipped": "Skipped",
  "setup.status.next": "Up next",
  "setup.status.todo": "Not started",

  "setup.step.brand.short": "Brand",
  "setup.step.brand.title": "Make it look like you",
  "setup.step.brand.sub": "Paste your website and we read the name, logo and colour your owners already know. Adjust anything, then save — every owner page and e-mail follows.",
  "setup.step.company.short": "Company & VAT",
  "setup.step.company.title": "Who signs the agreement",
  "setup.step.company.sub": "The legal entity that appears on offers and agreements, and how VAT is shown to private owners and businesses.",
  "setup.step.pms.short": "Connect PMS",
  "setup.step.pms.title": "Connect your property system",
  "setup.step.pms.sub": "Signed properties are handed over to your PMS with photos, details and house rules — no retyping. You can connect later from Settings.",
  "setup.step.email.short": "Sender e-mail",
  "setup.step.email.title": "Who the e-mails come from",
  "setup.step.email.sub": "Offers and reminders are sent in your name today from Listed's verified sender. Add your own domain when you want replies and DNS under your control.",
  "setup.step.catalogue.short": "Services & prices",
  "setup.step.catalogue.title": "What you offer, and for what",
  "setup.step.catalogue.sub": "A starter catalogue is ready. Switch off what you don't sell and adjust prices — offers are built from this list.",
  "setup.step.install.short": "Install & share",
  "setup.step.install.title": "Put Listed where owners find you",
  "setup.step.install.sub": "Share your start page or drop one line on your website. The first enquiry lands in your pipeline.",

  "setup.brand.website_ph": "yourcompany.com",
  "setup.brand.read": "Read website",
  "setup.brand.reading": "Reading…",
  "setup.brand.read_hint": "We only read what a visitor sees: the title, the logo and the main colour. Nothing is saved until you confirm.",
  "setup.brand.found": "Read from {domain} — check and adjust below.",
  "setup.brand.partial": "Read part of {domain} — fill in what's missing below.",
  "setup.brand.missing": "Could not read: {items}.",
  "setup.brand.item.name": "name",
  "setup.brand.item.logo": "logo",
  "setup.brand.item.color": "colour",
  "setup.brand.name": "Company name shown to owners",
  "setup.brand.note": "You can refine this any time under Settings → Branding.",

  "setup.company.legal_title": "Legal entity",
  "setup.company.legal_name": "Legal company name",
  "setup.company.org_number": "Organisation number",
  "setup.company.org_number_help": "Format: {hint}",
  "setup.company.address": "Street address",
  "setup.company.postal_code": "Postal code",
  "setup.company.city": "City",
  "setup.company.phone": "Phone",
  "setup.company.vat_title": "VAT",
  "setup.company.vat_sub": "Defaults for {country} — change if your registration differs.",
  "setup.company.tax_more": "Display rules, reverse charge and the revenue basis clause live under",
  "setup.company.required_note": "Legal name and organisation number are required — they appear on every agreement.",

  "setup.pms.connected": "{provider} is connected",
  "setup.pms.last_ok": "Connection tested successfully",
  "setup.pms.manage": "Manage",
  "setup.pms.why": "Your PMS stays the system of record for calendar, prices and bookings. Listed only hands over what it owns: the property, its photos and the details the owner filled in.",
  "setup.pms.skip_note": "No PMS yet? Skip — everything still works, and you can connect later.",

  "setup.email.intro": "Right now owners receive e-mail from Listed's verified sender, signed {org}. That works from day one.",
  "setup.email.use_current": "Use this sender",
  "setup.email.note": "You can add your own domain later without losing anything.",

  "setup.catalogue.active_n": "{n} of {total} services active",
  "setup.catalogue.edit": "Edit prices",
  "setup.catalogue.templates": "{n} offer templates ready — default: {name}.",
  "setup.catalogue.templates_link": "View templates",
  "setup.catalogue.confirm": "Looks right",
  "setup.catalogue.note": "Keep at least one service active — offers are built from this list.",

  "setup.install.link": "Your start page",
  "setup.install.link_sub": "Share it in e-mail, on social or as a link on your website.",
  "setup.install.open": "Open",
  "setup.install.snippet": "Widget for your website",
  "setup.install.snippet_sub": "One line, anywhere in the page. Your web developer needs nothing else.",
  "setup.install.more": "Colours, position and embed options live under",
  "setup.install.done": "Done — it's live",
  "setup.install.has_leads": "{n} enquiries have already arrived through it.",
  "setup.install.detected": "Detected on {host} · seen {ago}.",

  "setup.finished.title": "You're set up",
  "setup.finished.sub": "Owners can enquire, you can send offers and agreements, and signed properties flow into onboarding. Everything here can be changed later in Settings.",
  "setup.finished.cta": "Go to dashboard",
  "setup.finished.start": "Open your start page",
  "setup.finished.skipped": "Skipped for now: {items}.",
  "setup.finished.review": "Review",

  "setup.card.title": "Get started",
  "setup.card.progress": "{a} of {b} steps done",
  "setup.card.next": "Next: {step}",
  "setup.card.start": "Start setup",
  "setup.card.continue": "Continue setup",
  "setup.card.dismiss": "Hide this card",
  "setup.card.dismissed": "Hidden — you'll find setup in the sidebar until it's complete.",
  "setup.finish_later": "Finish later",
  "setup.progress_done": "{a} of {b}",
  "setup.step_short_n": "Step {n}",
  "setup.brand.website_label": "Your website",
  "setup.brand.website_sub": "We read the name, logo and main colour — nothing is saved until you continue.",
  "setup.brand.details_label": "Shown to owners",
  "setup.brand.details_sub": "This is what every owner page and e-mail carries.",
  "setup.brand.preview_url": "{domain}/start/{slug}",
  "setup.brand.logo_invalid": "Logo could not be loaded",
  "setup.brand.detected": "Detected",
  "setup.company.owner_view": "Private owners see prices {b2c} · businesses {b2b}",
  "setup.company.not_registered": "No tax line on offers or agreements.",
  "setup.pms.choose": "Choose the system your signed properties go live in.",
  "setup.pms.later": "Connect later",
  "setup.catalogue.title": "Starter catalogue",
  "setup.install.preview": "Preview",
  "setup.finished.summary": "What's set up",
  "setup.finished.next_title": "Good next steps",
  "setup.finished.next_lead": "Add your first lead by hand — or wait for the first enquiry.",
  "setup.finished.next_team": "Invite a colleague under Settings → Team.",
  "setup.finished.next_offer": "Open Settings → Proposal templates to shape the document owners receive.",
  "setup.finished.review_step": "Review",

  "hiw.eyebrow": "How it works",
  "hiw.title": "Six steps. One property record.",
  "hiw.sub": "Listed sits on your website and takes every owner enquiry through estimate, offer, e-signature and onboarding — in your brand, on the owner’s phone. Every answer lands on one property record: the one your PMS receives.",
  "hiw.link": "Follow one home through every step",
  "hiw.who.owner": "Owner",
  "hiw.who.you": "You",
  "hiw.who.auto": "Listed",
  "hiw.lane.owner": "Owner · on their phone",
  "hiw.lane.you": "You · in your Listed workspace · automatic steps are marked “Listed”",
  "hiw.legend.owner": "Owner · phone",
  "hiw.legend.you": "You · workspace",
  "hiw.legend.auto": "Listed · automatic",
  "hiw.address.t": "Owner enters an address",
  "hiw.address.p": "On your website, in your brand. No login, no PDF, no call-back.",
  "hiw.address.time": "Day 1 · 09:00",
  "hiw.estimate.t": "Instant revenue estimate",
  "hiw.estimate.p": "Clear numbers, clear assumptions. The owner decides fast; you get a structured lead.",
  "hiw.estimate.time": "Day 1 · 09:02",
  "hiw.offer.t": "An offer in your brand",
  "hiw.offer.p": "Your logo, your tone, your terms — a web page, not a PDF.",
  "hiw.offer.time": "Day 1 · 09:12",
  "hiw.sign.t": "E-sign on the phone",
  "hiw.sign.p": "One tap to accept and sign. No attachments, no printing.",
  "hiw.sign.time": "Day 1 · 14:31",
  "hiw.onboarding.t": "Guided onboarding",
  "hiw.onboarding.p": "Photos, keys, house rules and documents — collected once, in order.",
  "hiw.onboarding.time": "Day 2 · 17:02",
  "hiw.live.t": "Created in your PMS",
  "hiw.live.p": "A controlled draft in Guesty or Hostaway. Live is confirmed by your PMS — never assumed.",
  "hiw.live.time": "Day 2 · 18:40",
  "hiw.rec.eyebrow": "Property record",
  "hiw.rec.badge": "Live",
  "hiw.rec.title": "Rua da Prata 42",
  "hiw.rec.meta": "Lisbon · Emma Carter",
  "hiw.rec.address": "Verified address",
  "hiw.rec.address_v": "Rua da Prata 42, 1100-052 Lisboa",
  "hiw.rec.estimate": "Estimate",
  "hiw.rec.estimate_v": "€42–48k / yr · assumptions shown",
  "hiw.rec.offer": "Offer",
  "hiw.rec.offer_v": "Accepted · Full Service 15%",
  "hiw.rec.sign": "Agreement",
  "hiw.rec.sign_v": "Signed on the phone · 14:32",
  "hiw.rec.onboarding": "Onboarding",
  "hiw.rec.onboarding_v": "5 of 5 · ready to launch",
  "hiw.rec.live": "PMS",
  "hiw.rec.live_v": "Guesty #48213 · confirmed live",
  "hiw.rec.foot": "Two days · one record · nothing typed twice.",
  "l15.mo.play": "Watch the full flow",
  "l15.mo.play_len": "1 min",
  "l15.mo.pick": "Pick a moment",
  "l15.mo.side": "Whose screen",
  "l15.mo.swipe": "Swipe the screen or tap a moment.",
  "l15.mo.surface.phone": "Owner’s phone",
  "l15.mo.surface.desktop": "Your workspace",
  "l15.mo.surface.phone_s": "Phone",
  "l15.mo.surface.desktop_s": "Workspace",
  "l15.mo.rec": "Writes to the record",
  "l15.mo.film_title": "The full flow — Rua da Prata 42, first tap to live listing",
  "l15.mo.address.s": "Address",
  "l15.mo.address.p": "Emma types Rua da Prata 42 on your website. Verified against the map before she finishes the line — no form, no login, no call-back.",
  "l15.mo.estimate.s": "Estimate",
  "l15.mo.estimate.p": "€42–48k a year, assumptions in plain sight. The same second, in your workspace: a structured lead on the board — not an e-mail to retype.",
  "l15.mo.offer.s": "Offer",
  "l15.mo.offer.p": "You send the offer in minutes. Emma opens a page in your brand, compares Full Service and Standard side by side — and accepts.",
  "l15.mo.sign.s": "E-sign",
  "l15.mo.sign.p": "One tap to sign, still in your brand. The agreement files itself under the record; nobody chases a PDF.",
  "l15.mo.onboarding.s": "Onboarding",
  "l15.mo.onboarding.p": "Wi-Fi, keys, house rules, documents. Emma is guided room by room; every answer ticks a row on the record.",
  "l15.mo.live.s": "Live in PMS",
  "l15.mo.live.p": "Listed creates a controlled draft in Guesty. Live is confirmed by your PMS — and Emma’s phone lights up with the first booking.",
  "l5.int.existing_property": "Existing listing · linked to the signed owner",
  "l5.int.linked_in": "Linked in {pms}",
  "l5.int.status.link": "Links existing listings",
  "l5.int.status.beta": "Adapter in beta",
  "l5.int.status.link_beta": "Links existing · beta",
  /* ---------- /early-access landing page ---------- */
  "ea.nav.cta": "Apply for early access",
  "ea.hero.eyebrow": "For holiday-rental property managers",
  "ea.hero.title": "Win more owners, with an offer they sign on their phone.",
  "ea.hero.sub": "From an owner's address on your website to a signed management agreement — on their phone, in your brand. No spreadsheets, PDFs or e-mail ping-pong.",
  "ea.hero.cta": "Start with Listed",
  "ea.hero.how": "See how it works",
  "ea.hero.free": "Free until you sign an owner.",
  "ea.hero.trust1": "No setup fee",
  "ea.hero.trust2": "No credit card",
  "ea.hero.trust3": "Personal onboarding",
  "ea.hero.loop_cta": "Get Listed for your company",

  "fit.eyebrow": "Fits into your existing workflow",
  "fit.any_pms": "+ any PMS",

  "ea.cohort.eyebrow": "Founding customers",
  "ea.cohort.title": "We're looking for our first 20 property managers.",
  "ea.cohort.sub": "Join early and we'll personally design your owner offer experience in your brand — free. You get a product that already works, set up by the people who built it.",
  "ea.cohort.cta": "Apply for early access",
  "ea.cohort.note": "No setup fee · You only pay when an owner signs",

  "ea.problem.eyebrow": "The problem",
  "ea.problem.title": "Most owner enquiries die in a contact form.",
  "ea.problem.sub": "The estimate waits for a site visit, the offer goes out as a PDF and the agreement lives in an e-mail thread. Weeks pass, and the owner's interest cools.",
  "ea.solution.eyebrow": "With Listed",
  "ea.solution.title": "An owner enters their address. Listed builds the offer, collects the details and gets it signed — all in your brand.",
  "ea.solution.sub": "From owner lead to signed property, without the spreadsheets, PDFs and e-mail ping-pong. You see every enquiry, what it's worth and what's blocking it.",
  "ea.solution.p1.t": "Answer instantly",
  "ea.solution.p1.d": "A revenue estimate the moment the owner asks — while the interest is warm.",
  "ea.solution.p2.t": "Offer and sign in one flow",
  "ea.solution.p2.d": "Your terms, their phone, one tap. No attachments to chase.",
  "ea.solution.p3.t": "Ready for your PMS",
  "ea.solution.p3.d": "Photos, keys, rules and the agreement collected once, in one record.",

  "ea.how.eyebrow": "How it works",
  "ea.how.title": "From address to signed owner agreement, in one flow.",
  "ea.how.sub": "Listed sits on your website and takes every owner enquiry through estimate, offer, e-signature and onboarding — in your brand, on the owner's phone.",
  "ea.how.handoff": "Hand-off",
  "ea.how.s1.t": "Owner enters an address",
  "ea.how.s1.d": "On your website, in your brand. No login, no PDF, no waiting for a call back.",
  "ea.how.s2.t": "Branded revenue estimate",
  "ea.how.s2.d": "Clear numbers and clear assumptions, so the owner can decide fast.",
  "ea.how.s3.t": "An offer in your brand",
  "ea.how.s3.d": "Your logo, your tone, your terms. Options the owner can compare side by side.",
  "ea.how.s4.t": "Signed on the phone",
  "ea.how.s4.d": "One tap to accept and sign the agreement. No attachments, no printing.",
  "ea.how.s5.t": "Guided onboarding",
  "ea.how.s5.d": "Photos, keys, house rules and documents, collected once and in order.",
  "ea.how.s6.t": "Ready for your PMS",
  "ea.how.s6.d": "Everything a listing needs, in one record. Create a controlled draft in Guesty or Hostaway, link an existing Lodgify listing, or add it to any PMS by hand.",
  "ea.how.note": "Your PMS stays the system of record for operations. A property counts as live only when your PMS says so — Listed never assumes it.",

  "ea.price.eyebrow": "Pricing",
  "ea.price.title": "Free until you sign an owner.",
  "ea.price.sub": "No setup fee. No subscription. You only pay when an owner signs through Listed — so the tool earns its place before it costs you anything.",
  "ea.price.cta": "Start with Listed",
  "ea.price.details": "See pricing details",
  "ea.price.c1.t": "No setup fee",
  "ea.price.c1.d": "As a founding customer your branding, offer template and owner journey are set up by us, at no cost.",
  "ea.price.c2.t": "No subscription",
  "ea.price.c2.d": "No monthly fee, no seats, no minimums. Run every enquiry, estimate and offer through Listed for free.",
  "ea.price.c3.t": "Pay only when an owner signs",
  "ea.price.c3.d": "One flat fee per signed owner. If nobody signs, you owe nothing.",

  "ea.perk.eyebrow": "Founding-customer benefit",
  "ea.perk.title": "Your owner journey. Designed for your brand.",
  "ea.perk.sub": "As one of our first customers, we'll personally set up your Listed experience — your branding, offer template and owner journey — at no cost.",
  "ea.perk.p1.t": "Custom-branded owner experience",
  "ea.perk.p1.d": "Your logo, colours and domain on every screen the owner sees — the estimate, the offer, the signature and the onboarding.",
  "ea.perk.p2.t": "Personal setup",
  "ea.perk.p2.d": "We configure your offer template, terms and estimate assumptions with you, and put Listed on your website.",
  "ea.perk.p3.t": "Direct access to the team",
  "ea.perk.p3.d": "A direct line to the people building Listed — and a real say in what we build next.",
  "ea.perk.cta": "Apply for early access",
  "ea.mock.brand": "Your brand",
  "ea.mock.badge": "Example",
  "ea.mock.eyebrow": "Your offer",
  "ea.mock.title": "Full-service management for your holiday home",
  "ea.mock.addr": "Strandveien 12 · 2 bedrooms · sleeps 6",
  "ea.mock.r1": "Estimated nightly rate",
  "ea.mock.r1v": "€\u00a0165",
  "ea.mock.r2": "Expected occupancy",
  "ea.mock.r2v": "62\u00a0%",
  "ea.mock.r3": "Net to you per year",
  "ea.mock.r3v": "€\u00a031\u00a0400",
  "ea.mock.cta": "Accept offer",
  "ea.mock.sign": "Sign in one tap",
  "ea.mock.fine": "Illustration with example figures. Your setup uses your brand and a realistic estimate for your market.",

  "ea.owners.eyebrow": "Why owners say yes",
  "ea.owners.title": "Owners want clarity, not a sales call.",
  "ea.owners.sub": "The owner experience is where most acquisition flows lose. Listed makes the first step feel effortless and honest.",
  "ea.owners.b1.t": "A transparent estimate",
  "ea.owners.b1.d": "They see the numbers and the assumptions up front, and can decide without waiting for a callback.",
  "ea.owners.b2.t": "Sign from the sofa",
  "ea.owners.b2.d": "A mobile e-signature removes the 'send me the PDF' loop and the week it usually costs.",
  "ea.owners.b3.t": "A calm start",
  "ea.owners.b3.d": "Fewer e-mails and calls. A structured onboarding that respects their time and asks for everything once.",

  "ea.fit.eyebrow": "Integrations",
  "ea.fit.title": "Fits into your existing workflow.",
  "ea.fit.sub": "Listed handles acquisition, agreement and onboarding. Your PMS stays the system of record for operations.",
  "ea.fit.guesty": "Create controlled drafts",
  "ea.fit.hostaway": "Create controlled drafts",
  "ea.fit.lodgify": "Link existing listings",
  "ea.fit.smoobu": "Link existing listings",
  "ea.fit.any": "Add signed properties by hand",
  "ea.fit.note_lead": "Don't see your PMS? No problem.",
  "ea.fit.note": "You can use Listed independently and add signed properties to your PMS manually — everything you need is in one record.",

  "ea.faq.eyebrow": "Questions",
  "ea.faq.title": "Good to know.",
  "ea.faq.pricing": "See pricing",
  "ea.faq.q1": "Is this for homeowners?",
  "ea.faq.a1": "No. Listed is built for short-term and holiday-rental property-management companies. If you own a holiday home, your manager may use Listed with you.",
  "ea.faq.q2": "Do owners need an account?",
  "ea.faq.a2": "No. The flow works without logins: address, estimate, offer, e-signature and onboarding, straight from your website on the owner's phone.",
  "ea.faq.q3": "What does early access mean?",
  "ea.faq.a3": "Listed is live, and we're onboarding a limited first cohort personally. Early access means we set up your branding, offer template and owner journey with you — and you help shape what we build next.",
  "ea.faq.q4": "Which PMS do you support?",
  "ea.faq.a4": "Guesty and Hostaway for creating controlled property drafts; Lodgify for linking existing listings. Any other PMS works with a manual hand-off. Live status always comes from your PMS, never from Listed.",
  "ea.faq.q5": "What does it cost?",
  "ea.faq.a5": "Nothing until you sign an owner through Listed. Then one flat fee per signed owner. No setup fee, no subscription, no seats.",
  "ea.faq.q6": "What happens after I apply?",
  "ea.faq.a6": "You get a short confirmation e-mail. Within a few days we come back with a proposal for your owner journey in your brand, set it up with you, and you're live.",

  "ea.close.eyebrow": "Become a founding customer",
  "ea.close.title": "Start winning owners with an offer they sign on their phone.",
  "ea.close.sub": "We're onboarding our first 20 property managers personally. Apply, and we'll design your owner offer experience in your brand — free.",
  "ea.close.personal": "Every application is read and answered by the team.",

  "ea.form.title": "Apply for early access",
  "ea.form.sub": "We're onboarding our first 20 property managers personally. Tell us where to reach you and we come back within a few days.",
  "ea.form.email": "Work e-mail",
  "ea.form.email_ph": "name@yourcompany.com",
  "ea.form.company": "Company name",
  "ea.form.company_ph": "Your property-management company",
  "ea.form.more": "Add details (optional)",
  "ea.form.less": "Fewer details",
  "ea.form.optional": "Optional",
  "ea.form.name": "Your name",
  "ea.form.name_ph": "First and last name",
  "ea.form.website": "Website",
  "ea.form.website_ph": "yourcompany.com",
  "ea.form.units": "Units under management",
  "ea.form.units_ph": "e.g. 45",
  "ea.form.submit": "Apply for early access",
  "ea.form.sending": "Sending…",
  "ea.form.privacy": "We only use your details to get in touch about Listed. No newsletters, no sharing.",
  "ea.form.err.email": "Enter a valid work e-mail address.",
  "ea.form.err.company": "Enter your company name.",
  "ea.form.err.website": "Enter a website such as yourcompany.com.",
  "ea.form.err.units": "Enter a number between 1 and 5000.",
  "ea.form.err.generic": "Something went wrong. Please try again.",
  "ea.form.success.title": "Application received.",
  "ea.form.success.sub": "Check your inbox for a short confirmation. Here is what happens next:",
  "ea.form.success.step1": "We look at your website and how owners reach you today.",
  "ea.form.success.step2": "Within a few days we come back with a proposal for your owner journey in your brand — and set it up with you, at no cost.",
  "ea.form.success.step3": "Once it's live you only pay when a new owner signs. No setup fee, no subscription.",
  "ea.form.already.title": "We already have your application.",
  "ea.form.already.sub": "Good news: your details are with us and we'll be in touch soon. Here is what happens next:",

  /* ---------- /early-access · the journey loop on the owner's phone ---------- */
  "ea.loop.aria": "Product journey: from an owner's address to a property ready for your PMS",
  "ea.loop.owner_chip": "The owner's phone",
  "ea.loop.brand_chip": "In your brand",
  "ea.loop.group.owner": "The owner, on their phone",
  "ea.loop.group.you": "You, in Listed",
  "ea.loop.side.owner": "Owner",
  "ea.loop.side.you": "You",
  "ea.loop.step.address": "Enters their address on your website",
  "ea.loop.step.estimate": "Gets a revenue estimate, in your brand",
  "ea.loop.step.offer": "Sees your offer and picks a plan",
  "ea.loop.step.sign": "Signs the agreement on their phone",
  "ea.loop.step.signed": "You're notified the moment they sign",
  "ea.loop.step.onboard": "Completes onboarding on their phone",
  "ea.loop.step.ready": "The property is ready for your PMS",
  "ea.loop.desc.address": "No form to fill in first — the address is verified automatically.",
  "ea.loop.desc.estimate": "Nightly rate, occupancy and seasonality — instantly, and branded as you.",
  "ea.loop.desc.offer": "Your service levels and fees, exactly as you set them up.",
  "ea.loop.desc.sign": "Your management agreement, signed with a finger. No PDFs, no printing.",
  "ea.loop.desc.signed": "Listed tells you straight away, with the signed agreement attached.",
  "ea.loop.desc.onboard": "Photos, keys and house rules — a guided checklist, no e-mail back and forth.",
  "ea.loop.desc.ready": "Photos, keys and house rules collected — ready for Guesty, Hostaway, Hostfully, Beds24, Lodgify, Smoobu or any PMS.",
  "ea.loop.s1.eyebrow": "Free estimate",
  "ea.loop.s1.title": "What could your home earn?",
  "ea.loop.s1.sub": "Takes a minute. No obligation.",
  "ea.loop.s1.label": "Your address",
  "ea.loop.s1.verified": "Verified",
  "ea.loop.s1.verified_full": "Address found and verified",
  "ea.loop.s1.trust1": "Free, no obligation",
  "ea.loop.s1.trust2": "Takes about a minute",
  "ea.loop.s1.trust3": "Your details stay with {brand}",
  "ea.loop.s1.cta": "Get my estimate",
  "ea.loop.s2.eyebrow": "Your estimate",
  "ea.loop.s2.per_year": "per year, estimated net to you",
  "ea.loop.s2.nightly": "Nightly rate",
  "ea.loop.s2.occ": "Occupancy",
  "ea.loop.s2.vs": "vs. long-term rental",
  "ea.loop.s2.vs_v": "€ 18 000 per year",
  "ea.loop.s2.vs_delta": "+ 74 %",
  "ea.loop.s2.cta": "See your offer",
  "ea.loop.s3.eyebrow": "Your offer",
  "ea.loop.s3.title": "Management for your holiday home",
  "ea.loop.s3.opt1": "Full service",
  "ea.loop.s3.opt1_v": "20 % of revenue",
  "ea.loop.s3.opt2": "Essentials",
  "ea.loop.s3.opt2_v": "12 % of revenue",
  "ea.loop.s3.inc1": "Guest care & cleaning",
  "ea.loop.s3.inc2": "Dynamic pricing",
  "ea.loop.s3.inc3": "Monthly payouts",
  "ea.loop.s3.inc4": "Guest screening & insurance",
  "ea.loop.s3.net": "Your estimated net, after fees",
  "ea.loop.s3.net_v": "€ 25 100",
  "ea.loop.s3.cta": "Accept offer",
  "ea.loop.s4.eyebrow": "Agreement",
  "ea.loop.s4.title": "Sign to get started",
  "ea.loop.s4.r1": "Term",
  "ea.loop.s4.r1v": "12 months",
  "ea.loop.s4.r2": "Start",
  "ea.loop.s4.r2v": "1 June",
  "ea.loop.s4.r3": "Payout",
  "ea.loop.s4.r3v": "Monthly",
  "ea.loop.s4.r4": "Fee",
  "ea.loop.s4.r4v": "20 % of revenue",
  "ea.loop.s4.consent": "I've read the management agreement",
  "ea.loop.s4.sign_here": "Sign with your finger",
  "ea.loop.s4.signed_by": "Signed by {owner}",
  "ea.loop.s4.cta": "Sign agreement",
  "ea.loop.s5.title": "Signed",
  "ea.loop.s5.sub": "Your agreement with {brand} is signed. Next: a few details about your home.",
  "ea.loop.s5.doc": "Management agreement",
  "ea.loop.s5.doc_sub": "Signed copy sent to you",
  "ea.loop.s5.next_label": "Next steps",
  "ea.loop.s5.next1": "Photos of your home",
  "ea.loop.s5.next2": "Keys, access & house rules",
  "ea.loop.s5.next": "Continue to onboarding",
  "ea.loop.s6b.eyebrow": "Onboarding",
  "ea.loop.s6b.title": "A few details about your home",
  "ea.loop.s6b.photos": "Photos",
  "ea.loop.s6b.keys": "Keys & access",
  "ea.loop.s6b.keys1": "Key box",
  "ea.loop.s6b.keys2": "Smart lock",
  "ea.loop.s6b.rules": "House rules",
  "ea.loop.s6b.rule1": "No smoking",
  "ea.loop.s6b.rule2": "Pets on request",
  "ea.loop.s6b.cta": "Send to {brand}",
  "ea.loop.s6.eyebrow": "Onboarding",
  "ea.loop.s6.title": "Everything's in",
  "ea.loop.s6.i1": "Photos",
  "ea.loop.s6.i2": "Keys & access",
  "ea.loop.s6.i3": "House rules",
  "ea.loop.s6.summary": "Handed over to {brand}",
  "ea.loop.s6.summary_sub": "{n} of 3",
  "ea.loop.s6.done": "Complete — {brand} takes it from here",
  "ea.loop.s6.cta": "Done",
  "ea.loop.card.app": "Listed",
  "ea.loop.card.now": "now",
  "ea.loop.card.signed": "Owner signed",
  "ea.loop.card.signed_sub": "{address} · {owner}",
  "ea.loop.card.ready": "Ready for your PMS",
  "ea.loop.card.ready_sub": "Agreement, photos, keys and rules — in one record",
  "ea.loop.card.any_pms": "+ any PMS",

  /* ---------- HQ · Growth: early-access invites, preview, test send, Microsoft 365 ---------- */
  "hq.growth.run_waitlist": "Early-access invites",
  "hq.growth.run_waitlist_help": "Draft an early-access invite for up to 10 companies that have a contact and no invite yet. Research is optional — with research the opening line is personalised.",
  "hq.growth.detail.waitlist_invite": "Early-access invite",
  "hq.growth.detail.waitlist_invite_help": "Draft the early-access invite for this contact: fixed template, personalised opening line when research exists, link to /early-access with attribution.",
  "hq.growth.msg.kind.waitlist_invite": "Early-access invite",
  "hq.growth.msg.personalised": "personalised",
  "hq.growth.msg.generic_hook": "generic opening (no research)",
  "hq.growth.preview.title": "E-mail preview",
  "hq.growth.preview.open": "Preview",
  "hq.growth.preview.from": "From",
  "hq.growth.preview.subject": "Subject",
  "hq.growth.preview.html": "As the recipient sees it",
  "hq.growth.preview.text": "Plain text",
  "hq.growth.preview.no_mailbox": "No connected mailbox yet — real sends need Microsoft 365; tests go through the platform sender.",
  "hq.growth.test.send": "Send test",
  "hq.growth.test.send_me": "Send test to me",
  "hq.growth.test.help": "Sends this exact e-mail to you, prefixed [Test]. Uses the connected Microsoft 365 mailbox, otherwise the platform sender. The draft's status does not change.",
  "hq.growth.test.sent_m365": "Test sent to {to} from your Microsoft 365 mailbox.",
  "hq.growth.test.sent_platform": "Test sent to {to} via the platform sender (no Microsoft 365 mailbox connected yet).",
  "hq.growth.test.last": "Last test sent to {to} · {when}",
  "hq.growth.preview.sub": "Exactly what goes out — the same HTML and plain text the recipient receives.",
  "hq.growth.preview.rendered": "Rendered",
  "hq.growth.preview.desktop": "Desktop",
  "hq.growth.preview.mobile": "Mobile",
  "hq.growth.preview.inbox_row": "In the inbox list",
  "hq.growth.preview.now": "Now",
  "hq.growth.preview.your_mailbox": "Your mailbox",
  "hq.growth.preview.your_mailbox_short": "your mailbox — not connected yet",
  "hq.growth.preview.your_mailbox_help": "Connect Microsoft 365 in Settings and this becomes your name and address.",
  "hq.growth.preview.optout_chip": "Opt-out line appended",
  "hq.growth.preview.size": "{kb} KB e-mail",
  "hq.growth.preview.media_chip": "GIF · {label}",
  "hq.growth.preview.media_none": "No visual",
  "hq.growth.preview.load_error": "Couldn't load the preview",
  "hq.growth.preview.text_help": "What text-only clients and previews show. Media placeholders become a link.",
  "hq.growth.preview.mobile_help": "390 px wide — roughly an iPhone in portrait.",
  "hq.growth.preview.test_title": "Send yourself a test",
  "hq.growth.preview.to_direct": "Direct address",
  "hq.growth.preview.to_shared": "Shared inbox",
  "hq.growth.preview.mismatch_chip": "Greeting names {name}",

  "hq.growth.ms.title": "Microsoft 365",
  "hq.growth.ms.sub": "One app registration in Microsoft Entra lets every HQ mailbox connect with a normal Microsoft sign-in. Listed asks for permission to send (Mail.Send), to read the inbox so replies can stop follow-ups (Mail.Read), and to read the account name.",
  "hq.growth.ms.ready": "Ready",
  "hq.growth.ms.requires_setup": "Requires setup",
  "hq.growth.ms.banner": "Nothing is sent from Microsoft 365 until the app registration below is filled in and a mailbox is connected. Test e-mails still work through the platform sender.",
  "hq.growth.ms.redirect": "Redirect URI (add this in Entra → Authentication → Web)",
  "hq.growth.ms.redirect_help": "Must match exactly, including https and the path.",
  "hq.growth.ms.client_id": "Application (client) ID",
  "hq.growth.ms.client_secret": "Client secret",
  "hq.growth.ms.secret_ph": "Paste the secret value (not the secret ID)",
  "hq.growth.ms.secret_keep": "Leave empty to keep the stored secret.",
  "hq.growth.ms.tenant": "Tenant",
  "hq.growth.ms.tenant_help": "Your Directory (tenant) ID or domain for a single-tenant app, or “organizations” for any work account.",
  "hq.growth.ms.secret_stored": "secret stored encrypted",
  "hq.growth.ms.from_env": "configured on the server",
  "hq.growth.ms.guide": "How to register the app in Microsoft Entra",
  "hq.growth.ms.g1": "Microsoft Entra admin center → Identity → Applications → App registrations → New registration. Name it “Listed HQ outreach”.",
  "hq.growth.ms.g2": "Supported account types: “Accounts in this organizational directory only” (single tenant) is the safe default.",
  "hq.growth.ms.g3": "Authentication → Add a platform → Web → paste the redirect URI shown above.",
  "hq.growth.ms.g4": "Certificates & secrets → New client secret → copy the Value immediately (it is shown once).",
  "hq.growth.ms.g5": "API permissions → Add → Microsoft Graph → Delegated: Mail.Send, Mail.Read, User.Read, offline_access → Grant admin consent. Then paste Client ID, secret and tenant here.",
  "hq.growth.ms.open_entra": "Open Microsoft Entra app registrations",
  "hq.growth.ms.redirecting": "Taking you to Microsoft to sign in…",
  "hq.growth.ms.connected_ok": "{address} is connected. Growth can now send from this mailbox.",
  "hq.growth.ms.connected_on": "connected {date}",
  "hq.growth.ms.disconnect": "Disconnect",

  /* ---------- HQ · Growth · P53 (media delivery, preview rail, settings) ---------- */
  "hq.growth.media.tier.mail": "E-mail",
  "hq.growth.media.tier.light": "Light",
  "hq.growth.media.tier.standard": "Full",
  "hq.growth.media.version": "Version",
  "hq.growth.media.embedded": "Embedded",
  "hq.growth.media.linked": "Linked",
  "hq.growth.media.embedded_help": "Travels inside the e-mail as an inline attachment — no download from the web needed.",
  "hq.growth.media.linked_help": "Too large to embed: the e-mail links to the hosted file. Outlook and some proxies hide such images.",
  "hq.growth.media.note_embedded": "Embedded in the e-mail, so it shows wherever images show. Animates in Gmail, Apple Mail and Outlook on the web; Outlook for Windows shows the first frame.",
  "hq.growth.media.note_linked": "{mb} MB is too large to embed, so the e-mail links to the hosted file instead — Outlook and many corporate proxies hide linked images. The E-mail version is embedded and always shows.",
  "hq.growth.media.use_mail": "Use E-mail version",
  "hq.growth.media.bulk": "Apply to all {n} drafts",
  "hq.growth.media.bulk_help": "Every open draft with a walkthrough switches to the E-mail version in its own language. Copy stays untouched.",
  "hq.growth.media.bulk_done": "{n} drafts now use the {label} version.",
  "hq.growth.preview.checks": "Before you send",
  "hq.growth.preview.all_good": "Ready",
  "hq.growth.preview.to_check": "{n} to check",
  "hq.growth.preview.from_missing": "No mailbox connected — both real sends and tests need Microsoft 365.",
  "hq.growth.preview.greeting": "Greeting",
  "hq.growth.preview.greeting_ok": "Matches the recipient",
  "hq.growth.preview.mismatch_help": "The address is a shared inbox. Pick another opening in the reader, or keep it as written.",
  "hq.growth.preview.size_label": "Size",
  "hq.growth.preview.attached": "{mb} MB attached",
  "hq.growth.test.help_short": "This exact e-mail, prefixed [Test], from your connected mailbox. The draft's status does not change.",
  "hq.growth.settings.nav.mailbox": "Sending mailbox",
  "hq.growth.settings.nav.limits": "Limits & timing",
  "hq.growth.settings.nav.identity": "Sender identity",
  "hq.growth.settings.nav.suppression": "Never contact",
  "hq.growth.settings.mailbox_title": "Sending mailbox",
  "hq.growth.settings.mailbox_lead": "Cold outreach goes out from your own Microsoft 365 mailbox — never from a shared platform sender. Connect it once; replies land in your inbox.",
  "hq.growth.settings.state.not_setup": "Not set up — nothing is sent yet",
  "hq.growth.settings.state.ready": "Set up — connect a mailbox to start sending",
  "hq.growth.settings.state.connected": "{n} mailbox connected",
  "hq.growth.settings.state.connected_plural": "{n} mailboxes connected",
  "hq.growth.settings.step1": "Register the app in Microsoft Entra",
  "hq.growth.settings.step1_sub": "One-time, about five minutes. Add the redirect URI below to the app.",
  "hq.growth.settings.step2": "Paste the app's credentials",
  "hq.growth.settings.step2_sub": "Stored encrypted. The secret is never shown again.",
  "hq.growth.settings.step3": "Connect your mailbox",
  "hq.growth.settings.step3_sub": "Sign in with the Microsoft account you want to send from. Listed reads the address from the account.",
  "hq.growth.settings.step3_locked": "Available after step 2.",
  "hq.growth.settings.connect_ms": "Connect with Microsoft",
  "hq.growth.settings.connect_another": "Connect another mailbox",
  "hq.growth.settings.add_manually": "Add an address first",
  "hq.growth.settings.app_registered": "App registration",
  "hq.growth.settings.limits_lead": "Low, human volumes keep cold outreach deliverable. Sending stops automatically at these limits.",
  "hq.growth.settings.identity_lead": "Every e-mail ends with a sender card — photo, name, title, company and links — built from your profile. The opt-out line is appended exactly as written here.",
  "hq.growth.settings.card_preview": "As it appears at the foot of every e-mail",
  "hq.growth.settings.card_empty": "Add your name to your profile to show a sender card.",
  "hq.growth.settings.profile_of": "Sender: {name}",
  "hq.growth.settings.profile_none": "No HQ profile found",
  "hq.growth.settings.profile_help_mine": "Name, title, phone, LinkedIn and photo come from your profile. When a draft is signed with your name, the card replaces those lines — nothing is written twice.",
  "hq.growth.settings.profile_help_other": "Name, title, phone, LinkedIn and photo come from {name}'s profile.",
  "hq.growth.settings.profile_pick": "Whose card",
  "hq.growth.settings.edit_profile": "Edit profile",
  "hq.growth.settings.company": "Company",
  "hq.growth.settings.website": "Website",
  "hq.growth.settings.card_toggle": "Sender card in e-mails",
  "hq.growth.settings.card_toggle_help": "Off = the e-mail ends with the typed sign-off only.",
  "hq.growth.settings.ai_section": "AI drafting (only when you ask)",
  "hq.growth.settings.ai_sub": "Used only by Improve / Draft with AI. Imported e-mails are never rewritten automatically.",
  "hq.growth.settings.suppression_lead": "Addresses and whole domains that must never be contacted. Adding one cancels any pending drafts.",
  "hq.growth.settings.unsaved": "Unsaved changes",
  "hq.growth.settings.discard": "Discard",
  "hq.growth.settings.hours": "{start}:00 – {end}:00",
  "hq.growth.settings.per_day": "per day",
  "hq.growth.settings.connected_as": "Signed in as {name}",
  "hq.growth.settings.cap_short": "{n}/day",
  "hq.growth.lead.tier": "Tier {tier}",
  "hq.growth.media.bulk_mail": "Use E-mail version for all {n} drafts",
  "hq.growth.outreach.mismatch_short": "Pick an opening, or keep it as written.",
  "hq.growth.outreach.source_off": "Hide source",
  "hq.growth.settings.media_base": "Public address for hosted media",
  "hq.growth.settings.media_base_help": "Where linked (non-embedded) walkthrough files are fetched from. Set this to the production domain before real sends; embedded files do not depend on it.",
  "hq.growth.settings.suppression_cancelled": "{n} pending draft(s) cancelled.",
  "hq.growth.outreach.edited": "Edited · v{v}",
  "hq.growth.queue.view.list": "List",
  "hq.growth.queue.view.table": "Table",
  "hq.growth.col.contact": "Contact",
  "hq.growth.col.subject": "Subject",
  "hq.growth.col.sent": "Sent",
  "hq.growth.col.outcome": "Outcome",
  "hq.growth.outcome.none_yet": "No outcome yet",
  "hq.growth.media.too_big": "Too large to embed — Outlook may hide it.",
  "hq.growth.media.tier_label.mail": "E-mail version",
  "hq.growth.media.tier_label.light": "Light version",
  "hq.growth.media.tier_label.standard": "Full version",

  /* ---------- HQ · Growth · P55 company pipeline (Leads · lead detail · touches · follow-ups · import check · automation) ---------- */
  "hq.growth.tab.leads": "Leads",
  "hq.growth.funnel.leads": "Leads",
  "hq.growth.import.step.check": "Check",
  "hq.growth.import.check_n": "Check {n} companies",
  "hq.growth.import.skip_n": "{n} skipped",
  "hq.growth.import.open_leads": "Open leads",
  "hq.growth.import.done_skipped": "{n} skipped",
  "hq.growth.import.skipped_list": "{n} rows were skipped",
  "hq.growth.import.plan_new": "New companies",
  "hq.growth.import.plan_new_sub": "Not in Growth yet — will be created.",
  "hq.growth.import.plan_update": "Refreshes",
  "hq.growth.import.plan_update_sub": "Same website or e-mail as a company you already have — research is refreshed, nothing duplicated.",
  "hq.growth.import.plan_review": "Need your decision",
  "hq.growth.import.plan_review_sub": "Looks like a company you have, but the website or country differs. Skipped unless you decide.",
  "hq.growth.import.plan_empty": "Nothing to import from the included sheets.",
  "hq.growth.import.review_title": "{n} look-alikes",
  "hq.growth.import.review_sub": "Merge into the existing company, add as a new one, or skip the row. Skip is the default — nothing is guessed.",
  "hq.growth.import.review_all": "All:",
  "hq.growth.import.decide.label": "What to do with this row",
  "hq.growth.import.decide.merge": "Merge into {name}",
  "hq.growth.import.decide.merge_short": "Merge",
  "hq.growth.import.decide.new": "Add as new",
  "hq.growth.import.decide.skip": "Skip",
  "hq.growth.import.existing": "already in Growth",
  "hq.growth.import.in_file": "in the file",
  "hq.growth.import.updates_title": "{n} companies will be refreshed",
  "hq.growth.import.updates_sub": "edited, approved or sent e-mails are never overwritten",
  "hq.growth.import.new_title": "{n} new companies",
  "hq.growth.import.reason.same_website": "same website",
  "hq.growth.import.reason.same_email_domain": "same e-mail domain",
  "hq.growth.import.reason.same_contact_email": "same contact e-mail",
  "hq.growth.import.reason.same_name": "same name",
  "hq.growth.import.reason.same_name_other_website": "same name, different website",
  "hq.growth.import.reason.same_name_other_country": "same name, different country",
  "hq.growth.import.reason.similar_name": "very similar name",
  "hq.growth.import.reason.skipped": "skipped by you",
  "hq.growth.import.reason.same_listed_id": "same lead (Listed ID from the export)",
  "hq.growth.import.roundtrip": "This file came out of the Growth export: rows carry a Listed ID, so each one updates the lead it came from — never a duplicate.",
  "hq.growth.import.sheet_wins": "The sheet wins over e-mails edited or approved in Growth",
  "hq.growth.import.sheet_wins_help": "On: an e-mail you edited or approved here is replaced by the sheet's copy and goes back to review. Off: what you edited or approved here is kept. Sent e-mails are never touched.",
  "hq.growth.import.updates_sub_overwrite": "the sheet's copy replaces edited or approved e-mails (back to review); sent e-mails are never touched",
  "hq.growth.import.done_replaced": "{n} e-mails replaced by the sheet — back to review",

  "hq.growth.col.stage": "Stage",
  "hq.growth.col.next": "Next",
  "hq.growth.col.last_touch": "Last touch",
  "hq.growth.leads.search": "Search company, market, PMS or contact",
  "hq.growth.leads.sort": "Sort",
  "hq.growth.leads.sort.action": "By next action",
  "hq.growth.leads.sort.fit": "Best fit first",
  "hq.growth.leads.sort.due": "Soonest due",
  "hq.growth.leads.sort.recent": "Recently active",
  "hq.growth.leads.sort.name": "Name",
  "hq.growth.leads.count": "{n} leads",
  "hq.growth.leads.more": "Show {n} more",
  "hq.growth.leads.due_in": "in {when}",
  "hq.growth.leads.due_ago": "{when}",
  "hq.growth.leads.export": "Export leads (.xlsx)",
  "hq.growth.leads.export_help": "Export the {n} leads not contacted yet — same columns as the import, so you can edit the file in Excel or ChatGPT and import it again",
  "hq.growth.leads.export_none": "No leads to export — everything here has been contacted",
  "hq.growth.leads.exported": "{n} leads exported — edit the file and import it again when you're done",
  "hq.growth.leads.exported_ok": "Export ready — edit the file and import it again when you're done",
  "hq.growth.leads.selection": "Selected leads",
  "hq.growth.leads.selected": "{n} selected",
  "hq.growth.leads.selected_contacted": "{n} already contacted",
  "hq.growth.leads.select_all": "Select all {n} in this view",
  "hq.growth.leads.select_all_capped": "The first {n} were selected — narrow the view to reach the rest",
  "hq.growth.leads.select_page": "Select every loaded lead",
  "hq.growth.leads.select_row": "Select {name}",
  "hq.growth.leads.clear_selection": "Clear selection",
  "hq.growth.leads.export_selected": "Export {n}",
  "hq.growth.leads.export_selected_help": "Only leads not contacted yet are exported",
  "hq.growth.leads.export_selected_none": "Nothing to export — every selected lead has been contacted",
  "hq.growth.leads.delete_title": "Delete {n} leads?",
  "hq.growth.leads.delete_title_one": "Delete {name}?",
  "hq.growth.leads.delete_sub": "The companies, their contacts, drafts and history are removed. This cannot be undone. Opt-outs stay on the suppression list.",
  "hq.growth.leads.delete_protected": "{n} of them were already contacted and will be kept — delete those one at a time from the lead itself.",
  "hq.growth.leads.delete_none": "Every selected lead has already been contacted. Those are deleted one at a time from the lead itself, so nothing is lost by accident.",
  "hq.growth.leads.delete_n": "Delete {n}",
  "hq.growth.leads.deleted": "{n} leads deleted",
  "hq.growth.leads.deleted_one": "Lead deleted",
  "hq.growth.leads.deleted_kept": "{n} deleted · {kept} kept (already contacted)",

  "hq.growth.stagechip.open": "Open",
  "hq.growth.stagechip.to_review": "To review",
  "hq.growth.stagechip.ready_to_send": "Ready",
  "hq.growth.stagechip.manual_channel": "LinkedIn / form",
  "hq.growth.stagechip.needs_email": "Needs e-mail",
  "hq.growth.stagechip.needs_draft": "No draft",
  "hq.growth.stagechip.contacted": "Contacted",
  "hq.growth.stagechip.follow_up_due": "Follow-up due",
  "hq.growth.stagechip.replied": "Replied",
  "hq.growth.stagechip.meeting": "Meeting",
  "hq.growth.stagechip.closed": "Closed",
  "hq.growth.stagechip.all": "All",
  "hq.growth.stage.to_review": "To review",
  "hq.growth.stage.ready_to_send": "Ready to send",
  "hq.growth.stage.manual_channel": "LinkedIn / form",
  "hq.growth.stage.needs_email": "Needs e-mail",
  "hq.growth.stage.needs_draft": "Needs a draft",
  "hq.growth.stage.contacted": "Contacted",
  "hq.growth.stage.follow_up_due": "Follow-up due",
  "hq.growth.stage.replied": "Replied",
  "hq.growth.stage.meeting": "Meeting",
  "hq.growth.stage.won": "Won",
  "hq.growth.stage.lost": "Lost",
  "hq.growth.stage.suppressed": "Do not contact",
  "hq.growth.stage.empty.open": "Nothing open — every lead is waiting on them, closed, or on the do-not-contact list.",
  "hq.growth.stage.empty.to_review": "No e-mails to review.",
  "hq.growth.stage.empty.ready_to_send": "Nothing approved and waiting to be sent.",
  "hq.growth.stage.empty.manual_channel": "No LinkedIn- or form-only leads left.",
  "hq.growth.stage.empty.needs_email": "Every lead has a verified address.",
  "hq.growth.stage.empty.needs_draft": "Every lead with an address has a draft.",
  "hq.growth.stage.empty.contacted": "Nobody is waiting on a reply right now.",
  "hq.growth.stage.empty.follow_up_due": "No follow-ups due. Good.",
  "hq.growth.stage.empty.replied": "No replies yet.",
  "hq.growth.stage.empty.meeting": "No meetings booked yet.",
  "hq.growth.stage.empty.closed": "Nothing closed yet.",
  "hq.growth.stage.empty.all": "No companies yet",
  "hq.growth.action.review": "Review the e-mail",
  "hq.growth.action.send": "Send the e-mail",
  "hq.growth.action.send_linkedin_dm": "Send the LinkedIn message",
  "hq.growth.action.submit_form": "Submit the contact form",
  "hq.growth.action.find_email": "Find an e-mail address",
  "hq.growth.action.write_draft": "Write the e-mail",
  "hq.growth.action.follow_up_1": "Follow-up 1",
  "hq.growth.action.follow_up_2": "Follow-up 2",
  "hq.growth.action.wait_reply": "Waiting for a reply",
  "hq.growth.action.book_meeting": "Book the meeting",
  "hq.growth.action.record_outcome": "Record the outcome",
  "hq.growth.action.none": "—",
  "hq.growth.dtab.overview": "Overview",
  "hq.growth.dtab.research": "Research",
  "hq.growth.dtab.outreach": "Outreach",
  "hq.growth.dtab.contacts": "Contacts",
  "hq.growth.dtab.activity": "Activity",
  "hq.growth.now.kicker": "Now",
  "hq.growth.now.review": "The imported e-mail is waiting for your approval.",
  "hq.growth.now.send": "Approved. Press Send, or let automatic sending take it.",
  "hq.growth.now.send_planned": "Approved — planned {when} ({tz} local) once automatic sending is on. Press Send to go now.",
  "hq.growth.now.send_held": "Approved but on hold — it stays out of the schedule until you release it.",
  "hq.growth.now.linkedin": "No e-mail address — the research recommends LinkedIn. Copy the message, send it there, then mark it here.",
  "hq.growth.now.form": "No e-mail address — reach them through the contact form on their website, then mark it here.",
  "hq.growth.now.find_email": "No route yet. Add a contact with an e-mail address, or log a LinkedIn message.",
  "hq.growth.now.write_draft": "There is an address but no e-mail. Draft one with AI or paste your own.",
  "hq.growth.now.follow_up": "Due {when}. Send the sheet's follow-up, or wait a little longer.",
  "hq.growth.now.wait": "Follow-up {when}. Log the reply as soon as it arrives.",
  "hq.growth.now.replied": "They replied — book the meeting and record it here.",
  "hq.growth.now.outcome": "Close the loop: won, lost, or later.",
  "hq.growth.now.none_won": "Won.",
  "hq.growth.now.none_lost": "Closed as lost.",
  "hq.growth.now.none_suppressed": "On the do-not-contact list. Nothing goes out.",
  "hq.growth.now.btn_open_email": "Open the e-mail",
  "hq.growth.now.btn_add_email": "Add a contact",
  "hq.growth.now.btn_draft": "Write the e-mail",
  "hq.growth.now.btn_outcome": "Record outcome",
  "hq.growth.now.btn_open_site": "Open website",
  "hq.growth.touch.logged": "Logged",
  "hq.growth.touch.mark_linkedin": "Mark as sent on LinkedIn",
  "hq.growth.touch.mark_form": "Mark form as submitted",
  "hq.growth.touch.mark_email": "Mark as e-mailed outside Growth",
  "hq.growth.touch.mark_followup": "Mark follow-up as sent",
  "hq.growth.touch.log_reply": "They replied",
  "hq.growth.touch.log_meeting": "Meeting booked",
  "hq.growth.touch.linkedin_logged": "{n} LinkedIn message(s) sent · last {when}",
  "hq.growth.touch.form_logged": "Form submitted {when}",
  "hq.growth.touch.log_title": "Log a call, meeting or note",
  "hq.growth.touch.channel": "Channel",
  "hq.growth.touch.kind": "What happened",
  "hq.growth.touch.note": "Note",
  "hq.growth.touch.note_ph": "Optional — what was said, what's next",
  "hq.growth.touch.log": "Log",
  "hq.growth.touch.ch.call": "Phone call",
  "hq.growth.touch.ch.linkedin": "LinkedIn",
  "hq.growth.touch.ch.contact_form": "Contact form",
  "hq.growth.touch.ch.email_manual": "E-mail (outside Growth)",
  "hq.growth.touch.ch.meeting": "Meeting",
  "hq.growth.touch.ch.other": "Other",
  "hq.growth.touch.kind.sent": "I reached out",
  "hq.growth.touch.kind.replied": "They replied",
  "hq.growth.touch.kind.meeting": "Meeting booked",
  "hq.growth.touch.kind.note": "Just a note",
  "hq.growth.followup.create": "Create follow-up {n}",
  "hq.growth.followup.created": "Follow-up {n} drafted — review and send it under Outreach",
  "hq.growth.followup.after_intro": "Available once the intro has gone out",
  "hq.growth.followup.linkedin_note": "Follow-up {n} sent on LinkedIn",
  "hq.growth.followup.make_due": "Follow up now",
  "hq.growth.followup.due_now": "Follow-up moved to now",
  "hq.growth.snooze": "Wait {n} more days",
  "hq.growth.snoozed": "Next follow-up in {n} days",
  "hq.growth.lead.why_company": "Why this company",
  "hq.growth.lead.scale": "Scale",
  "hq.growth.lead.contact_readiness": "Contact readiness",
  "hq.growth.lead.status_hint": "Sheet status",
  "hq.growth.overview.facts": "The facts",
  "hq.growth.overview.thin": "The sheet carried no argument for this company yet. Research it in ChatGPT and re-import, or run the AI researcher under Research.",
  "hq.growth.research.sheet": "From the research sheet",
  "hq.growth.research.imported": "imported {when} from “{name}”",
  "hq.growth.research.none": "No research fields were imported for this company.",
  "hq.growth.research.ai": "AI researcher (second opinion)",
  "hq.growth.research.ai_help": "Reads the company website, summarises what they do, finds decision-makers and scores the fit. Adds to the sheet — never changes the imported e-mail.",
  "hq.growth.field.hook": "Hook",
  "hq.growth.field.why_fits": "Why Listed fits",
  "hq.growth.field.why_now": "Why now",
  "hq.growth.field.outreach_angle": "Recommended angle",
  "hq.growth.field.owner_journey": "Owner journey today",
  "hq.growth.field.owner_portal": "Owner portal / booking layer",
  "hq.growth.field.integration_path": "Integration path",
  "hq.growth.field.previous_stack": "Previous / adjacent stack",
  "hq.growth.field.stack_category": "Stack category",
  "hq.growth.field.pms": "PMS / stack",
  "hq.growth.field.pms_confidence": "PMS confidence",
  "hq.growth.field.scale": "Scale",
  "hq.growth.field.evidence": "Evidence",
  "hq.growth.field.contact_readiness": "Contact readiness",
  "hq.growth.field.public_contact": "Public contact route",
  "hq.growth.field.next_step": "Suggested next step",
  "hq.growth.field.status_hint": "Sheet status",
  "hq.growth.field.alt_subject": "Alternative subject",
  "hq.growth.outreach.preferred": "Recommended channel",
  "hq.growth.outreach.touches": "{n} touches so far",
  "hq.growth.outreach.ch_email": "E-mail",
  "hq.growth.outreach.ch_followups": "Follow-ups from the sheet",
  "hq.growth.outreach.followups_help": "Verbatim from the sheet · sent as a reply to the intro",
  "hq.growth.outreach.ch_linkedin": "LinkedIn",
  "hq.growth.outreach.ch_form": "Contact form",
  "hq.growth.outreach.no_dm": "The sheet has no LinkedIn message for this company. Write one and log it below.",
  "hq.growth.outreach.form_help": "Reach them through the contact form on their website, then mark it as submitted.",
  "hq.growth.outreach.no_draft_title": "No e-mail drafted yet",
  "hq.growth.outreach.no_draft_sub": "The sheet carried an address but no copy. Draft one with AI (only when you ask), or send from your own client and mark it here.",
  "hq.growth.outreach.draft_needs_research": "Run the AI researcher first — the draft is written from it.",
  "hq.growth.notes_ph": "Anything worth remembering about this company…",
  "hq.growth.event.by_auto": "automatic",
  "hq.growth.event.imported": "Imported",
  "hq.growth.event.enriched": "Refreshed from the sheet",
  "hq.growth.event.import": "Import",
  "hq.growth.event.draft_imported": "E-mail imported",
  "hq.growth.event.draft_updated": "E-mail refreshed from the sheet",
  "hq.growth.event.draft_kept": "E-mail kept as edited",
  "hq.growth.event.drafted": "E-mail drafted",
  "hq.growth.event.draft_failed": "Drafting failed",
  "hq.growth.event.approved": "Approved",
  "hq.growth.event.rejected": "Rejected",
  "hq.growth.event.reopened": "Reopened",
  "hq.growth.event.sent": "E-mail sent",
  "hq.growth.event.send_failed": "Sending failed",
  "hq.growth.event.test_sent": "Test sent",
  "hq.growth.event.outcome": "Outcome recorded",
  "hq.growth.event.reply_detected": "Reply detected",
  "hq.growth.event.touch": "Outreach",
  "hq.growth.event.touch_removed": "Log entry removed",
  "hq.growth.event.follow_up_drafted": "Follow-up drafted",
  "hq.growth.event.rescheduled": "Rescheduled",
  "hq.growth.event.status_changed": "Status changed",
  "hq.growth.event.contact_added": "Contact added",
  "hq.growth.event.contact_email": "Contact e-mail changed",
  "hq.growth.event.contact_status": "Contact status changed",
  "hq.growth.event.researched": "AI research",
  "hq.growth.event.research_failed": "AI research failed",
  "hq.growth.event.scored": "Scored",
  "hq.growth.event.score_failed": "Scoring failed",
  "hq.growth.event.score_overridden": "Score set by hand",
  "hq.growth.event.suppressed": "Added to do-not-contact",
  "hq.growth.event.media_changed": "Walkthrough changed",
  "hq.growth.event.waitlist_linked": "Early-access application linked",
  "hq.growth.event.waitlist_signup": "Applied for early access",
  "hq.growth.settings.nav.automation": "Automation",
  "hq.growth.settings.automation_lead": "Approved e-mails can go out by themselves — spaced out, inside the send window, under the daily cap. Nothing is ever approved for you.",
  "hq.growth.settings.timezone": "Time zone",
  "hq.growth.settings.timezone_help": "Recipient's local time is used when their country is known; otherwise this zone.",
  "hq.growth.settings.warmup_hint": "{n} a day is a lot for a fresh sending domain. Start at 5–10 for the first two weeks, then raise it.",
  "hq.growth.auto.switch": "Automatic sending",
  "hq.growth.auto.title_off": "Automatic sending is off",
  "hq.growth.auto.title_on": "Automatic sending is on",
  "hq.growth.auto.title_paused": "Automatic sending is paused",
  "hq.growth.auto.title_blocked": "Automatic sending is on, but nothing can go out",
  "hq.growth.auto.state_off": "You press Send on every approved e-mail. Turn it on and approved e-mails go out by themselves.",
  "hq.growth.auto.state_paused": "Paused — press Resume when you're ready.",
  "hq.growth.auto.state_blocked": "Fix the blocker under Sending mailbox and it will continue on its own.",
  "hq.growth.auto.state_next": "Next e-mail goes out at {time}.",
  "hq.growth.auto.state_on_now": "Inside the send window — the next approved e-mail goes out within a minute.",
  "hq.growth.auto.state_on_window": "Waiting for the send window ({note}).",
  "hq.growth.auto.state_on_idle": "Nothing approved yet — approve e-mails under Leads and they will go out on their own.",
  "hq.growth.auto.pause": "Pause",
  "hq.growth.auto.resume": "Resume",
  "hq.growth.auto.paused_toast": "Paused — nothing goes out until you resume",
  "hq.growth.auto.resumed": "Resumed",
  "hq.growth.auto.auto_send_on_toast": "Automatic sending is on",
  "hq.growth.auto.auto_send_off_toast": "Automatic sending is off — you send by hand again",
  "hq.growth.auto.auto_follow_up_on_toast": "Follow-ups will be queued automatically while replies are being detected",
  "hq.growth.auto.auto_follow_up_off_toast": "Follow-ups are manual again",
  "hq.growth.auto.fact_approved": "Approved, waiting",
  "hq.growth.auto.fact_today": "Sent today / cap",
  "hq.growth.auto.fact_window": "Send window",
  "hq.growth.auto.fact_window_weekdays": "Send window · weekdays",
  "hq.growth.auto.fact_spacing": "Between e-mails",
  "hq.growth.auto.fact_spacing_v": "{min}–{max} min",
  "hq.growth.auto.rules": "One e-mail at a time, in fit order, with a random pause between them so it reads like a person. Stops at the daily cap, outside the window and on weekends (recipient's local time). Pauses itself after three failed sends or if the mailbox disconnects.",
  "hq.growth.auto.spacing_min": "Min. minutes between e-mails",
  "hq.growth.auto.spacing_max": "Max. minutes between e-mails",
  "hq.growth.auto.follow_up_days": "Follow-up 1 after (days)",
  "hq.growth.auto.follow_up_2_days": "Follow-up 2 after (days)",
  "hq.growth.auto.rd_title": "Reply & bounce detection",
  "hq.growth.auto.rd_none": "Needs a connected Microsoft 365 mailbox. Once connected, Growth reads the inbox every five minutes.",
  "hq.growth.auto.rd_waiting": "Mailbox connected — the first inbox check runs within five minutes.",
  "hq.growth.auto.rd_active": "Active · inbox checked {when}. Replies move the lead to Replied and stop every follow-up; bounces are marked.",
  "hq.growth.auto.rd_stale": "Last successful check {when} — it may be catching up.",
  "hq.growth.auto.rd_error": "Could not read the inbox:",
  "hq.growth.auto.rd_help": "Only messages from people you've written to (or their company) are matched. Nothing else in the inbox is stored.",
  "hq.growth.auto.rd_check": "Check inbox now",
  "hq.growth.auto.polled": "Inbox checked · {matched} replies · {bounced} bounces",
  "hq.growth.auto.fu_title": "Automatic follow-ups",
  "hq.growth.auto.fu_help": "Queues the sheet's follow-up 1 after {d1} days and follow-up 2 after {d2} more — verbatim, as a reply to the intro — and sends them with automatic sending.",
  "hq.growth.auto.fu_locked": "Only available while reply detection is active, so nobody who already answered gets chased.",
  "hq.growth.auto.fu_due": "{n} follow-ups are due and will be queued on the next run.",
  "hq.growth.auto.last_send": "Last automatic send {when}",
  "hq.growth.auto.last_tick": "last check {when}",
  "hq.growth.auto.chip_on": "Auto-send on",
  "hq.growth.auto.chip_idle": "Auto-send on · nothing approved",
  "hq.growth.auto.chip_next": "Auto-send · next {time}",
  "hq.growth.auto.chip_paused": "Auto-send paused",
  "hq.growth.auto.chip_blocked": "Auto-send blocked",


  /* ---------- HQ · Early access tab (applications) ---------- */
  "hq.wl.status.new": "New",
  "hq.wl.status.contacted": "Contacted",
  "hq.wl.status.converted": "Converted",
  "hq.wl.status.ignored": "Ignored",
  "hq.wl.stat.total": "Applications",
  "hq.wl.stat.units": "{n} units in total",
  "hq.wl.stat.week": "Last 7 days",
  "hq.wl.stat.campaign": "{n} from outreach",
  "hq.wl.search": "Search company, name or e-mail",
  "hq.wl.filter.all": "All",
  "hq.wl.filter.any_source": "Any source",
  "hq.wl.filter.outreach": "From outreach",
  "hq.wl.filter.direct": "Direct",
  "hq.wl.copy_link": "Copy landing-page link",
  "hq.wl.open_page": "Open /early-access",
  "hq.wl.export": "Export CSV",
  "hq.wl.empty": "No applications yet",
  "hq.wl.empty_filtered": "Nothing matches these filters",
  "hq.wl.empty_sub": "Every company that applies on /early-access shows up here — with source, units and a one-click hand-off into Growth.",
  "hq.wl.col.company": "Company",
  "hq.wl.col.contact": "Contact",
  "hq.wl.col.units": "Units",
  "hq.wl.col.source": "Source",
  "hq.wl.col.status": "Status",
  "hq.wl.col.joined": "Applied",
  "hq.wl.no_website": "No website given",
  "hq.wl.no_name": "No name given",
  "hq.wl.src.outreach": "Outreach link",
  "hq.wl.src.outreach_linked": "Outreach · {name}",
  "hq.wl.src.direct": "Direct",
  "hq.wl.joined_on": "Applied {date}",
  "hq.wl.signed_up_times": "applied {n} times",
  "hq.wl.open_in_growth": "Open in Growth",
  "hq.wl.add_to_growth": "Add to Growth",
  "hq.wl.linked_created": "Company and contact created in Growth.",
  "hq.wl.linked_matched": "Linked to the existing Growth company.",
  "hq.wl.f.name": "Name",
  "hq.wl.f.email": "E-mail",
  "hq.wl.f.website": "Website",
  "hq.wl.f.units": "Units",
  "hq.wl.f.referrer": "Referrer",
  "hq.wl.source_title": "Source & confirmation",
  "hq.wl.conf.title": "Confirmation e-mail",
  "hq.wl.conf.sent": "Sent",
  "hq.wl.conf.logged": "Logged (no sender configured)",
  "hq.wl.conf.failed": "Failed",
  "hq.wl.conf.none": "Not sent",
  "hq.wl.notes": "Notes",
  "hq.wl.notes_ph": "Call notes, brand assets received, setup status…",
  "hq.wl.deleted": "Application deleted.",
  "hq.wl.delete_title": "Delete this application?",
  "hq.wl.delete_confirm": "The application is removed from the early-access list. A Growth company created from it stays.",

  /* ---- Settings · Portal 2026 (P22.4) ---- */
  "settings.unsaved": "Unsaved changes",
  "settings.email": "E-mail sender",
  "common.discard": "Discard",
  "common.refresh": "Refresh",
  "branding.upload": "Upload",
  "branding.replace": "Replace",
  "branding.logo_uploaded": "Logo updated. It now appears on every owner page.",
  "branding.favicon_uploaded": "Browser icon updated.",
  "branding.asset_removed": "Removed.",
  "branding.asset_set": "Uploaded",
  "branding.asset_none": "Not set",
  "branding.asset_broken": "This image could not be loaded. Upload a new file.",
  "branding.org_name_help": "The name owners see in offers, agreements and e-mail.",
  "branding.logo_hint": "SVG, PNG or JPG · up to 2 MB · transparent background works best.",
  "branding.favicon_hint": "Square PNG or SVG · at least 64 × 64 px.",
  "branding.locale_sub": "Sets defaults for currency, tax and address lookup.",
  "branding.country_help": "Where you operate. Drives tax defaults and address search.",
  "branding.currency_help": "Used in every offer, estimate and price.",
  "branding.plan_domain": "Plan & domain",
  "branding.open_page": "Open your start page",
  "branding.preview_note": "How your start page opens for an owner. Colour and logo update as you save.",
  "email.sender.identity": "Sender identity",
  "email.sender.identity_sub": "How owner-facing mail appears in the inbox.",
  "email.receiving.title": "Replies & inbox",
  "email.receiving.sub": "Owner replies come back into Listed and show up in your Inbox and on the lead.",
  "email.receiving.on": "Receiving",
  "email.receiving.off": "Not receiving",
  "email.receiving.how": "Reply address",
  "email.receiving.how_help_on": "Every e-mail to an owner carries a unique reply address on {domain}. Replies are matched to the lead and a copy lands in your own mailbox.",
  "email.receiving.how_help_off": "Inbound capture is not configured on this platform. Replies go straight to your Reply-To mailbox and are not shown in Listed.",
  "email.receiving.domain_hint": "Reply from Outlook or Gmail to the copy you receive — that answer is captured on the lead too.",
  "email.receiving.not_configured": "Not configured",
  "email.receiving.activity": "Last 30 days",
  "email.receiving.activity_help": "Owner replies received, answers captured from your own mailbox, and owners waiting on you right now.",
  "email.receiving.stat_inbound": "Owner replies",
  "email.receiving.stat_captured": "Captured from mailbox",
  "email.receiving.stat_waiting": "Waiting on you",
  "email.receiving.last": "Last owner reply {when}.",
  "email.receiving.none_yet": "No owner reply received yet.",
  "email.sender.from_help": "Set by your plan. Verify your own domain below to send from it.",
  "email.sender.footer_help": "One line under every e-mail — company name, address or phone.",
  "email.domain.add_label": "Your domain",
  "email.domain.add_help": "Enter the domain you send mail from today, e.g. yourcompany.com.",
  "email.domain.domain": "Domain",
  "email.dns.title": "DNS records",
  "email.dns.sub": "Add these records at your domain provider, then check again. It usually takes a few minutes.",
  "capture.placeholder_help": "The hint inside the address field before the owner types.",
  "capture.trust_line_help": "One reassuring line under the button, e.g. “Free · no obligation”.",
  "capture.allow_listing_help": "Owners can paste an Airbnb or Booking.com link so details and photos are picked up automatically.",
  "capture.photo_upload_help": "Owners can add photos of the property in the enquiry.",
  "capture.required_phone_help": "Ask for a phone number before the enquiry can be sent.",
  "capture.est.source_help": "Where the numbers come from. Automatic picks the best available source per market.",
  "capture.est.show_source_help": "Mention the data source next to the estimate the owner sees.",
  "capture.preview_note": "The widget exactly as it renders on your site. Reloads after you save.",
  "pipe.stages": "Stages",
  "pipe.stages_sub": "The internal name is shown on the left; type what your team should see.",
  "auto.days": "Days",
  "auto.no_rules": "No rules yet. Add one to follow up automatically.",
  "auto.no_tasks": "No default tasks. Add the things your team always does after signing.",
  "auto.offer_rules_sub": "Counted from the day the offer is sent. Stops when the owner accepts or declines.",
  "auto.onboarding_rules_sub": "Counted from signing. Stops when onboarding is complete.",
  "tax.registration": "Registration",
  "tax.agreement_title": "In the agreement",
  "team.members": "{n} people",
  "team.invited": "Invited",
  "team.resend_invite": "Resend invitation",
  "team.invite_resent": "Invitation sent again to {email}.",
  "team.invite_sub": "We e-mail a single-use link so they can set their own password.",
  "team.password_optional": "Password (optional)",
  "team.password_optional_help": "Leave empty to send an invitation link instead.",
  "team.send_invite": "Send invitation",
  "team.invite_sent": "Invitation sent to {email}.",
  "team.invite_created_mail_failed": "The account was created, but the invitation e-mail could not be sent. Use “Resend invitation” once e-mail is set up.",
  "services.empty_sub": "Add the services you offer — management fee, cleaning, photography — and reuse them in every offer.",
  "services.includes_help": "One per line. Shown as bullet points in the offer.",
  "templates.empty_sub": "A template bundles services with a behaviour — required, included or optional — so every offer starts complete.",
  "onbt.intro_group": "Introduction",
  "onbt.intro_group_sub": "What the owner reads before the first question.",
  "onbt.name_help": "Internal name for this template.",
  "onbt.sections_sub": "{sections} sections · {questions} questions",
  "onbt.field_key_help": "Internal identifier. Used by integrations; letters, numbers and underscores.",
  "onbt.questions_title": "Questions",
  "onbt.no_questions": "No questions in this section yet.",
  "onbt.no_sections": "No sections yet. Add one to start building the onboarding.",
  "onbt.conditional": "Conditional",
  "onbt.ai_badge": "AI check",
  "contract.document": "Document",
  "install.link.url": "Your link",
  "install.link.url_help": "Fully branded, mobile-first, no code. Use it in ads, newsletters, listings and your navigation.",
  "install.link.tracking": "Tracking",
  "install.snippet_title": "Snippet",
  "install.options_sub": "Optional. Changes are reflected in the snippet and the preview.",
  "install.opt.max_width_help": "Leave empty to fill the container.",
  "install.opt.layout": "Layout",
  "install.opt.layout.card": "Card",
  "install.opt.layout.field": "Address field only",
  "install.opt.layout_help": "Card brings its own headline and copy. Address field only drops the search into your own hero section — you keep the heading.",
  "install.opt.placeholder": "Placeholder",
  "install.opt.placeholder_help": "The hint inside the field. Leave empty to use the text from Lead capture.",
  "install.snippet_note_field": "Paste it under your own heading. The field is transparent, fills its container and grows when suggestions open — the journey continues in a popup on your page.",

  "wf.live_rule_badge": "Honest live status",

  /* ---- Support & sales chat (P38) ---- */
  "sup.title": "Chat with Listed",
  "sup.launcher": "Ask Listed",
  "sup.open": "Open chat with Listed",
  "sup.assistant": "Listed assistant",
  "sup.typing": "Listed is writing",
  "sup.greeting": "Hi — I'm Listed's assistant. Ask me anything about how Listed works for property managers, or tell me what you're trying to do.",
  "sup.placeholder": "Ask about Listed…",
  "sup.placeholder_person": "Reply to Listed…",
  "sup.privacy": "Please don't share passwords or keys here. Conversations are read by Listed's team.",
  "sup.talk_to_person": "Talk to a person",
  "sup.new_conversation": "New conversation",
  "sup.closed_note": "This conversation is closed.",
  "sup.error": "That didn't go through. Please try again.",
  "sup.status.ai": "Online · replies in seconds",
  "sup.status.team": "Listed team · replies within a working day",
  "sup.status.open": "Online · replies in seconds",
  "sup.status.waiting_on_hq": "A person from Listed will pick this up",
  "sup.status.waiting_on_customer": "{name} replied · your turn",
  "sup.status.resolved": "Resolved",
  "sup.status.closed": "Closed",
  "sup.q1": "How does pricing work?",
  "sup.q2": "Which PMS do you support?",
  "sup.q3": "Can I white-label the owner pages?",
  "sup.q4": "I'd like a demo",
  "sup.handoff.title": "Talk to a person at Listed",
  "sup.handoff.sub": "Leave your details and someone from Listed replies here and by e-mail — usually within a working day.",
  "sup.handoff.name": "Your name",
  "sup.handoff.company": "Company",
  "sup.handoff.email": "E-mail address",
  "sup.handoff.message": "What can we help with? (optional)",
  "sup.handoff.email_invalid": "Enter a valid e-mail address so we can get back to you.",
  "sup.handoff.submit": "Send to Listed",
  "sup.handoff.sending": "Sending…",

  /* ---- Support desk (HQ) ---- */
  "hq.nav.support": "Support",
  "sup.hq.title": "Support",
  "sup.hq.counts": "{needs} need a reply · {open} open",
  "sup.hq.settings": "Chat settings",
  "sup.hq.settings_sub": "What the assistant knows, how visitors are greeted and who is notified.",
  "sup.hq.search": "Search…",
  "sup.hq.view.needs_reply": "Needs reply",
  "sup.hq.view.active": "Active",
  "sup.hq.view.waiting": "Waiting",
  "sup.hq.view.resolved": "Resolved",
  "sup.hq.view.all": "All",
  "sup.hq.ch.all": "All",
  "sup.hq.ch.web": "Website",
  "sup.hq.ch.portal": "Portal",
  "sup.hq.empty": "Nothing here",
  "sup.hq.empty_sub": "New conversations from the website and the portal land in this queue.",
  "sup.hq.total": "{n} conversations",
  "sup.hq.pick": "Pick a conversation",
  "sup.hq.pick_sub": "Read the full transcript, reply as a person, assign and resolve.",
  "sup.hq.no_subject": "New conversation",
  "sup.hq.visitor": "Website visitor",
  "sup.hq.assign_me": "Assign to me",
  "sup.hq.assigned": "Assigned to you",
  "sup.hq.unassign": "Unassign",
  "sup.hq.unassigned": "Unassigned",
  "sup.hq.you": "You",
  "sup.hq.resolve": "Resolve",
  "sup.hq.resolved_ok": "Marked as resolved",
  "sup.hq.reopen": "Reopen",
  "sup.hq.reopened": "Reopened",
  "sup.hq.details": "Case details",
  "sup.hq.closed_note": "This case is closed.",
  "sup.hq.mode.reply": "Reply",
  "sup.hq.mode.note": "Internal note",
  "sup.hq.note_hint": "Only visible to Listed HQ.",
  "sup.hq.reply_hint": "Sent to the customer in the chat.",
  "sup.hq.reply_hint_mail": "Sent in the chat and by e-mail to {email}.",
  "sup.hq.note_placeholder": "Write an internal note…",
  "sup.hq.reply_placeholder": "Reply to {name}…",
  "sup.hq.note_saved": "Note saved",
  "sup.hq.rail_empty": "Case details appear here.",
  "sup.hq.rail.contact": "Contact",
  "sup.hq.rail.email": "E-mail",
  "sup.hq.rail.org": "Organization",
  "sup.hq.rail.channel": "Channel",
  "sup.hq.rail.started": "Started",
  "sup.hq.rail.page": "Page",
  "sup.hq.rail.case": "Case",
  "sup.hq.rail.status": "Status",
  "sup.hq.rail.priority": "Priority",
  "sup.hq.rail.kind": "Type",
  "sup.hq.rail.assignee": "Assignee",
  "sup.hq.rail.tags": "Tags",
  "sup.hq.rail.tags_help": "Comma separated. Saved when you leave the field.",
  "sup.hq.rail.notes": "Internal notes",
  "sup.hq.rail.notes_empty": "No notes yet. Switch the composer to Internal note.",
  "sup.hq.set.public": "Chat on the public website",
  "sup.hq.set.public_help": "Show the chat launcher on listed pages.",
  "sup.hq.set.ai": "Assistant answers first",
  "sup.hq.set.ai_help": "The assistant answers from the knowledge below and hands over when it cannot help.",
  "sup.hq.set.ai_unavailable": "No AI provider configured — every message goes straight to a person.",
  "sup.hq.set.notify": "Notify by e-mail",
  "sup.hq.set.notify_help": "Where new cases that need a person are announced. Replies to customers use this as Reply-To.",
  "sup.hq.set.greeting": "Greeting",
  "sup.hq.set.knowledge": "What the assistant knows",
  "sup.hq.set.knowledge_help": "Plain text. The assistant only uses what is written here — never invents features or prices.",
  "sup.hq.set.knowledge_reset": "Reset to default",
  "sup.st.open": "Open",
  "sup.st.waiting_on_hq": "Needs reply",
  "sup.st.waiting_on_customer": "Waiting on customer",
  "sup.st.resolved": "Resolved",
  "sup.st.closed": "Closed",
  "sup.kind.sales": "Sales",
  "sup.kind.support": "Support",
  "sup.kind.question": "Question",
  "sup.kind.bug": "Bug",
  "sup.kind.billing": "Billing",
  "sup.kind.other": "Other",
  "sup.prio.low": "Low",
  "sup.prio.normal": "Normal",
  "sup.prio.high": "High",
  "sup.prio.urgent": "Urgent",

  /* ---- Portal help panel ---- */
  "nav.support": "Support chat",
  "sup.pm.title": "Help & support",
  "sup.pm.sub": "Ask the assistant or reach a person at Listed.",
  "sup.pm.ask": "Ask about Listed",
  "sup.pm.ask_sub": "How do I…? The assistant answers from Listed's documentation in seconds.",
  "sup.pm.ask_team": "Message Listed",
  "sup.pm.ask_team_sub": "A person from Listed replies here and by e-mail.",
  "sup.pm.placeholder": "How do I…",
  "sup.pm.quick.bug": "Report a problem",
  "sup.pm.quick.billing": "Billing question",
  "sup.pm.quick.support": "Get help with a setup",
  "sup.pm.yours": "Your conversations",
  "sup.pm.none": "No conversations yet",
  "sup.pm.none_sub": "Questions you ask and cases you file show up here for the whole team.",
  "sup.pm.new_case": "New case",
  "sup.pm.new_sub": "Tell us what happened and where. A person from Listed picks it up — you'll see replies here and get an e-mail.",
  "sup.pm.kind": "What is it about?",
  "sup.pm.subject": "Subject",
  "sup.pm.subject_ph": "Short and specific, e.g. “PDF download fails on iPhone”",
  "sup.pm.describe": "Describe it",
  "sup.pm.describe_ph": "What did you do, what happened, what did you expect? Which lead or property?",
  "sup.pm.describe_more": "Please add a few more words so we can help.",
  "sup.pm.send_case": "Send to Listed",
  "sup.pm.filed": "Sent to Listed — we'll get back to you",
  "sup.pm.conversation": "Conversation",
  "sup.pm.person_on_it": "A person from Listed is on it",
  "sup.pm.mark_solved": "Mark as solved",
  "sup.pm.resolved_note": "This conversation is solved. Ask something new from the help panel.",
  "sup.pm.back_home": "Back to help",

  /* ---------------- /features ---------------- */
  "ft.meta.title": "Features",
  "ft.hero.eyebrow": "Features",
  "ft.hero.title": "The whole owner journey, on your own website.",
  "ft.hero.sub": "An estimate on your pages. A proposal and e-signature on your domain. Onboarding in your brand, and a property that lands in your PMS. Owners only ever see you — Listed runs underneath.",
  "ft.hero.demo": "Ask for a demo",
  "ft.hero.works_with": "Pushes to",
  "ft.stack.stage": "Stage",
  "ft.stack.where": "Where it happens",

  "ft.where.site": "Your website",
  "ft.where.domain": "Your domain",
  "ft.where.pms": "Your PMS",

  "ft.stage.lead": "Lead",
  "ft.stage.estimate": "Estimate",
  "ft.stage.proposal": "Proposal",
  "ft.stage.agreement": "Agreement",
  "ft.stage.onboarding": "Onboarding",
  "ft.stage.pms-live": "PMS live",
  "ft.stage.lead.actor": "Owner",
  "ft.stage.estimate.actor": "Owner",
  "ft.stage.proposal.actor": "You",
  "ft.stage.agreement.actor": "Owner",
  "ft.stage.onboarding.actor": "Owner",
  "ft.stage.pms-live.actor": "Your team",

  "ft.site.eyebrow": "Your website, your brand",
  "ft.site.nav": "Your website",
  "ft.site.title": "Owners never leave your site.",
  "ft.site.sub": "Listed is the engine, not the storefront. The estimate lives on your pages. Proposals, e-signature and onboarding open on owners.yourcompany.com. E-mails leave from your domain. No Listed logo, login or link anywhere an owner looks.",
  "ft.site.caption": "A manager's own website with the estimate embedded — and where every later step lives.",
  "ft.site.f1.title": "The estimate on your pages",
  "ft.site.f1.text": "An inline field, a button, a floating launcher or a hosted page under your slug. Installed once, in one line — WordPress, Webflow, Squarespace, Wix, Framer, Shopify or plain HTML.",
  "ft.site.f2.title": "Owner pages on your domain",
  "ft.site.f2.text": "Proposal, signature and onboarding open on owners.yourcompany.com with your logo, colour and typography. No owner account, no app.",
  "ft.site.f3.title": "E-mail from your address",
  "ft.site.f3.text": "Once your DNS records are in place, every owner e-mail leaves from post@yourcompany.com. Replies land back on the lead, not in someone's mailbox.",
  "ft.site.f4.title": "One record underneath",
  "ft.site.f4.text": "Every step writes to the same record — the one that becomes the property in your PMS. Nothing is typed twice, and nothing lives in a spreadsheet.",

  "ft.journey.eyebrow": "The journey",
  "ft.journey.title": "Six stages. One record. Your name on all of it.",
  "ft.journey.sub": "Every stage has a clear outcome and a place it lives — on your website, on your domain or in your PMS. Nothing is retyped between them, and no owner is ever sent to a third-party site.",
  "ft.journey.rail_label": "Journey stages",
  "ft.journey.rail_note": "The label on the right is where the stage happens. Owners see your site and your domain from the first tap to the last signature.",

  "ft.ch.lead.eyebrow": "Capture",
  "ft.ch.lead.title": "An enquiry from your own pages.",
  "ft.ch.lead.body": "The address field sits on your website — inline, as a button, a floating launcher or a link in your menu. The address is verified as the owner types, and an existing listing is detected when there is one. What reaches your pipeline is a structured lead, not an e-mail to untangle.",
  "ft.ch.lead.b1": "Embedded on your site in one line — or a hosted page under your slug",
  "ft.ch.lead.b2": "Verified address, owner contact and property basics in one record",
  "ft.ch.lead.b3": "Stage, owner and notes visible to the whole team from the first second",
  "ft.ch.lead.caption": "What reaches your pipeline from the field on your site — and the four ways the field can sit there.",

  "ft.ch.estimate.eyebrow": "Estimate",
  "ft.ch.estimate.title": "A confident range in seconds — still on your site.",
  "ft.ch.estimate.body": "The owner sees a yearly range with the assumptions behind it — nightly rate, occupancy and the source — right where the address was typed. Your team sees the same numbers on the lead and can adjust them before anything is promised.",
  "ft.ch.estimate.b1": "Range-based, with visible assumptions instead of a single magic number",
  "ft.ch.estimate.b2": "Instant on your pages, editable by you before the proposal goes out",
  "ft.ch.estimate.b3": "The estimate carries into the proposal and the agreement unchanged",
  "ft.ch.estimate.caption": "The range the owner sees, with the assumptions your team can adjust.",

  "ft.ch.proposal.eyebrow": "Propose",
  "ft.ch.proposal.title": "A proposal that opens on your domain.",
  "ft.ch.proposal.body": "Built from your template and the lead's numbers, then sent as a link on owners.yourcompany.com. Your logo, your colour, your sender name. The owner reads it on their phone and accepts in place — no attachment, no login.",
  "ft.ch.proposal.b1": "Reusable templates with locked, optional and always-on sections",
  "ft.ch.proposal.b2": "A guided configurator per offer; the document stays editable when you need it",
  "ft.ch.proposal.b3": "Opens on your owner domain in your brand — Listed is never mentioned",
  "ft.ch.proposal.caption": "The proposal page owners open — on the manager's own domain.",

  "ft.ch.agreement.eyebrow": "Agree",
  "ft.ch.agreement.title": "Signed on your domain, filed on the record.",
  "ft.ch.agreement.body": "Acceptance turns into an agreement the owner signs in the browser, on the same domain as the proposal. The signed PDF is attached to the confirmation e-mail — sent from your address — and stored on the lead with a full audit line.",
  "ft.ch.agreement.b1": "E-signature in the browser — no account and no third-party tool for the owner",
  "ft.ch.agreement.b2": "Signed PDF attached to the confirmation and downloadable at any time",
  "ft.ch.agreement.b3": "Who signed, when and from where — on the record, permanently",
  "ft.ch.agreement.caption": "The signed agreement and its audit line.",

  "ft.ch.onboarding.eyebrow": "Onboard",
  "ft.ch.onboarding.title": "The owner fills in the rest — on their phone, on your domain.",
  "ft.ch.onboarding.body": "After signing, the owner gets one link. Photos, access codes, Wi-Fi, house rules and payout details are collected in the right order. Sensitive fields are encrypted at rest and masked for your team until they need them.",
  "ft.ch.onboarding.b1": "Checklist-driven steps the owner can pause and pick up later",
  "ft.ch.onboarding.b2": "Access codes, Wi-Fi and bank details sealed at rest; every reveal is logged",
  "ft.ch.onboarding.b3": "Everything lands on the same record that goes to your PMS",
  "ft.ch.onboarding.caption": "Owner onboarding as it appears on the owner's phone — your brand, your domain.",

  "ft.ch.pms-live.eyebrow": "Launch",
  "ft.ch.pms-live.title": "One push, and the property is in your PMS.",
  "ft.ch.pms-live.body": "The record you built from the first address becomes a listing in Hostaway, Guesty, Hostfully or Beds24 — or is linked to an existing Lodgify, Smoobu, Uplisting or Hospitable property. Status is visible to the team, and the record stays the source of truth for the next owner who lands on your website.",
  "ft.ch.pms-live.b1": "Property, owner and media pushed together — nothing typed twice",
  "ft.ch.pms-live.b2": "Clear connection and sync status per property",
  "ft.ch.pms-live.b3": "A clean handoff to operations; the owner's pages keep working after go-live",
  "ft.ch.pms-live.caption": "The handoff to the PMS — with the source record kept intact.",

  "ft.mod.eyebrow": "Modules",
  "ft.mod.title": "The parts around the journey.",
  "ft.mod.sub": "Capabilities you lean on at every stage — the same way from the first lead to the five-hundredth home.",
  "ft.mod.white-label.eyebrow": "White-label",
  "ft.mod.white-label.title": "Your brand on every owner screen.",
  "ft.mod.white-label.body": "Logo, colour, sender name and domain are set once. Every owner page, e-mail and PDF follows — on owners.yourcompany.com, with no trace of Listed. Paste your website and we read the name, logo and colour for you.",
  "ft.mod.white-label.b1": "Brand colour and logo applied across every owner route and document",
  "ft.mod.white-label.b2": "Owner pages served from your own subdomain",
  "ft.mod.white-label.b3": "E-mails from your domain, with your signature",
  "ft.mod.inbox.eyebrow": "Inbox",
  "ft.mod.inbox.title": "Owner replies land on the lead — not in someone's mailbox.",
  "ft.mod.inbox.body": "Every message to and from an owner is tied to the lead and the property. Reply in your name from the record, see who is waiting for an answer, and keep internal notes apart from what the owner sees.",
  "ft.mod.inbox.b1": "Two-way e-mail per lead, with unread and needs-reply signals",
  "ft.mod.inbox.b2": "Sent as you — your sender name and your domain",
  "ft.mod.inbox.b3": "Internal notes stay internal",
  "ft.mod.templates.eyebrow": "Proposal templates",
  "ft.mod.templates.title": "Consistent offers, without the copy-paste.",
  "ft.mod.templates.body": "Design a template once — which sections are locked, which are optional, which are always on. Each offer starts from it with the lead's numbers filled in, and the personal letter is drafted for you to edit.",
  "ft.mod.templates.b1": "Locked, optional and always-on sections",
  "ft.mod.templates.b2": "Merge fields for owner, address and estimate",
  "ft.mod.templates.b3": "AI-drafted personal letter — never sent without you",
  "ft.mod.integrations.eyebrow": "Integrations",
  "ft.mod.integrations.title": "Connected to the PMS you already run.",
  "ft.mod.integrations.body": "Hostaway, Guesty, Hostfully and Beds24 receive the property with one push. Lodgify, Smoobu, Uplisting and Hospitable link to an existing listing. Your own developers can post leads straight to the public API from any form on your site.",
  "ft.mod.integrations.b1": "Hostaway, Guesty, Hostfully, Beds24, Lodgify, Smoobu, Uplisting and Hospitable",
  "ft.mod.integrations.b2": "Connection and sync status per property",
  "ft.mod.integrations.b3": "Public lead API and browser events for your own tooling",
  "ft.mod.security.eyebrow": "Security & oversight",
  "ft.mod.security.title": "Sensitive data, handled like it matters.",
  "ft.mod.security.body": "Access codes, Wi-Fi passwords and bank details are encrypted at rest and masked for your team. Every reveal is logged. Roles decide who sees what, and every change has a name and a time.",
  "ft.mod.security.b1": "Encrypted secure fields with audited reveals",
  "ft.mod.security.b2": "Role-based visibility for team members",
  "ft.mod.security.b3": "Activity history on every lead, owner and property",
  "ft.mod.support.eyebrow": "Support",
  "ft.mod.support.title": "Help inside the product — and a person when you need one.",
  "ft.mod.support.body": "Ask in the portal and get an answer that knows Listed. When that isn't enough, file a case and a person from Listed picks it up — replies show in the same thread, and your team sees them too.",
  "ft.mod.support.b1": "Answers in context, in seconds",
  "ft.mod.support.b2": "Cases with status and history, shared with your team",
  "ft.mod.support.b3": "Human handoff — no ticket black hole",

  "ft.inc.eyebrow": "Included",
  "ft.inc.title": "Everything you need to run the journey.",
  "ft.inc.sub": "No add-ons for the basics. The same system from your first owner to your five-hundredth home.",
  "ft.inc.1": "Estimate widget for your own website",
  "ft.inc.2": "Owner pages on your own domain",
  "ft.inc.3": "Unlimited leads and pipeline stages",
  "ft.inc.4": "Proposal templates and guided configurator",
  "ft.inc.5": "E-signature with signed PDF",
  "ft.inc.6": "Owner onboarding on mobile",
  "ft.inc.7": "Encrypted secure fields",
  "ft.inc.8": "Two-way owner inbox",
  "ft.inc.9": "E-mail from your domain",
  "ft.inc.10": "PMS push and sync status",
  "ft.inc.11": "Team roles and activity history",
  "ft.inc.12": "Support chat and cases",

  "ft.cta.title": "Put the whole journey on your website.",
  "ft.cta.sub": "Paste your website and we read the name, logo and colour. Install the estimate in one line — the first owner can sign this week.",

  /* /features visuals */
  "ft.vis.lead.new": "New lead",
  "ft.vis.lead.source": "northstay.com · inline field",
  "ft.vis.lead.just_now": "just now",
  "ft.vis.lead.verified": "Verified",
  "ft.vis.lead.owner": "Owner",
  "ft.vis.lead.property": "Property",
  "ft.vis.lead.prop_v": "Apartment · 3 bedrooms · 84 m²",
  "ft.vis.lead.note": "“Available from June, currently self-managed”",
  "ft.vis.lead.listing": "Existing listing found · 4.9 · 112 reviews",
  "ft.vis.lead.stage": "In your pipeline",
  "ft.vis.lead.modes": "How the field sits on your site",
  "ft.vis.lead.mode.inline": "Inline",
  "ft.vis.lead.mode.button": "Button",
  "ft.vis.lead.mode.floating": "Floating",
  "ft.vis.lead.mode.link": "Link",
  "ft.vis.est.title": "Estimated yearly revenue",
  "ft.vis.est.per_year": "per year",
  "ft.vis.est.range": "Range {lo} – {hi}",
  "ft.vis.est.adr": "Nightly rate",
  "ft.vis.est.occ": "Occupancy",
  "ft.vis.est.source": "Source",
  "ft.vis.est.source_v": "Market data",
  "ft.vis.agr.doc": "Management agreement",
  "ft.vis.agr.title": "Northstay · Rua da Prata 42",
  "ft.vis.agr.owner": "Owner",
  "ft.vis.agr.manager": "Manager",
  "ft.vis.agr.audit1": "Signed by Emma Costa · IP recorded",
  "ft.vis.agr.audit2": "Signed PDF sent from post@northstay.com",
  "ft.vis.inbox.title": "Inbox",
  "ft.vis.inbox.needs": "{n} needs a reply",
  "ft.vis.inbox.r1": "Can we start on the 1st instead?",
  "ft.vis.inbox.r2": "Photos uploaded",
  "ft.vis.inbox.r3": "Thanks — signed",
  "ft.vis.inbox.msg_owner": "Can we start on the 1st instead of the 15th? I'll be abroad.",
  "ft.vis.inbox.msg_you": "Of course — I've moved the start date to 1 June. The agreement is updated.",
  "ft.vis.inbox.sent_as": "Sent as {name}",
  "ft.vis.tpl.template": "Template",
  "ft.vis.tpl.sections": "Sections",
  "ft.vis.tpl.b1": "Cover & personal letter",
  "ft.vis.tpl.b2": "Your estimate",
  "ft.vis.tpl.b3": "Photography package",
  "ft.vis.tpl.b4": "Interior styling",
  "ft.vis.tpl.b5": "Fees & terms",
  "ft.vis.tpl.locked": "Locked",
  "ft.vis.tpl.always": "Always",
  "ft.vis.tpl.merge": "Personal letter · merge fields",
  "ft.vis.tpl.letter_1": "Dear",
  "ft.vis.tpl.letter_2": ", thank you for your interest in letting",
  "ft.vis.tpl.letter_3": ". Based on comparable homes nearby we expect",
  "ft.vis.tpl.drafted": "Drafted",
  "ft.vis.int.push": "Pushes property",
  "ft.vis.int.link": "Links existing",
  "ft.vis.int.webhooks": "Public API",
  "ft.vis.sec.title": "Secure fields · Rua da Prata 42",
  "ft.vis.sec.encrypted": "Encrypted",
  "ft.vis.sec.door": "Door code",
  "ft.vis.sec.wifi": "Wi-Fi",
  "ft.vis.sec.bank": "Payout account",
  "ft.vis.sec.activity": "Activity",
  "ft.vis.sec.a1": "Emma Costa filled in access details",
  "ft.vis.sec.a2": "Mari revealed the door code",
  "ft.vis.sec.a3": "Reveal logged on the record",
  "ft.vis.sup.q": "Can owners sign on their phone?",
  "ft.vis.sup.a": "Yes — the agreement opens on your owner domain and is signed in the browser. No account, no app. The signed PDF is e-mailed automatically.",
  "ft.vis.sup.handoff": "Handed to a person",
  "ft.vis.sup.person": "Happy to walk you through it — want a 15-minute demo this week?",
  "ft.vis.site.url": "northstay.com/estimate",
  "ft.vis.site.nav1": "Homes",
  "ft.vis.site.nav2": "Owners",
  "ft.vis.site.nav3": "About",
  "ft.vis.site.h1": "How much could your home earn?",
  "ft.vis.site.sub": "Type your address and get a yearly estimate in seconds.",
  "ft.vis.site.cta": "Get my estimate",
  "ft.vis.site.badge": "Embedded on your page, in your colour — Listed underneath",
  "ft.vis.site.where1": "Estimate",
  "ft.vis.site.where2": "Proposal · Agreement · Onboarding",
  "ft.vis.site.where3": "Every owner e-mail",

  /* ---------------- Billing (PM) ---------------- */
  "bill.sub": "Listed is free to use. You pay one flat fee per owner who signs a management agreement in Listed — collected on one invoice when the month closes, at your volume tier for the year.",
  "bill.see_pricing": "Pricing",
  "bill.saved": "Billing details saved",
  "bill.signed_year": "Signed owners in {year}",
  "bill.signed_none": "Nothing charged yet",
  "bill.signed_sub": "Signed in Listed this calendar year",
  "bill.next_owner": "Your next signed owner",
  "bill.next_invoice": "On your next invoice",
  "bill.next_invoice_sub": "{n} signed · incl. {tax}",
  "bill.next_invoice_none": "Nothing to invoice yet",
  "bill.next_invoice_credit": "Credit carried to your next invoice",
  "bill.tiers_title": "Volume tiers",
  "bill.tiers_sub": "Per calendar year. Cross a threshold and every owner after it costs less — automatically.",
  "bill.tier_first": "First {n} owners",
  "bill.tier_range": "Owners {from}–{to}",
  "bill.tier_open": "Owner {from} and up",
  "bill.tier_current": "current",
  "bill.per_owner": "per signed owner",
  "bill.to_next_tier": "{n} more signed owners this year and the price drops to {price}.",
  "bill.next_lines_title": "Next invoice",
  "bill.next_lines_sub": "Every owner who signs shows up here the same minute. Cancelled within {days} days? Credited in full — ask us.",
  "bill.lines_empty": "Nothing to invoice",
  "bill.lines_empty_sub": "The moment an owner signs the agreement in Listed, the fee appears here.",
  "bill.subtotal": "Subtotal (excl. tax)",
  "bill.total": "Total",
  "bill.invoices_title": "Invoices",
  "bill.invoices_sub": "Issued when the month closes; due {days} days later. Download the PDF at any time.",
  "bill.invoices_empty": "No invoices yet",
  "bill.invoices_empty_sub": "Your first invoice arrives after your first owner signs.",
  "bill.draft": "Draft",
  "bill.period": "Period",
  "bill.issued": "issued",
  "bill.due": "due",
  "bill.paid_on": "paid",
  "bill.download_pdf": "Download PDF",
  "bill.status.draft": "Draft",
  "bill.status.issued": "Open",
  "bill.status.overdue": "Overdue",
  "bill.status.paid": "Paid",
  "bill.status.void": "Void",
  "bill.status.uncollectible": "Written off",
  "bill.profile_title": "Invoice details",
  "bill.profile_sub": "Who receives Listed's invoices, and what goes on them.",
  "bill.legal_entity": "Billed to",
  "bill.legal_entity_help": "Your legal entity and address, from your company profile.",
  "bill.legal_missing": "Company name not set",
  "bill.address_missing": "Address not set — add it under Get started",
  "bill.email": "Billing e-mail",
  "bill.email_help": "Invoices (with PDF) are sent here the moment they are issued.",
  "bill.contact": "Contact person",
  "bill.reference": "Your reference",
  "bill.reference_help": "A purchase-order number or cost centre, printed on every invoice.",
  "bill.vat_number": "VAT number",
  "bill.vat_number_help": "Defaults to the registration number from Tax & VAT.",
  "bill.notes": "Notes to Listed",
  "bill.notes_help": "Anything our billing team should know.",
  "bill.payment_title": "Payment",
  "bill.payment_bank": "Bank transfer",
  "bill.payment_bank_help": "Account details and the reference are printed on the invoice.",
  "bill.payment_card": "Card payment",
  "bill.payment_card_help": "Save a card once and every invoice is settled automatically the day it is issued — no bank transfers to remember.",
  "bill.available": "Available",
  "bill.coming": "Coming soon",
  "bill.note": "Amounts exclude tax unless stated. Manually marked or migrated signings are never charged — only e-signatures completed in Listed. Questions about a line? Open a support case and mention the property.",

  /* ---------------- Billing (HQ) ---------------- */
  "hq.nav.billing": "Billing",
  "hqb.title": "Billing",
  "hqb.sub": "Listed's receivables: unbilled signings per organisation, open and overdue invoices, month-end close.",
  "hqb.settings": "Billing settings",
  "hqb.close_all": "Close {period} for everyone",
  "hqb.close_all_done": "{n} draft invoice(s) created",
  "hqb.unbilled": "Unbilled",
  "hqb.unbilled_sub": "Signed owners not yet on an invoice",
  "hqb.open": "Open invoices",
  "hqb.open_sub": "{n} drafts and issued",
  "hqb.overdue": "Overdue",
  "hqb.overdue_sub": "{n} past due date",
  "hqb.paid_ytd": "Paid in {year}",
  "hqb.paid_sub": "{n} invoices settled",
  "hqb.orgs": "Organisations",
  "hqb.orgs_sub": "Open one to close, credit or issue",
  "hqb.no_orgs": "No organisations yet",
  "hqb.org_unbilled": "{n} unbilled · {amount}",
  "hqb.org_nothing": "Nothing unbilled",
  "hqb.org_credit": "Credit carried forward · {amount}",
  "hqb.org_open": "{n} open · {amount}",
  "hqb.org_overdue": "{n} overdue",
  "hqb.profile_incomplete": "Billing details missing",
  "hqb.invoices": "Invoices",
  "hqb.no_invoices": "No invoices here",
  "hqb.no_invoices_sub": "Close a period for an organisation to create the first draft.",
  "hqb.filter.open": "Open",
  "hqb.filter.issued": "Issued",
  "hqb.filter.overdue": "Overdue",
  "hqb.filter.paid": "Paid",
  "hqb.filter.draft": "Drafts",
  "hqb.filter.void": "Void",
  "hqb.filter.uncollectible": "Written off",
  "hqb.filter.all": "All",
  "hqb.act.issue": "Issue and e-mail",
  "hqb.act.paid": "Mark as paid",
  "hqb.act.send": "Send again",
  "hqb.act.void": "Void",
  "hqb.act.writeoff": "Write off",
  "hqb.act.none": "No actions",
  "hqb.act.credit": "Credit",
  "hqb.act.waive": "Waive",
  "hqb.issued_ok": "Invoice issued and e-mailed",
  "hqb.sent_ok": "Invoice e-mailed",
  "hqb.draft_ok": "Draft invoice created",
  "hqb.paid_ok": "Marked as paid",
  "hqb.void_ok": "Invoice voided — lines released",
  "hqb.writeoff_ok": "Invoice written off",
  "hqb.credited_ok": "Fee credited",
  "hqb.waived_ok": "Fee waived",
  "hqb.paid_title": "Mark {n} as paid",
  "hqb.paid_desc": "Record a payment of {amount}. This does not move money — it records that it arrived.",
  "hqb.void_title": "Void {n}",
  "hqb.void_desc": "The invoice is cancelled and its lines return to the organisation's unbilled list.",
  "hqb.writeoff_title": "Write off {n}",
  "hqb.writeoff_desc": "Mark the invoice as uncollectible. It stays on record; nothing is released.",
  "hqb.method.bank_transfer": "Bank transfer",
  "hqb.method.card": "Card",
  "hqb.method.other": "Other",
  "hqb.reference_ph": "Payment reference (optional)",
  "hqb.reason_ph": "Reason (shown on the record)",
  "hqb.org_sheet_sub": "{n} signed in {year} · next owner priced in {tier}",
  "hqb.bill_to": "Bill to",
  "hqb.no_email": "No billing e-mail — the organisation must add one under Settings → Billing",
  "hqb.unbilled_lines": "Unbilled",
  "hqb.incl_tax": "incl. tax",
  "hqb.close_draft": "Create draft",
  "hqb.close_issue": "Close, issue and e-mail",
  "hqb.need_email": "Issuing needs a billing e-mail. You can still create a draft.",
  "hqb.events": "History",
  "hqb.no_events": "No signings yet",
  "hqb.ev_signed": "Signed owner",
  "hqb.ev_credit": "Credit",
  "hqb.ev_status.unbilled": "Unbilled",
  "hqb.ev_status.invoiced": "Invoiced",
  "hqb.ev_status.credited": "Credited",
  "hqb.ev_status.waived": "Waived",
  "hqb.credit_title": "Credit this fee",
  "hqb.credit_desc": "for an owner who cancelled inside the credit window. Unbilled fees leave the next invoice; invoiced fees become a credit line on the next one.",
  "hqb.waive_title": "Waive this fee",
  "hqb.waive_desc": "goodwill — the fee is dropped and counts for nothing.",
  "hqb.settings_title": "Billing settings",
  "hqb.settings_sub": "Who issues the invoices, the volume tiers and the tax rule. Applies to every invoice issued from now on.",
  "hqb.settings_saved": "Billing settings saved",
  "hqb.issuer": "Issuer",
  "hqb.issuer_name": "Legal name",
  "hqb.issuer_org_number": "Registration number",
  "hqb.issuer_vat_number": "VAT number",
  "hqb.issuer_address": "Address",
  "hqb.issuer_postal_code": "Postal code",
  "hqb.issuer_city": "City",
  "hqb.issuer_country": "Country (ISO)",
  "hqb.issuer_email": "Billing e-mail",
  "hqb.issuer_bank_account": "Bank account",
  "hqb.issuer_iban": "IBAN",
  "hqb.issuer_bic": "BIC",
  "hqb.tiers": "Volume tiers (per signed owner, excl. tax)",
  "hqb.tier_upto": "Up to owner no.",
  "hqb.tier_open_label": "Open-ended",
  "hqb.due_days": "Due after (days)",
  "hqb.credit_days": "Credit window (days)",
  "hqb.tax_home": "Home country",
  "hqb.tax_rate": "Tax rate",
  "hqb.tax_label": "Tax label",
  "hqb.prefix": "Invoice number prefix",
  "hqb.notes": "Payment note on invoices",
  "hqb.tax_note": "Customers in the home country are charged the tax rate; business customers elsewhere are invoiced at 0 % with a reverse-charge note. Confirm with your accountant.",

  // Ported: onboarding builder v2 (catalogue, badges, phone preview) + no-PMS handoff
  "common.or": "or",
  "common.collapse": "Collapse",
  "common.expand": "Expand",
  "onbt.welcome_screen": "Welcome screen",
  "onbt.intro_text_ph": "A sentence or two the owner reads before the first question.",
  "onbt.new_section_title": "New section {n}",
  "onbt.section_desc_ph": "One line on what this section is for (optional)",
  "onbt.remove_section": "Remove section",
  "onbt.add_first_question": "Add the first question",
  "onbt.untitled_question": "Untitled question",
  "onbt.remove_question": "Remove question",
  "onbt.added": "Added “{name}”",
  "onbt.change_icon": "Change icon",
  "onbt.pick_icon": "Pick an icon",
  "onbt.field_help_hint": "Shown under the question on the owner's phone.",
  "onbt.behaviour": "Answer",
  "onbt.behaviour_hint.optional": "The owner can skip it.",
  "onbt.behaviour_hint.required": "Needed to finish the section — the property can still go live without it.",
  "onbt.behaviour_hint.blocking": "The property cannot go live until this is answered.",
  "onbt.only_when": "Only when",
  "onbt.is": "is",
  "onbt.always_shown": "Always shown",
  "onbt.condition_values_ph": "Type the answers that reveal this question, comma separated",
  "onbt.condition_pick_value": "Pick at least one answer, or the question is never shown.",
  "onbt.ask_only_for": "Ask only for",
  "onbt.all_property_types": "All homes",
  "onbt.option_label": "Option",
  "onbt.add_option": "Add option",
  "onbt.options_needed": "Add at least two options.",
  "onbt.custom_note": "Your own question. The answer stays in Listed — on the property page and the handover sheet — and is never sent to {pms}.",
  "onbt.a_pms": "a property system",
  "onbt.catalogue_note_pms": "Part of Listed's property schema. The answer is written into the {pms} listing when the property is created or synced.",
  "onbt.catalogue_note": "Part of Listed's property schema. The answer lands on the property page and the handover sheet.",
  "onbt.badge.listed_only": "Listed only",
  "onbt.badge.pms_tip": "The answer is written into your {pms} listing.",
  "onbt.badge.pms_required_tip": "{pms} cannot create a listing without this answer.",
  "onbt.badge.internal_tip": "{pms} has no field for this. The answer stays in Listed — property page and handover sheet.",
  "onbt.badge.internal_tip_nopms": "No property system connected. The answer lives in Listed — property page and handover sheet.",
  "onbt.badge.custom_tip": "Your own question. Stays in Listed; never sent to a property system.",
  "onbt.badge.encrypted": "Encrypted",
  "onbt.badge.encrypted_tip": "Stored encrypted. Shown to guests only during their stay.",
  "onbt.badge.blocks_tip": "The property cannot go live without this answer.",
  "onbt.badge.reads_photo": "Reads photo",
  "onbt.badge.reads_photo_tip": "Listed reads the photo and suggests the answer (router label, key box, panel…).",
  "onbt.cov.no_pms": "No property system connected. This template feeds Listed's property page and handover sheet — connect a PMS and every question will show whether its answer is sent there.",
  "onbt.cov.connect": "Connect a property system",
  "onbt.cov.line": "Asks {covered} of {total} answers {pms} takes from the owner",
  "onbt.cov.required_missing": "{n} required by your PMS missing",
  "onbt.cov.complete": "Everything your PMS can take is asked",
  "onbt.cov.not_asked": "Not asked:",
  "onbt.cat.title": "Add a question",
  "onbt.cat.sub": "Listed's property schema — each answer says where it ends up.",
  "onbt.cat.sub_target": "Goes into “{section}”",
  "onbt.cat.count": "{added} of {total} in your template",
  "onbt.cat.search": "Search questions…",
  "onbt.cat.no_match": "No question matches. Write your own below.",
  "onbt.cat.added": "Added",
  "onbt.cat.custom_hint": "Need something that is not in the schema? Write your own question — it stays inside Listed.",
  "onbt.cat.custom_cta": "Write your own",
  "onbt.cat.back": "Back to the catalogue",
  "onbt.custom.title": "Your own question",
  "onbt.custom.sub": "Added to the section you have open.",
  "onbt.custom.banner_title": "Internal — only in Listed",
  "onbt.custom.banner_pms": "{pms} has no field for this, so the answer is never sent there. It is shown on the property page and in the handover sheet for your team.",
  "onbt.custom.banner_nopms": "The answer is shown on the property page and in the handover sheet for your team.",
  "onbt.custom.label_ph": "e.g. Where is the spare vacuum cleaner?",
  "onbt.custom.answer_as": "The owner answers with",
  "onbt.custom.create": "Add question",
  "onbt.preview.title": "The owner's phone",
  "onbt.preview.note": "Live from your draft. Nothing here is saved or sent.",
  "onbt.preview.button": "Preview",
  "onbt.preview.overview": "Overview",
  "onbt.preview.question": "Question",
  "onbt.preview.no_options": "No options yet",
  "handoff.nopms.title": "Go live",
  "handoff.nopms.body": "No property system is connected — Listed is the source of truth for this home. Confirm when it is bookable on your channels.",
  "handoff.nopms.connect": "Connect a property system",
  "handoff.nopms.ready": "Onboarding is complete. Confirm when the home is published and bookable.",
  "handoff.nopms.not_ready": "{n} launch blocker(s) remain — you can still confirm live, it is logged as manual.",
  "handoff.nopms.mark_live": "Confirm the home is live",
  "handoff.nopms.live_by": "Confirmed live by {by} · {when}",
  "onbt.visibility": "Visibility",

  // Ported (go-live package): password flows, Account section, HQ go-live panel
  "auth.back_to_login": "Back to log in",
  "login.forgot": "Forgot your password?",
  "forgot.title": "Reset your password",
  "forgot.sub": "Enter the e-mail you log in with. If we know it, we'll send a link to choose a new password.",
  "forgot.submit": "Send reset link",
  "forgot.sent_title": "Check your inbox",
  "forgot.sent_sub": "If an account exists for {email}, a reset link is on its way.",
  "forgot.sent_note": "The link works once and expires in 1 hour. Nothing arrived after a few minutes? Check spam, or try again with the address you registered with.",
  "forgot.try_again": "Use another e-mail",
  "reset.checking": "Checking your link…",
  "reset.title": "Choose a new password",
  "reset.sub": "Pick something you don't use anywhere else. You'll be logged in straight away.",
  "reset.set_title": "Set your password",
  "reset.set_sub": "Welcome to {org} on Listed. Choose a password and you're in.",
  "reset.for_account": "For",
  "reset.submit": "Save new password",
  "reset.set_submit": "Set password and log in",
  "reset.done_reset": "Password updated — you're logged in.",
  "reset.done_set": "Welcome! Your password is set.",
  "reset.invalid_title": "This link is no longer valid",
  "reset.invalid_sub": "Reset links work once and expire — invitation links after 7 days, reset links after 1 hour. Request a new one below.",
  "reset.request_new": "Request a new link",
  "pw.new": "New password",
  "pw.confirm": "Repeat new password",
  "pw.current": "Current password",
  "pw.hint": "At least {n} characters. Avoid common passwords.",
  "pw.too_short": "Use at least {n} characters.",
  "pw.too_common": "That password is too common.",
  "pw.mismatch": "The two passwords don't match.",
  "pw.show": "Show password",
  "pw.hide": "Hide password",
  "pw.change": "Change password",
  "pw.changed": "Password changed.",
  "settings.account": "Account",
  "account.title": "Account",
  "account.sub": "Who you're logged in as, and your password.",
  "account.signed_in": "Logged in as",
  "account.password_sub": "You stay logged in on this device. Other devices need the new password next time.",
  "golive.title": "Go-live readiness",
  "golive.sub": "Environment and data checks before production. Values are never shown — only whether each check passes.",
  "golive.ready": "Ready for production",
  "golive.blocking": "{n} blocking",
  "golive.level.critical": "Critical",
  "golive.level.high": "High",
  "golive.level.medium": "Medium",
  "golive.level.info": "Info",
  "golive.demo_pw_title": "You are logged in with the demo password",
  "golive.demo_pw_body": "Anyone who has seen the demo can log in to Listed HQ. Change it now.",
  "golive.pw_sub": "Your Listed HQ password. Platform owners bootstrapped from SUPERADMIN_EMAILS set theirs via “Forgot your password?” on the log-in page.",
  "golive.actions.title": "Before you go live — your steps outside Listed",
  "golive.actions.sub": "Microsoft 365, DNS, Entra, Resend and Emergent for {domain}. Values are ready to copy; steps Listed can observe are verified automatically, the rest you tick off yourself.",
  "golive.actions.all_done": "All steps done",
  "golive.actions.open": "{n} of {total} open",
  "golive.actions.optional": "Optional",
  "golive.actions.verified": "Verified",
  "golive.actions.done_by": "Done · {by}",
  "golive.actions.not_yet": "Not yet",
  "golive.actions.mark_done": "Mark done",
  "golive.actions.undo": "Undo",
  "golive.actions.group.microsoft": "Microsoft 365 — Growth sender",
  "golive.actions.group.integrations": "Entra & Resend",
  "golive.actions.group.deploy": "Domain & deploy",
  "golive.actions.group.data": "Data in production",
  "golive.actions.group.optional": "Optional",
  "golive.marked_done": "Marked as done",
  "golive.marked_open": "Marked as open",
  "golive.purge.button": "Remove demo tenant",
  "golive.purge.title": "Remove the Northstay demo tenant?",
  "golive.purge.body": "Deletes the Northstay organisation, its accounts and every lead, offer, agreement and message that belongs to it — from the database of the environment you are in right now. Growth leads and platform settings are not touched. This cannot be undone.",
  "golive.purge.type": "Type northstay to confirm",
  "golive.purge.run": "Remove permanently",
  "golive.purge.done": "Demo tenant removed · {n} records deleted",
  "golive.purge.nothing": "No demo tenant in this database",
  "hq.alerts.title": "Platform alerts",
  "hq.alerts.sub": "Unhandled errors (500) and e-mails the provider refused. Owners get one e-mail per problem per hour; the full list lives here.",
  "hq.alerts.open": "{n} open",
  "hq.alerts.none": "All clear",
  "hq.alerts.empty": "No open alerts",
  "hq.alerts.empty_sub": "When something breaks — a 500 or an e-mail Resend refuses — it shows up here and in your inbox.",
  "hq.alerts.resolve": "Resolve",
  "hq.alerts.resolved": "Alert resolved",
  "hq.backup.title": "Backup",
  "hq.backup.sub": "Download every collection as JSON lines in one ZIP — a manual copy before a deploy or a risky change. Encrypted secrets stay encrypted; photos and media files are not included.",
  "hq.backup.download": "Download backup (.zip)",
  "hq.backup.done": "Backup downloaded",
  "settings.all": "All settings",
  "settings.search_ph": "Search settings…",
  "settings.search_empty": "No setting matches that.",
  "settings.search_empty_sub": "Try another word — for example “logo”, “VAT”, “Hostaway” or “invite”.",
  "settings.group.brand": "Brand & owner experience",
  "settings.group.brand_sub": "How Listed looks and sounds to your owners — logo, colours, widget copy and the sender of every e-mail.",
  "settings.group.website": "Website & install",
  "settings.group.website_sub": "Put your start page, widget or button where owners find you, and see where enquiries come from.",
  "settings.group.offers": "Offers & agreements",
  "settings.group.offers_sub": "What you sell, how tax is shown, and the proposal and agreement every owner signs.",
  "settings.group.onboarding": "Onboarding & PMS",
  "settings.group.onboarding_sub": "The questions owners answer on their phone, and the property system that receives the result.",
  "settings.group.workflow": "Workflow & team",
  "settings.group.workflow_sub": "Stage names, automatic follow-ups and who on your team does what.",
  "settings.group.workspace": "Workspace",
  "settings.group.workspace_sub": "What Listed charges you, and your own account.",
  "settings.desc.branding": "Name, logo, browser icon, colour and cover photos on every owner surface.",
  "settings.desc.capture": "The words and behaviour of the widget and start page.",
  "settings.desc.email": "Who owner e-mails come from, reply-to and your own sending domain.",
  "settings.desc.install": "Hosted link, embed code, button, launcher, QR code and API events.",
  "settings.desc.services": "Your catalogue: management fees, cleaning, photography and add-ons.",
  "settings.desc.tax": "Registration, standard rate and how private owners vs. businesses see prices.",
  "settings.desc.templates": "Proposal templates and the shared content they reuse.",
  "settings.desc.contract": "The management agreement owners sign after accepting.",
  "settings.desc.onboarding": "Sections and questions of the owner onboarding journey.",
  "settings.desc.integrations": "Your PMS connection and the hand-over workflow.",
  "settings.desc.pipeline": "What your team calls each stage of the journey.",
  "settings.desc.automations": "Reminders and tasks that fire while you wait on an owner.",
  "settings.desc.team": "Colleagues, invitations and roles.",
  "settings.desc.billing": "Volume tier, next invoice, invoices and who receives them.",
  "settings.desc.account": "Your profile, password and session.",
  "settings.hint.brand_ok": "Logo and colour set",
  "settings.hint.logo_missing": "Logo missing",
  "settings.hint.copy_set": "Copy customised",
  "settings.hint.defaults": "Using defaults",
  "settings.hint.own_domain": "Your own domain",
  "settings.hint.listed_domain": "Listed domain, your name",
  "settings.hint.installed_on": "Installed on {host}",
  "settings.hint.not_installed": "Not detected on a site yet",
  "settings.hint.services": "{n} services",
  "settings.hint.tax_missing": "Registration number missing",
  "settings.hint.templates": "{n} templates",
  "settings.hint.contract": "Standard agreement",
  "settings.hint.onboarding": "Owner journey",
  "settings.hint.pms_connected": "{pms} connected",
  "settings.hint.pms_none": "No PMS connected",
  "settings.hint.stages": "{n} stages",
  "settings.hint.auto_on": "On · {n} rules",
  "settings.hint.auto_off": "Off",
  "settings.hint.billing": "Invoiced monthly",
  "settings.health.title": "Workspace setup",
  "settings.health.complete": "Setup complete.",
  "settings.health.complete_sub": "Every step is done — change anything below whenever you like.",
  "auto.state_on": "On · {n} active rules",
  "auto.state_off": "Off",
  "auto.last_run": "Last evaluated {when}",
  "auto.never_run": "Not evaluated yet",
  "auto.fired_recent": "{n} actions fired in the last 10 runs",
  "auto.day": "Day",
  "auto.start.offer": "Offer sent to the owner",
  "auto.start.signed": "Agreement signed",
  "pipe.preview": "How the board header reads to your team",
  "pipe.stage_help.new": "An enquiry just arrived. Qualify it or mark it lost.",
  "pipe.stage_help.qualified": "Worth pursuing — build and send the proposal.",
  "pipe.stage_help.offer": "The proposal is with the owner. Follow-ups run from here.",
  "pipe.stage_help.signed": "Agreement signed. Onboarding invitation goes out.",
  "pipe.stage_help.onboarding": "The owner answers questions and adds photos on their phone.",
  "pipe.stage_help.ready": "Everything needed is in. Push to the PMS and go live.",
  "pipe.stage_help.live": "Bookable in your property system.",
  "team.sub_short": "Who works in this workspace and what each role can do.",
  "team.pending": "{n} pending invitation(s)",
  "team.pending_sub": "They have a single-use link to set a password. Resend it if it expired.",
  "team.roles_title": "What each role can do",
  "team.roles_sub": "Roles are set per person; change them any time from the list above.",
  "team.role_desc.admin": "Configures the organisation: brand, integrations, billing and team.",
  "team.role_desc.manager": "Runs leads, offers and onboarding end to end, and can change settings.",
  "team.role_desc.sales": "Handles leads and offers up to signature.",
  "team.role_desc.operations": "Handles onboarding, launch tasks and the PMS hand-over.",
  "account.member_since": "Member since",
  "account.password_changed": "Password changed",
  "account.password_never": "Never",
  "account.workspace_slug": "Owner start page",
  "account.session_title": "Session",
  "account.session_sub": "You are logged in on this device.",
  "account.session_this": "This device",
  "account.session_help": "Logging out clears the session here only.",
  "bill.credit_balance": "Credit balance",
  "bill.credit": "Credit",
  "dash.title.morning": "Good morning, {name}.",
  "dash.title.afternoon": "Good afternoon, {name}.",
  "dash.title.evening": "Good evening, {name}.",
  "dash.title.night": "Working late, {name}?",
  "dash.qa.copy_start": "Copy start-page link",
  "dash.qa.link_copied": "Start-page link copied",
  "cmd.placeholder_short": "Search or jump to…",
  "nav.create": "Create",
  "nav.create_more": "More ways to create",
  "dash.next.title": "Up next",
  "dash.next.sub": "{n} things only you can move today",
  "dash.next.reply": "Reply to {owner}",
  "dash.next.reply_cta": "Reply",
  "dash.next.launch": "Push {property} live",
  "dash.next.launch_sub": "Everything is in — hand it over to your PMS.",
  "dash.next.launch_cta": "Launch",
  "dash.next.followup": "Follow up on {property}",
  "dash.next.followup_sub": "{owner} has had the offer for {n} days",
  "dash.next.followup_cta": "Follow up",
  "dash.next.qualify": "Qualify {property}",
  "dash.next.qualify_sub": "{owner} enquired {ago}",
  "dash.next.qualify_cta": "Review",
  "dash.next.unblock": "Unblock {property}",
  "dash.next.unblock_sub": "{owner} owner answers · {internal} internal tasks outstanding",
  "dash.next.unblock_cta": "Open",
  "dash.next.empty": "You're all caught up.",
  "dash.next.empty_sub": "Nothing is waiting on you right now — owners have the ball.",
  "pipeline.est_revenue": "Estimated yearly booking revenue",
  "common.undo": "Undo",
  "kbd.title": "Keyboard shortcuts",
  "kbd.sub": "Work faster — none of these fire while you type.",
  "kbd.search": "Search or jump anywhere",
  "kbd.new_lead": "New lead",
  "kbd.help": "Show this sheet",
  "kbd.save": "Save (in settings)",
  "kbd.close": "Close dialogs",
  "kbd.then": "then",
  "settings.tip_cmdk": "jumps to any setting from anywhere",
  "settings.tip_kbd": "shows every keyboard shortcut",
  "account.password_tip": "Use a passphrase you don't use anywhere else. A password manager makes that painless.",

  /* ---- Growth · Queue-first outbound (P56) ---- */
  "common.previous": "Previous",
  "hq.growth.tab.prospects": "Prospects",
  "hq.growth.tab.replies": "Replies",
  "hq.growth.funnel.no_email": "{n} need e-mail enrichment",
  "hq.growth.more": "More",
  "hq.growth.import.cta": "Import leads",
  "hq.growth.recipient.direct": "Direct e-mail",
  "hq.growth.recipient.company": "Company inbox",
  "hq.growth.recipient.none": "No verified e-mail",
  "hq.growth.recipient.direct_help": "A named person's own address.",
  "hq.growth.recipient.company_help": "A shared or role inbox (info@, general@, sales@). Safe to write to; the greeting should not pretend.",
  "hq.growth.recipient.none_help": "No send-safe address yet. LinkedIn or the contact form is today's fallback — add an address once it is found.",
  "hq.growth.pms.in_house": "In-house PMS",
  "hq.growth.media.optimised": "optimised for e-mail",
  "hq.growth.media.still": "first frame as fallback",
  "hq.growth.msg.send_email": "Send e-mail",
  "hq.growth.msg.approve_auto": "Approve for automatic sending",
  "hq.growth.msg.queued_auto": "Queued for automatic sending",
  "hq.growth.outreach.from_not_connected": "no mailbox connected yet",
  "hq.growth.outreach.from_fallback": "Microsoft fallback domain",
  "hq.growth.outreach.from_fallback_help": "Recipients see this address as the sender. Set your real address (e.g. name@digihome.ai) as primary in Microsoft 365 admin, then Disconnect → Connect under Settings; Listed follows the new address.",
  "hq.growth.outreach.from_fallback_cta": "How to fix",
  "hq.growth.outreach.company_inbox_note": "this message is addressed to {name} but will be sent to {address}.",
  "hq.growth.outreach.greeting": "Greeting:",
  "hq.growth.outreach.greeting_help": "Only the first line changes. Everything else stays exactly as imported.",
  "hq.growth.outreach.greeting_keep": "As written",
  "hq.growth.outreach.sent_to": "Sent to {name}",
  "hq.growth.test.connect_first": "Connect a Microsoft 365 mailbox to send test e-mails — a test travels the same way as the real e-mail.",
  "hq.growth.lead.public_contact": "Public contact",
  "hq.growth.noemail.copy_dm": "Copy LinkedIn message",
  "hq.growth.noemail.open_form": "Open contact form",
  "hq.growth.noemail.kicker": "Needs e-mail enrichment",
  "hq.growth.settings.test_recipient": "Test recipient",
  "hq.growth.settings.test_recipient_help": "Where “Send test” goes. Leave empty to use the connected mailbox's own address.",
  "hq.growth.settings.test_recipient_ph": "same as the connected mailbox",
  "hq.growth.bucket.short.incomplete": "No copy",
  "hq.growth.bucket.empty.incomplete": "Every address has a prepared e-mail",
  "hq.growth.queue.split": "{direct} direct · {company} company inbox",
  "hq.growth.queue.enrich_help": "No verified address yet. Use the fallback for now, or add an e-mail and the stored copy becomes a draft.",
  "hq.growth.col.fallback": "Fallback",
  "hq.growth.col.recipient": "Recipient",
  "hq.growth.import.summary_title": "{n} companies imported",
  "hq.growth.import.sum.direct_email": "Direct e-mails",
  "hq.growth.import.sum.company_inbox": "Company inboxes",
  "hq.growth.import.sum.no_verified_email": "Need e-mail enrichment",
  "hq.growth.import.sum.contacted": "Contacted",
  "hq.growth.import.sum.direct_email_help": "A named person's own address",
  "hq.growth.import.sum.company_inbox_help": "info@, general@ … — safe to write to",
  "hq.growth.import.sum.no_verified_email_help": "LinkedIn or form for now",
  "hq.growth.import.sum.contacted_help": "Already reached before this import",
  "hq.growth.import.ready_line": "{n} prepared e-mails are ready to review.",
  "hq.growth.import.ready_none": "No prepared e-mails to review yet — add addresses to the leads that need enrichment.",
  "hq.growth.import.review_n": "Review {n} ready",
  "hq.growth.import.open_prospects": "Open prospects",
  "hq.growth.replies.title": "Replies",
  "hq.growth.replies.sub": "Every e-mail that went out, and what came back. Replies and bounces are detected from the connected mailbox (checked every 5 minutes); record the outcome when you have read the reply.",
  "hq.growth.replies.empty": "Nothing sent yet",
  "hq.growth.replies.empty_sub": "Once the first e-mails go out from the queue, they appear here with their outcome.",
  "hq.growth.replies.open_queue": "Open the queue",
  "hq.growth.replies.count": "{n} sent",
  "hq.growth.replies.replied": "{n} replied",
  "hq.growth.replies.no_outcome": "Waiting",
  "hq.growth.replies.replied_by": "Replied · {who} · {when}",
  "hq.growth.replies.auto_reply": "Out-of-office reply · {when} · still waiting",
  "hq.growth.queue.approve_all": "Approve all ({n})",
  "hq.growth.queue.approve_all_title": "Approve {n} e-mails?",
  "hq.growth.queue.approve_all_body": "Every approved e-mail gets a slot in the schedule — the recipient's best local hours, inside your daily limit — and goes out by itself once automatic sending is on. Nothing is sent while it is off. You can hold or re-open any e-mail afterwards.",
  "hq.growth.queue.approve_all_warn": "Also approve {n} with a recipient warning",
  "hq.growth.queue.approve_all_warn_help": "A greeting to a named person, but the address is a company inbox. Off = those stay in review.",
  "hq.growth.queue.approve_all_run": "Approve all",
  "hq.growth.queue.approve_all_done": "{n} e-mails approved",
  "hq.growth.queue.approve_all_left": "{n} with warnings left for review",
  "hq.growth.plan.today": "Today: {planned} planned · {sent} sent · limit {cap}",
  "hq.growth.plan.later": "{n} on the next days",
  "hq.growth.plan.held": "{n} on hold",
  "hq.growth.plan.next": "next {when} ({tz}) → {company}",
  "hq.growth.plan.no_mailbox": "Connect a mailbox under Settings — nothing goes out until then.",
  "hq.growth.plan.on_hold": "On hold",
  "hq.growth.plan.slot": "{when} · {tz}",
  "hq.growth.plan.hold": "Hold",
  "hq.growth.plan.release": "Release",
  "hq.growth.plan.held_ok": "On hold — it stays approved but leaves the schedule",
  "hq.growth.plan.released_ok": "Back in the schedule",
  "hq.growth.plan.planned_line": "Planned {when} · {tz} local",
  "hq.growth.lead.local_time": "Local time {time} · {label}",
  "hq.growth.settings.best_hours": "Best hours (recipient's local time)",
  "hq.growth.settings.best_hours_prime": "First choice",
  "hq.growth.settings.best_hours_secondary": "then",
  "hq.growth.settings.monday_from": "Monday not before",
  "hq.growth.settings.friday_until": "Friday only until",
  "hq.growth.settings.best_hours_help": "Every approved e-mail gets a slot in these hours, Tuesday–Thursday first, spread over your daily limit with the spacing below. The window above is the hard limit; nothing goes out outside it.",
  "hq.growth.import.approve": "Approve clean drafts on import",
  "hq.growth.import.approve_help": "New drafts whose recipient check is clean go straight into the schedule. Drafts with a warning (person greeting → company inbox) stay in review. Nothing is sent while automatic sending is off.",
  "hq.growth.import.done_approved": "{n} approved on import — already in the schedule",
  "hq.growth.settings.brand_link": "Link the product name",
  "hq.growth.settings.brand_link_help": "The first plain “Listed by DigiHome” in an e-mail links to the public site. The stored text is untouched; write [Listed by DigiHome](https://…) yourself to choose the destination.",
  "hq.growth.settings.media_caption_en": "Line under the walkthrough (English)",
  "hq.growth.settings.media_caption_nb": "Line under the walkthrough (Norwegian)",
  "hq.growth.settings.media_caption_help": "Shown as a link right under the animation — the path that always works when images are blocked. Leave empty for no line (the image still links).",
  "hq.growth.settings.media_link": "Walkthrough link",
  "hq.growth.settings.media_link_help": "Where the animation and the line link to. Empty = the public site's Features page.",
  "hq.growth.outreach.markup_hint": "[text](https://…) makes a link · **text** makes it bold · [GIF] places the walkthrough",
  "hq.growth.replies.record": "Record outcome",
  "hq.growth.overview.where": "Where",
  "hq.growth.overview.contact": "Contact",
  "hq.growth.overview.owner_today": "How owners sign up today",
  "hq.growth.overview.sources": "{n} sources",
  "hq.growth.overview.preview_email": "Preview e-mail",
  "hq.growth.overview.open_outreach": "Open outreach",
  "hq.growth.overview.more_research": "Everything the sheet carried is under Research.",
  "hq.growth.overview.open_full": "Open the full lead",
  /* ---- Add / edit a lead by hand ---- */
  "hq.growth.ms.onmicrosoft_warn": "{address} is Microsoft's fallback domain — cold e-mail from it looks untrustworthy and carries Microsoft's, not your, sender reputation. In Microsoft 365 admin set your real address (e.g. martin@digihome.ai) as the primary e-mail, then Disconnect → Connect here; Listed follows the new address automatically.",
  "hq.growth.add_lead": "Add lead",
  "hq.growth.edit_lead": "Edit lead",
  "hq.growth.event.created_manually": "Added by hand",
  "hq.growth.event.fit_set": "Fit set by hand",
  "hq.growth.leadform.title": "Add a lead",
  "hq.growth.leadform.sub": "Same shape as one row of the research sheet. Fill in what you know — everything else can be added later. Copy is stored exactly as written.",
  "hq.growth.leadform.edit_title": "Edit {name}",
  "hq.growth.leadform.edit_sub": "Corrects the company, the research and the main contact. The prepared e-mail is edited from the Queue.",
  "hq.growth.leadform.company": "Company",
  "hq.growth.leadform.name": "Company name",
  "hq.growth.leadform.website": "Website",
  "hq.growth.leadform.website_help": "Also how duplicates are recognised — one company per domain.",
  "hq.growth.leadform.pms": "PMS / core stack",
  "hq.growth.leadform.pms_help": "Leave empty when unknown.",
  "hq.growth.leadform.country": "Country",
  "hq.growth.leadform.country_help": "Two-letter code (NO, PT, AU …).",
  "hq.growth.leadform.market": "Markets",
  "hq.growth.leadform.market_help": "Cities or regions they operate in.",
  "hq.growth.leadform.language": "E-mail language",
  "hq.growth.leadform.language_auto": "From country",
  "hq.growth.leadform.fit": "Research fit",
  "hq.growth.leadform.fit_help": "0–10 · 8+ is tier A.",
  "hq.growth.leadform.fit_tier": "Tier {tier}",
  "hq.growth.leadform.why": "Why this lead",
  "hq.growth.leadform.why_sub": "shown on the lead and used as the opening hook",
  "hq.growth.leadform.hook": "Personalisation hook",
  "hq.growth.leadform.hook_help": "The one observation that proves you looked — e.g. their four-step owner journey.",
  "hq.growth.leadform.why_fits": "Why Listed fits",
  "hq.growth.leadform.why_now": "Why now",
  "hq.growth.leadform.contact": "Contact",
  "hq.growth.leadform.contact_sub": "a name, an address, a LinkedIn profile — any one is enough",
  "hq.growth.leadform.contact_edit_sub": "the main contact",
  "hq.growth.leadform.contact_name": "Name",
  "hq.growth.leadform.role": "Role",
  "hq.growth.leadform.email": "E-mail",
  "hq.growth.leadform.email_help": "Direct address or a company inbox — Listed tells them apart. Leave empty to enrich later.",
  "hq.growth.leadform.linkedin": "LinkedIn profile",
  "hq.growth.leadform.copy": "Prepared e-mail",
  "hq.growth.leadform.copy_sub": "optional · with an address it lands in the Queue as a draft, verbatim",
  "hq.growth.leadform.subject": "Subject",
  "hq.growth.leadform.subject_ph": "For Lisa — owner acquisition, finally made simple",
  "hq.growth.leadform.body": "Body",
  "hq.growth.leadform.body_help": "Plain text, exactly as it should go out. The walkthrough and the opt-out line are added on send.",
  "hq.growth.leadform.create": "Add lead",
  "hq.growth.leadform.created": "{name} added",
  "hq.growth.leadform.enriched": "{name} enriched",
  "hq.growth.leadform.err_name": "Give the company a name.",
  "hq.growth.leadform.err_email": "That does not look like an e-mail address.",
  "hq.growth.leadform.err_fit": "Fit is a number from 0 to 10.",
  "hq.growth.leadform.err_copy": "A prepared e-mail needs both a subject and a body.",
  "hq.growth.leadform.dup_title": "{name} is already in Prospects",
  "hq.growth.leadform.dup_open": "Open existing",
  "hq.growth.leadform.dup_merge": "Enrich existing",
  "hq.growth.leadform.dup_new": "Add anyway",

  /* ---- Ported from Flow branch 11: Stripe card-on-file + Help Center (P58) ---- */
  "bill.payment_sub": "How Listed collects what you owe. A card on file settles each invoice the moment it is issued.",
  "bill.payment_card_on_file_help": "Charged automatically when an invoice is issued. Replace it any time.",
  "bill.card_add": "Add card",
  "bill.card_replace": "Replace card",
  "bill.card_none": "No card on file",
  "bill.card_saved": "Card saved — invoices will be paid automatically.",
  "bill.card_removed": "Card removed. Invoices fall back to bank transfer.",
  "bill.card_remove_confirm": "Remove the card on file?",
  "bill.card_remove_confirm_sub": "Future invoices will have to be paid by bank transfer or with Pay now.",
  "bill.autopay": "Pay invoices automatically",
  "bill.autopay_help": "Off: we keep the card but you press Pay now on each invoice.",
  "bill.stripe_note": "Payments are processed by Stripe. Your card details never reach Listed.",
  "bill.card_not_enabled": "Not enabled yet",
  "bill.card_not_enabled_help": "Card payments are not switched on for this workspace yet. Invoices are settled by bank transfer until then.",
  "hqb.stripe_off": "Card payments off — set STRIPE_SECRET_KEY to enable",
  "hqb.stripe_test": "Stripe test mode — no real money moves",
  "bill.pay_now": "Pay now",
  "bill.paid_by_card": "Card",
  "bill.card_failed": "Card payment failed",
  "bill.stripe_cancelled": "No changes were made.",
  "bill.stripe_pending": "Still confirming with the bank — refresh in a moment.",
  "bill.invoice_paid_ok": "Invoice paid. Thank you!",
  "hqb.charge_card": "Charge card on file",
  "hqb.card_autopay": "Card · autopay",
  "hqb.card_manual": "Card on file",
  "hqb.charged_ok": "Card charged — invoice paid.",
  "nav.help": "Help Center",
  "cmd.group.help": "Help",
  "help.title": "Help Center",
  "help.sub": "How Listed works, written for property managers — with the exact buttons and settings to press.",
  "help.search_ph": "Search the manual or ask a question…",
  "help.ask": "Ask Listed",
  "help.ask_instead": "Ask Listed instead →",
  "help.ask_disclaimer": "Answered from the manual only. Double-check anything that affects owners or money.",
  "help.low_confidence": "not sure — check the sources",
  "help.no_results": "No article matches that.",
  "help.start_here": "Start here",
  "help.start_here_sub": "Five articles, twenty minutes, the whole picture.",
  "help.browse": "Browse by topic",
  "help.stuck": "Still stuck?",
  "help.stuck_sub": "Open a support case — we answer inside Listed and by e-mail.",
  "help.open_case": "Open a support case",
  "help.shortcuts_sub": "Search, jump and create without the mouse.",
  "help.related": "Related",
  "help.minutes": "{n} min read",
  "help.missing": "That article does not exist (yet).",
  "help.back": "Back to the Help Center",
  "help.tip": "Tip",
  "help.note": "Good to know",
  "help.owner_sees": "What the owner sees",
  "help.helpful_q": "Was this helpful?",
  "help.feedback_done": "Thanks — noted.",
  "help.thanks": "Thanks for the feedback",
  "help.about_this_page": "About this page",
  "help.open_full": "Open Help Center",
  "help.how_this_works": "How this works",
  "help.ask_about": "Ask about this",
  "help.ask_ph": "Ask a question about this page…",
  "common.view_all": "View all",
};
